const messages = {
  'app.pages.versions.excludeArchived': 'Exclude archived',
  'app.pages.applications.openingOptions': 'Opening options',
  'app.pages.applications.readOnly': 'Read-only',
  'app.pages.versions.openInNewInstance': 'Open in new instance',
  'app.pages.versions.openInNewInstanceHelp':
    'Starts a separate process from open sessions. Uses additional resources.',
  'app.pages.versions.searchVersions': 'Search versions',
  'app.pages.applications.openWithOptions': 'Open with options…',
  'app.pages.applications.recommended': 'Recommended',
  'app.pages.applications.useDefaultConfiguration': 'Use default configuration',
  'app.pages.applications.recommendedResources': 'Resource options',
  'app.pages.applications.recommendedResourcesHelp':
    'Only these resources will be offered when opening with options. Leave empty to offer all resources.',
  'app.pages.applications.recommendedResourcesUnavailable':
    'No allowed resource is available. The application will open with the default configuration.',
  'app.pages.applications.resourcesLoadError':
    'Resources could not be loaded. The application can be opened with the default configuration or loading can be retried.',
  'app.pages.applications.resourceUnavailable': 'Unavailable',
  'app.pages.applications.retry': 'Try again',
  'common.code': 'Code',
  'common.diagram': 'Diagram',
  'common.preview': 'Preview',
  'common.result': 'Result',
  'common.shortcuts': 'Shortcuts',
  'common.app': 'App',
  'common.apps': 'Apps',
  'common.confirm': 'Confirm',
  'common.close': 'Close',
  'common.cancel': 'Cancel',
  'common.run': 'Run',
  'common.stop': 'Stop',
  'common.home': 'Home',
  'common.error': 'Error',
  'common.console': 'Console',
  'common.all': 'All',
  'common.allPlural': 'All',
  'common.apply': 'Apply',
  'common.noResultsFound': 'No results found',
  'common.options': 'Options',
  'common.goToNode': 'Go to node',
  'common.goToInterface': 'Go to interface',
  'common.goToModule': 'Go to module',
  'common.goToApplicationFiles': 'Go to application files',
  'common.goToVersionFiles': 'Go to version files',
  'common.top': 'Top',
  'common.bottom': 'Bottom',
  'common.left': 'Left',
  'common.right': 'Right',
  'common.default': 'Default',
  'common.custom': 'Custom',
  'common.none': 'None',
  'common.interface': 'Interface',
  'common.text': 'Text',
  'common.true': 'True',
  'common.false': 'False',
  'common.hide': 'Hide',
  'common.show': 'Show',
  'common.position': 'Position',
  'common.inside': 'Inside',
  'common.outside': 'Outside',
  'common.running': 'Running',
  'common.general': 'General',
  'common.value': 'Value',
  'common.edit': 'Edit',
  'common.username': 'Username',
  'common.password': 'Password',
  'common.invalidPassword': 'Invalid password',
  'common.required': 'Required',
  'common.copy': 'Copy',
  'common.cut': 'Cut',
  'common.pasteBelow': 'Paste below',
  'common.about': 'About',
  'common.documentation': 'Documentation',
  'common.addDocumentation': 'Add documentation',
  'common.editDocumentation': 'Edit documentation',
  'common.hasDocumentation': 'Has documentation',
  'common.documentationUpdated': 'Documentation updated successfully',
  'common.help': 'Help',
  'common.from': 'From',
  'common.to': 'To',
  'common.color': 'Color',
  'common.values': 'Values',
  'common.applyTo': 'Apply to',
  'common.save': 'Save',
  'common.paste': 'Paste',
  'common.total': 'Total',
  'common.totals': 'Totals',
  'common.row': 'Row',
  'common.rows': 'Rows',
  'common.column': 'Column',
  'common.columns': 'Columns',
  'common.measures': 'Measures',
  'common.labels': 'Labels',
  'common.read': 'Read',
  'common.properties': 'Properties',
  'common.selectInterface': 'Select interface',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.table': 'Table',
  'common.tables': 'Tables',
  'common.cube': 'Cube',
  'common.discard': 'Discard',
  'common.settings': 'Settings',
  'common.resetView': 'Reset view',
  'common.viewError': 'View error',
  'common.reloadComponent': 'Reload component',
  'common.fields': 'Fields',
  'common.delete': 'Delete',
  'common.add': 'Add',
  'common.information': 'Information',
  'common.openApp': 'Open app',
  'common.openAppInNewInstance': 'Open app in new instance',
  'common.description': 'Description',
  'common.version': 'Version',
  'common.versions': 'Versions',
  'common.screenshots': 'Screenshots',
  'common.showInstallationLogs': 'Show installation logs',
  'common.hideInstallationLogs': 'Hide installation logs',
  'common.noResults': 'No results',
  'common.conditionFormatType': 'Condition type',
  'common.loadingAppVersion': 'Loading app version',
  'common.loadingTextEditor': 'Loading text editor..',
  'common.creatingAppVersion': 'Creating app version',
  'common.notAllowedCharacters':
    'The text contains one or more characters that are not allowed. Please remove the following characters: / \\ : * ? ',
  'common.status': 'Status',
  'common.activate': 'Activate',
  'common.archive': 'Archive',
  'common.unarchive': 'Unarchive',
  'common.invalidCharactersMessage': 'The following characters are not allowed: {characters}',
  'common.import': 'Import',
  'common.export': 'Export',
  'common.scenarios': 'Scenarios',
  'common.selectANode': 'Select a node',
  'common.selectedNode': 'Selected node',
  'common.deleteAll': 'Delete all',
  'common.creator': 'Creator',
  'common.scenario': 'Scenario',
  'common.validating': 'Validating',
  'common.selectedNode.incorrect': 'The selected node is incorrect. Please select another node.',
  'common.max': 'Max',
  'common.min': 'Min',
  'common.internalTests': 'Internal tests',
  'common.used': 'Used',
  'common.generalSettings': 'General settings',
  'common.clipboard': 'Clipboard',
  'common.clipboard.clear': 'Clear clipboard',
  'common.apiKeysManager': 'API keys manager',
  'common.user': 'User',
  'common.items': 'Items',
  'common.assistant': 'Assistant',
  'common.assistants': 'Assistants',
  'common.sources': 'Sources',
  'common.team': 'Team',
  'common.appConsolidation': 'Consolidation',
  'common.changes': 'Changes',
  'common.destination': 'Destination',
  'common.new': 'New',
  'common.old': 'Old',
  'common.definition': 'Definition',
  'common.nodes': 'Nodes',
  'common.appManagement': 'App management',
  'common.modules': 'Modules',
  'common.maximize': 'Maximize',
  'common.minimize': 'Minimize',
  'common.areYouSureYouWantToProceed': 'Are you sure you want to proceed?',
  'common.load': 'Load',
  'common.colors': 'Colors',
  'common.component': 'Component',
  'common.source': 'Source',
  'common.string': 'String',
  'common.integer': 'Integer',
  'common.float': 'Float',
  'common.boolean': 'Boolean',
  'common.date': 'Date',
  'common.datetime': 'Datetime',
  'common.extraSettings': 'Extra settings',
  'common.apiKeys': 'API keys',
  'common.applicationEnvironment': 'Application environment',
  'common.moduleRestrictions': 'Module restrictions',
  'common.workflowProcesses': 'Workflow processes',
  'common.lostMessage': 'will be lost.',
  'common.attemptingReconnectServer': 'Attempting to reconnect to the server, please wait...',
  'common.connectionReestablished': 'Connection re-established',
  'common.order': 'Order',
  'common.nodeInterface': 'Node interface',
  'common.pleaseWait': 'Please wait...',
  'common.context': 'Context',
  'common.name': 'Name',
  'common.assistantBot': 'Assistant bot',
  'common.assistantBots': 'Assistant bots',
  'common.open': 'Open',
  'common.somethingWentWrong': 'Something went wrong',
  'common.details': 'Details',
  'common.reloadPage': 'Reload page',
  'common.titleAndId': 'Title + id',
  'common.expand': 'Expand',
  'common.seeMore': 'See more',
  'common.application': 'Application',
  'common.companyPreference': 'Company preferences',
  'common.externalLinks': 'External links',
  'common.instance': 'Instance',
  'common.instanceId': 'Instance ID',
  'common.logging': 'Logging',
  'common.modelManager': 'Model manager',
  'common.userCompany': 'User company',
  'common.forceRun': 'Force run',
  'common.scrollBottom': 'Scroll to bottom',
  'common.scrollTop': 'Scroll to top',
  'common.of': 'of',
  'common.tableCopied': 'Table copied',
  'common.copyId': 'Copy id',
  'common.refresh': 'Refresh',
  'common.invalidCharactersCompanyValidation':
    'Invalid characters. Only lowercase a-z, uppercase A-Z, 0 to 9 numbers, dashes and underscores are allowed',
  'common.invalidCharactersFilesAndFoldersValidation':
    'Invalid characters. Only lowercase a-z, uppercase A-Z, 0 to 9 numbers, dashes, underscores, "+", "%", "&" and "*" symbols are allowed',
  'common.invalidCharactersAppsVersionsScenariosValidation':
    'Invalid characters. Only lowercase a-z, uppercase A-Z, 0 to 9 numbers, dashes, underscores, parentheses, "+", "%", "&" and "*" symbols are allowed',
  'common.undo': 'Undo',
  'common.redo': 'Redo',
  'common.darkMode': 'Dark mode',
  'common.lightMode': 'Light mode',
  'common.copyTableToClipboard': 'Copy table to clipboard',
  'common.websocketsStatus': 'Websockets status',
  'common.connected': 'Connected',
  'common.disconnected': 'Disconnected',
  'common.persistenceType': 'Persistence type',
  'common.inDefinition': 'In definition',
  'common.inMemory': 'In memory',
  'common.onDisk': 'On disk',
  'common.persistencePath': 'Persistence path',
  'common.componentCodeError': "There was an error in the component's code",
  'common.resultError': 'Could not display the result of this component',
  'common.componentDefinitionError': "There was an error in the component's definition",
  'common.nodeResultError': 'Could not display the result of this node',
  'common.noPermissionToNavigate': 'You do not have permission to go to {path}',
  'common.addContext': 'Add context',
  'common.addAsContext': 'Add as context',
  'common.addComponent': 'Add component',
  'common.addComponentToAgentContext': 'Add component to agent context',
  'common.addNodeContextMessage': 'To add context, select and execute a node',
  'common.addComponentToContextMessage': 'Click on a component to add it as context',
  'common.selectComponentToContextMessage': 'Select a component as context',
  'common.sort': 'Sort',
  'common.ascending': 'Ascending',
  'common.descending': 'Descending',
  'common.preference': 'Preference',
  'common.insert': 'Insert',
  'common.searchBy': 'Search by',
  'common.searchFields': 'Search fields',
  'common.clear': 'Clear',
  'common.charts': 'Charts',
  'common.indicators': 'Indicators',
  'common.indexes': 'Indexes',

  copying_app_to_user_workspace: "Copying app to user's workspace",
  creating_environment: 'Creating environment',
  starting_environment: 'Starting environment',
  loading_workspace: 'Loading workspace',
  engine_created: 'Engine created',
  starting_pyplan_calc_engine: 'Starting calculation engine',
  opening_app: 'Opening App',
  cancel_opening_app: 'Cancel opening',
  canceling_app_opening: 'Canceling...',
  error_opening_app: 'An error occurred while opening the application',
  installing_requirements_file_libraries: 'Installing libraries from requirements.txt file',
  no_libraries_to_install: 'No libraries to install',
  processing_startup_nodes: 'Processing startup nodes',
  reading_app_properties: 'Reading application properties',
  reading_app_modules: 'Reading application modules',
  loading_interfaces: 'Loading interfaces',
  creating_nodes: 'Creating nodes',
  applying_migrations: 'Applying migrations',
  done: 'Done',
  may_take: 'This task may take up to 5 minutes. Please wait...',
  // TODO: return untranslated message from backend and use these two
  'common.checkingPythonLibrariesUsedInModel': 'Checking python libraries used in model',
  'common.librariesAlreadyInstalled': 'Libraries already installed',
  'common.resultsNotFound': 'Results not found, please search',
  need_logout: 'Logout required',
  need_logout_detail:
    'The administrator has requested to close the instance. Please save and close the instance as soon as possible',
  session_killed_detail: 'Logout required',
  session_killed: 'The administrator has closed your instance',
  instance_purged: 'Your instance has expired due to inactivity',
  instance_purged_detail: 'Close the instance',
  session_purged: 'Your session has expired due to inactivity',
  session_purged_detail: 'Login again',
  engine_down:
    'Your calculation engine has unexpectedly ended. Please close your current instance and start a new one',
  engine_down_detail: 'Close instance',
  error_installing_libs_from_requirements: 'Error installing libraries from requirements.txt file',
  error_creating_new_version: 'Error creating new version',
  error_version_name_already_exists: 'Version name chosen already exists',
  app_recovered_from_backup: 'Application recovered from backup',
  indexing_documents: 'Indexing documents',
  recovered_existing_instance: 'The application was retrieved from an existing instance.',
  app_closed_in_another_tab: 'The application was closed in another tab.',
  app_closed_by_agent: 'The agent closed the application.',
  'app.agentLive.anAgent': 'An agent',
  'app.agentLive.working': '{name} is working on this app',
  'app.agentLive.follow': 'Follow the agent',
  'app.agentLive.status': 'Working on this app through MCP',
  'app.agentLive.tooltip':
    '{name} is working on this app through MCP. You see its changes here as it makes them. Click to choose whether the screen follows it.',
  'app.agentLive.followHelp':
    'Take me to the nodes and interfaces it edits. Not while you have unconfirmed changes.',
  'app.agentLive.nodeCreated': 'The agent created a node',
  'app.agentLive.nodeUpdated': 'The agent modified a node',
  'app.agentLive.nodesMoved': 'The agent moved nodes in a module',
  'app.agentLive.interfaceChangedWhileEditing':
    'The agent changed this interface while you edit it',
  'app.agentLive.viewCaptured': 'The agent took a picture of your screen to check its work',
  'app.agentLive.interfaceChangedWhileEditingDetail':
    "It was not refreshed, so your edits are kept. Saving them replaces the agent's changes.",
  'app.agentLive.nodesDeleted': 'The agent deleted nodes in a module',
  'app.agentLive.interfaceCreated': 'The agent created an interface',
  'app.agentLive.interfaceUpdated': 'The agent modified an interface',
  session_closed_in_another_tab: 'The session was closed in another tab.',
  indexing_app_elements: 'Indexing app elements',
  uploading_app_documentation: 'Uploading app documentation',

  //home
  'app.components.HomePage.header': 'Home page',
  //notifier
  'common.notifier.dismissSnackbar': 'Dismiss',
  'common.notifier.readMore': 'Read more',

  //Initial configuration
  'app.pages.initialConfig.initialSetUp': 'Initial Setup',
  'app.pages.initialConfig.internalTesting': 'Internal testing',
  'app.pages.initialConfig.finish': 'Finish',
  'app.pages.initialConfig.initialConfig': 'Please enter the company name',
  'app.pages.initialConfig.userAdminInfo': 'Enter company administrator user information',
  'app.pages.initialConfig.copyKey':
    'Copy the activation code and send it to the system administrator to generate the license code',
  'app.pages.initialConfig.finishMessage': 'Initial setup completed successfully',
  'app.pages.initialConfig.licenseSuccess': 'License successfully created',

  // Internal tests
  'app.pages.internalTests.runTests': 'Run tests',
  'app.pages.internalTests.deleteApp': 'Delete Application',
  'app.pages.internalTests.createPublicFolder': 'Create public folder',
  'app.pages.internalTests.removePublicFolder': 'Remove public folder',
  'app.pages.internalTests.systemResources': 'System resources',

  //cards
  'app.components.cards.instanceCard.openAgo': 'Open {number} mins ago',
  'app.components.cards.instanceCard.currentInstance': 'Current instance',
  'app.components.cards.instanceCard.activeAgo': 'Active {number} mins ago',
  'app.components.cards.instanceCard.deleteInstance': 'Delete instance',
  'app.components.cards.instanceCard.selectInstance': 'Select instance',
  'app.components.cards.instanceCard.changeInstance':
    'Change to this instance:{br}- Name: {title}{br}- Version: {version}{br}- Path: {modelPath}',
  'app.components.cards.instanceCard.currentInstanceTooltip':
    '- Name: {title}{br}- Version: {version}{br}- Path: {modelPath}',

  //login
  'app.pages.login.init': 'Init',
  'app.pages.login.usernameLabel': 'Username',
  'app.pages.login.passwordLabel': 'Password',
  'app.pages.login.forgotPassword': 'Forgot password?',
  'app.pages.login.sendInstructions': 'Send Instructions',
  'app.pages.login.login': 'Log In',
  'app.pages.login.connectWithSocialMedia': 'Connect with social media',
  'app.pages.login.connectWithApp': 'Connect with {app}',
  'app.pages.login.or': 'or',
  'app.pages.login.orContinueWith': 'Or continue with:',
  'app.pages.login.SSOTo': 'SSO to {company}',
  'app.pages.login.createAnAccount': 'Create an account',
  'app.pages.login.copyright': 'Copyright © Pyplan {year}.',
  'app.pages.login.selectCompany': 'Select a company',
  'app.pages.login.licenseInfo': 'License information',
  'app.pages.login.invalidLicense': 'Invalid license',
  'app.pages.login.carousel.previous': 'Previous',
  'app.pages.login.carousel.next': 'Next',
  'app.pages.login.carousel.viewMore': 'View more',
  'app.pages.login.carousel.userPasswordExpired':
    'Your user password has expired! Please choose a new one to keep your account secure.',
  'app.pages.login.carousel.userPasswordRepeated':
    'New password must be different from current password.',
  'app.pages.login.rememberMe': 'Remember me',
  'app.pages.login.resetPasswordMessage':
    "If an account exists for this username, you'll receive an email with instructions to reset your password.",
  'app.pages.login.resetPassword': 'Reset password',
  'app.pages.login.passwordChangedSuccessfully': 'Password changed successfully',
  'app.pages.login.invalidToken': 'The token is invalid',
  'app.pages.login.multiFactorAuthentication': 'Multi-factor authentication',
  'app.pages.login.scanQrCode':
    'Enhance the security of your account by downloading a Two-Factor Authentication (2FA) app, such as Google Authenticator or Microsoft Authenticator, on your mobile device. Scan the QR code below using the app to generate unique verification codes whenever you log in.',
  'app.pages.login.enterCode': 'Enter the code generated by your Authenticator app',
  'app.pages.login.enterCodePlaceholder': 'Enter the code',
  'app.pages.login.enterCodeError': 'The code is invalid',
  'app.pages.login.enterCodeSuccess': 'Multi-factor authentication enabled successfully',
  'app.pages.login.verify': 'Verify',
  'app.pages.login.cantUseAuthAppNow': 'I can’t use my authenticator app right now.',
  'app.pages.login.sendCodeToEmail':
    'We have sent the verification code to your email inbox {userSecretMail}. Please enter the code to proceed.',
  'app.pages.login.loadingInstanceData': 'Loading instance data',
  'app.pages.login.deleteSSOTo': 'Delete "SSO to {company}" link',
  'app.pages.login.invalidCredentials': 'Unable to log in with provided credentials.',
  'app.pages.login.accountDisabled': 'User account is disabled. Please contact your administrator.',
  'app.pages.login.invalidInput': "Must include 'username' and 'password'.",
  'app.pages.login.directAccessCompanyDenied':
    'Your account does not have access to company {company}.',
  'app.pages.login.privacyMessage': 'By signing in, you agree to the',
  'app.pages.login.termsOfService': 'Terms of service',
  'app.pages.login.privacyPolicy': 'Privacy policy',

  //topbar
  'app.pages.app.topbar.notifications': 'Notifications',
  'app.pages.app.topbar.showMore': 'Show more',
  'app.pages.app.topbar.showNotifications': 'Show notifications',
  'app.pages.app.topbar.showErrors': 'Show errors',
  'app.pages.app.topbar.defaultInterface': 'Default interface',
  'app.pages.app.topbar.summary': 'Summary',
  'app.pages.app.topbar.manageLibs': 'Libraries',
  'app.pages.app.topbar.reloadApp': 'Reload app',
  'app.pages.app.topbar.createNew.app': 'App',
  'app.pages.app.topbar.layout.diagram': 'Result',
  'app.pages.app.topbar.layout.preview': 'Code+Preview',
  'app.pages.app.topbar.layout.result': 'Code+Result',
  'app.pages.app.topbar.saveAs': 'Save as',
  'app.pages.app.topbar.saveAsNewVersion': 'Save as new version',
  'app.pages.app.topbar.saveApplicationInMyWorkspace': 'Save application in my workspace',
  'app.pages.app.topbar.saveApplicationInTeam': 'Save application in my team',
  'app.pages.app.topbar.claimWriteMode': 'Claim write mode',
  'app.pages.app.topbar.writeModeClaimed': 'You can now save your changes',
  'app.pages.app.topbar.appName': 'App name',
  'app.pages.app.topbar.appNameValidationError':
    "App name can't contain the following characters: ",
  'app.pages.app.topbar.selectAppVersionsToCopy': 'Select app versions to copy',
  'app.pages.app.topbar.copiesAllAppVersionMessage':
    'All versions will be copied when none are selected',
  'app.pages.app.topbar.logout': 'Log out',
  'app.pages.app.topbar.libsManager.uninstalled': 'The library has been uninstalled successfully',
  'app.pages.app.topbar.libsManager.version': 'Version',
  'app.pages.app.topbar.libsManager.refresh': 'Refresh',
  'app.pages.app.topbar.libsManager.location': 'Location',
  'app.pages.app.topbar.libsManager.actions': 'Actions',
  'app.pages.app.topbar.libsManager.installedLibraries': 'Installed libraries',
  'app.pages.app.topbar.libsManager.install': 'Install',
  'app.pages.app.topbar.libsManager.appRequirements': 'App requirements',
  'app.pages.app.topbar.libsManager.saveFileInstallLibraries': 'Save file and install libraries',
  'app.pages.app.topbar.libsManager.saveInstallLibraries': 'Save and install',
  'app.pages.app.topbar.libsManager.requirementsFile': 'requirements.txt file',
  'app.pages.app.topbar.libsManager.pipInstallError': 'Whitespaces are not allowed',
  'app.pages.app.topbar.libsManager.systemLib': 'system lib',
  'app.pages.app.topbar.libsManager.userLib': 'user lib',
  'app.pages.app.topbar.libsManager.filter': 'Filter',
  'app.pages.app.topbar.libsManager.libraries': 'Libraries',
  'app.pages.app.topbar.showConsole': 'Show console',
  'app.pages.app.topbar.showPinnedNodes': 'Show pinned nodes',
  'app.pages.app.topbar.hidePinnedNodes': 'Hide pinned nodes',
  'app.pages.app.topbar.closeConsole': 'Close console',
  'app.pages.app.topbar.appProperties': 'Properties',
  'app.pages.app.topbar.appPropertiesUpdatedSuccessfully': 'App properties updated successfully',
  'app.pages.app.topbar.deparmentsError':
    'There is an interface without departments.Please select a department.',
  'app.pages.app.topbar.deparmentRepeated':
    'The department {name} already has an interface defined',
  'app.pages.app.topbar.allDeps': 'All',
  'app.pages.app.topbar.selecteDefaultInterface':
    'Select the default interface for the application',
  'app.pages.app.topbar.libsManager.cantInstallHead':
    'You are using a shared library environment. Pyplan needs to generate a unique environment for you to add/remove libraries (this task may take a few minutes).',
  'app.pages.app.topbar.libsManager.cantInstallTasksHead':
    'To do this, the following tasks will be performed:',
  'app.pages.app.topbar.libsManager.cantInstallTask1': 'the current application will be saved',
  'app.pages.app.topbar.libsManager.cantInstallTask2': 'a new unique environment will be generated',
  'app.pages.app.topbar.libsManager.cantInstallTask3':
    'the application will be opened again with the unique environment',
  'app.pages.app.topbar.libsManager.cantInstallConfirmationMessage':
    'Are you sure you want to perform these tasks?',
  'app.pages.app.topbar.libsManager.cantInstallButtonText': 'Yes, perform these tasks',
  'app.pages.app.topbar.changeAppVersion': 'Change app version',
  'app.pages.app.topbar.changeVersion': 'Change version',
  'app.pages.app.topbar.takeScreenshot': 'Take screenshot',
  'app.pages.app.topbar.goToAppFolder': 'Go to application folder',
  'app.pages.app.topbar.screenshotResult': 'Screenshot result',
  'app.pages.app.topbar.downloadScreenshot': 'Download screenshot',
  'app.pages.app.topbar.saveImageAsAppThumbnail': 'Save image as app thumbnail',
  'app.pages.app.topbar.appIdError':
    'The app ID may only contain numbers, letters, hyphens and must be more than 7 characters long',
  'app.pages.app.topbar.mustRestartAppWarning':
    'To make the changes take effect, you must restart the application.',
  'app.pages.app.topbar.allDataRelatedTo': 'All data related to:',
  'app.pages.app.topbar.additionalInformation': 'Additional information',
  'app.pages.app.topbar.nodesEvaluatedMessage': 'Nodes evaluated when the app is opened',
  'app.pages.app.topbar.noNodesEvaluated':
    'There are no nodes that are evaluated when the application is opened',
  'app.pages.app.topbar.defaultSettings': 'Default settings',
  'app.pages.app.topbar.componentHeaderBackgroundColor':
    'Component header background color - tables, charts, indicators, forms',
  'app.pages.app.topbar.componentHeaderTextColor':
    'Component header text color - tables, charts, indicators, forms',
  'app.pages.app.topbar.commonHeaderBackgroundColor':
    'Component header background color - indices, selectors',
  'app.pages.app.topbar.commonHeaderColor': 'Component header text color - indices, selectors',
  'app.pages.app.topbar.libsManager.creatingEnvironmentSuccess': 'Environment created',
  'app.pages.app.topbar.showColumnFilterIcon': 'Show column filter icon',
  'app.pages.app.topbar.showIndex': 'Show index',
  'app.pages.app.topbar.defaultStylesComponentHeaderColorsSection': 'Component header colors',
  'app.pages.app.topbar.defaultStylesTableOptionsSection': 'Table options',
  'app.pages.app.topbar.defaultStylesChartOptionsSection': 'Chart options',
  'app.pages.app.topbar.defaultStylesFormatsSection': 'Default formats',
  'app.pages.app.topbar.dateFormatLabel': 'Dates format',
  'app.pages.app.topbar.dateTimeFormatLabel': 'Datetime format',
  'app.pages.app.topbar.indexFormatLabel': 'Indices format',
  'app.pages.app.topbar.selectorFormatLabel': 'Selectors format',
  'app.pages.app.topbar.defaultStylesFormPropertiesSection': 'Form settings',
  'app.pages.app.topbar.buildAutomaticDateHierarchies': 'Build automatic date hierarchies',
  'app.pages.app.topbar.scenarioFillMissingWithZero': 'Fill missing values with zero',
  'app.pages.app.topbar.scenarioZeroDivisionReturnsZero': 'Zero division returns zero',
  'app.pages.app.topbar.fontFamily': 'Font family',
  'app.pages.app.topbar.tableNonEditableCellBackgroundColor': 'Non-editable cell background color',
  'app.pages.app.topbar.tableNonEditableCellColor': 'Non-editable cell text color',
  'app.pages.app.topbar.tableEditableCellBackgroundColor': 'Editable cell background color',
  'app.pages.app.topbar.tableEditableCellColor': 'Editable cell text color',
  'app.pages.app.topbar.tableLabelsBackgroundColor': 'Labels background color',
  'app.pages.app.topbar.tableLabelsColor': 'Labels text color',
  'app.pages.app.topbar.tableColorsLightTheme': 'Light theme',
  'app.pages.app.topbar.tableColorsDarkTheme': 'Dark theme',
  'app.pages.app.topbar.chartColorPalettes': 'Color palettes',

  //Info menu dialog:
  'app.pages.app.closeApp': 'Close App',
  'app.pages.app.closedSuccessfully': 'Application closed successfully',
  'app.pages.app.reloadSuccessfully': 'Application successfully reloaded',
  'app.pages.app.saveSuccessfully': 'Application saved successfully',
  'app.pages.app.appNewPath': 'The app was saved in: ',
  'app.pages.app.saveApp': 'Save app',
  'app.pages.app.newModelName': 'New model name',
  'app.pages.app.newModelNamePlaceholder': 'Insert new model name',
  'app.pages.app.unconfirmedNodes': 'Unconfirmed nodes',
  'app.pages.app.saveDefinitionsAndApp': 'Confirm definitions and save app',
  'app.pages.app.discardDefinitionsAndSaveApp': 'Discard definitions and save app',
  'app.pages.app.unconfirmedNodesAlert':
    'There are {number} nodes with unconfirmed definitions. What would you like to do?',
  'app.pages.app.lostDataAlert': 'Unsaved application data will be lost. Are you sure?',
  'app.pages.app.unsavedChanges': 'You have unsaved changes. What would you like to do?',
  'app.pages.app.saveChangesAndOpenApp': 'Save changes and open app',
  'app.pages.app.discardChangesAndOpenApp': 'Discard changes and open app',
  'app.pages.app.saveChangesAndCreateApp': 'Save changes and create app',
  'app.pages.app.discardChangesAndCreateApp': 'Discard changes and create app',
  'app.pages.app.saveChangesAndLogout': 'Save changes and logout',
  'app.pages.app.saveChangesAndReload': 'Save changes and reload app',
  'app.pages.app.saveChangesAndCloseApp': 'Save changes and close app',

  //sidebarMenu
  'app.pages.app.sidebarMenu.fileManager': 'File manager',
  'app.pages.app.sidebarMenu.code': 'Code',
  'app.pages.app.sidebarMenu.interfaces': 'Interfaces',
  'app.pages.app.sidebarMenu.tools': 'Tools',
  'app.pages.app.sidebarMenu.aiManagement': 'AI Management',
  'app.pages.app.sidebarMenu.scheduledTasks': 'Scheduled tasks',
  'app.pages.app.sidebarMenu.myAccount': 'My account',
  'app.pages.app.sidebarMenu.settings': 'Settings',
  'app.pages.app.sidebarMenu.securityOptions': 'Security options',
  'app.pages.app.sidebarMenu.users': 'Users',
  'app.pages.app.sidebarMenu.departments': 'Departments',
  'app.pages.app.sidebarMenu.teams': 'Teams',
  'app.pages.app.sidebarMenu.instance': 'Instance manager',
  'app.pages.app.sidebarMenu.permissionByRole': 'Permissions by role',
  'app.pages.app.sidebarMenu.applications': 'Applications',
  'app.pages.app.sidebarMenu.processManager': 'Processes',
  'app.pages.app.sidebarMenu.home': 'Home',
  'app.pages.app.sidebarMenu.numberLocale': 'Number format',
  'app.pages.app.sidebarMenu.language': 'Language',
  'app.pages.app.sidebarMenu.applicationAnalysis': 'Analysis',
  'app.pages.app.sidebarMenu.connections': 'Connections',
  'app.pages.app.sidebarMenu.applicationTests': 'Application tests',
  'app.pages.app.sidebarMenu.support': 'Support',
  'app.pages.app.sidebarMenu.supportNewTicket': 'Create ticket',
  'app.pages.app.sidebarMenu.supportMyTickets': 'My tickets',
  'app.pages.support.errors.tabBlocked':
    'Your browser blocked the Pyplan Support tab. Allow pop-ups for this site and try again.',
  'app.pages.support.errors.timeout': 'Pyplan took too long to open Pyplan Support. Try again.',
  'app.pages.support.errors.network':
    'Could not connect to Pyplan to open Pyplan Support. Check your connection and try again.',
  'app.pages.support.errors.invalidResponse':
    'Pyplan Support could not be opened because Pyplan sent an unexpected response. Try again.',
  'app.pages.support.errors.notEnabled': 'Pyplan Support is not enabled for your company.',
  'app.pages.support.errors.emailRequired':
    'Your user needs a valid email address to open Pyplan Support. Ask your administrator to add it.',
  'app.pages.support.errors.sessionExpired':
    'Your session can no longer open Pyplan Support. Sign in again and try again.',
  'app.pages.support.errors.unavailable':
    'Pyplan Support could not be opened (error {status}). Try again later.',

  //home
  'app.pages.app.home.myPyplan': 'My Pyplan',
  'app.pages.app.home.openApps': 'Open apps',
  'app.pages.app.home.workspaces': 'Workspaces',
  'app.pages.app.home.folders': 'Folders',
  'app.pages.app.home.instanceKilledSuccessfully': 'Instance killed successfully',
  'app.pages.app.home.instanceChangedSuccessfully': 'Instance changed successfully',
  //home.pyplanResources
  'app.pages.app.home.pyplanResources': 'Pyplan resources',
  'app.pages.app.home.pyplanResources.videos': 'Videos',
  'app.pages.app.home.pyplanResources.videosCaption': 'Watch Pyplan in action',
  'app.pages.app.home.pyplanResources.documentation': 'Documentation',
  'app.pages.app.home.pyplanResources.documentationCaption': 'Basic steps',
  'app.pages.app.home.pyplanResources.examples': 'Examples',
  'app.pages.app.home.pyplanResources.examplesCaption': 'Applications',
  //home.shortcutsPanel
  'app.pages.app.home.shortcutsPanel.tutorials': 'Tutorials',
  'app.pages.app.home.shortcutsPanel.examples': 'Examples',
  'app.pages.app.home.shortcutsPanel.demos': 'Demos',
  'app.pages.app.home.shortcutsPanel.models': 'Models',
  'app.pages.app.home.shortcutsPanel.noModelFound':
    'No models were open recently. Create a new model or explore your files',
  'app.pages.app.home.shortcutsPanel.noExamplesFound': 'No examples found',
  'app.pages.app.home.shortcutsPanel.my_apps': 'My apps',
  'app.pages.app.home.shortcutsPanel.public_apps': 'Public apps',
  'app.pages.app.home.shortcutsPanel.recently_opened': 'Recently opened',
  'app.pages.app.home.shortcutsPanel.noPermissionsToViewApps':
    'You do not have permissions to view applications. Please, contact an administrator.',

  //editProfile
  'app.pages.editProfile.editProfile': 'Profile',
  'app.pages.editProfile.changePasswordAlert':
    'If you change your password your instance will be closed and you would need to log in again',
  'app.pages.editProfile.currentPassword': 'Current password',
  'app.pages.editProfile.currentPasswordIncorrect': 'Current password is incorrect',
  //my account
  'app.pages.myAccount.title': 'My account',
  'app.pages.myAccount.preferences': 'Preferences',
  'app.pages.myAccount.accessTokens': 'Access tokens',
  'app.pages.accessTokens.title': 'Personal access tokens',
  'app.pages.accessTokens.description':
    'Personal access tokens let headless clients (Claude Code, scripts, other MCP clients) and API integrations authenticate as you with a static bearer token, replacing the interactive login. Treat them like passwords.',
  'app.pages.accessTokens.create': 'Create token',
  'app.pages.accessTokens.name': 'Name',
  'app.pages.accessTokens.defaultCompany': 'Default company',
  'app.pages.accessTokens.defaultCompanyHelp':
    'Session starts in this company; the assistant can switch later.',
  'app.pages.accessTokens.expiration': 'Expiration',
  'app.pages.accessTokens.expiresInDays': '{days} days',
  'app.pages.accessTokens.createdAt': 'Created',
  'app.pages.accessTokens.expiresAt': 'Expires',
  'app.pages.accessTokens.lastUsed': 'Last used',
  'app.pages.accessTokens.status': 'Status',
  'app.pages.accessTokens.active': 'Active',
  'app.pages.accessTokens.expired': 'Expired',
  'app.pages.accessTokens.revoked': 'Revoked',
  'app.pages.accessTokens.revoke': 'Revoke',
  'app.pages.accessTokens.revokeConfirm': 'Revoke this token? Clients using it will stop working.',
  'app.pages.accessTokens.copyWarning': "Copy this token now — it won't be shown again.",
  'app.pages.accessTokens.copy': 'Copy',
  'app.pages.accessTokens.copied': 'Copied',
  'app.pages.accessTokens.empty': "You don't have any access tokens yet.",
  'app.pages.accessTokens.descriptionForAgent':
    'Access tokens let this agent authenticate from headless clients (Claude Code, scripts, other MCP clients) with a static bearer token. The agent cannot sign in, so its tokens are managed here. Treat them like passwords.',
  'app.pages.accessTokens.emptyForAgent': 'This agent has no access tokens yet.',
  'app.pages.accessTokens.nameRequired': 'Name is required',
  'app.pages.accessTokens.createError': 'The token could not be created. Please try again.',
  //scim tokens (company manager)
  'app.pages.scimTokens.title': 'SCIM tokens',
  'app.pages.scimTokens.create': 'Create token',
  'app.pages.scimTokens.name': 'Name',
  'app.pages.scimTokens.company': 'Company',
  'app.pages.scimTokens.prefix': 'Prefix',
  'app.pages.scimTokens.createdAt': 'Created',
  'app.pages.scimTokens.expiresAt': 'Expires',
  'app.pages.scimTokens.lastUsedAt': 'Last used',
  'app.pages.scimTokens.status': 'Status',
  'app.pages.scimTokens.active': 'Active',
  'app.pages.scimTokens.expired': 'Expired',
  'app.pages.scimTokens.revoked': 'Revoked',
  'app.pages.scimTokens.revoke': 'Revoke',
  'app.pages.scimTokens.revokeConfirm':
    'Revoke this token? Entra ID will stop being able to use it.',
  'app.pages.scimTokens.copy': 'Copy',
  'app.pages.scimTokens.copied': 'Copied',
  'app.pages.scimTokens.copyWarning': "Copy this token now — it won't be shown again.",
  'app.pages.scimTokens.empty': 'This company has no SCIM tokens yet.',
  'app.pages.scimTokens.nameRequired': 'Name is required',
  'app.pages.scimTokens.noExpiration': 'No expiration',
  'app.pages.scimTokens.createError': 'The token could not be created. Please try again.',
  'app.pages.scimTokens.tabSecretToken': 'Secret Token',
  'app.pages.scimTokens.tabOAuth2': 'OAuth 2.0',
  'app.pages.scimTokens.oauth2Create': 'Create client',
  'app.pages.scimTokens.oauth2Help':
    "The Token Endpoint to enter in Entra is this server's /api/oauth2/token.",
  'app.pages.scimTokens.oauth2ClientId': 'Client ID',
  'app.pages.scimTokens.oauth2ClientSecret': 'Client Secret',
  'app.pages.scimTokens.oauth2CopyWarning': "Copy the Client Secret now — it won't be shown again.",
  'app.pages.scimTokens.oauth2Empty': 'This company has no OAuth2 clients yet.',
  'app.pages.myAccount.personalData': 'Personal data',
  'app.pages.myAccount.formatAndLanguage': 'Format and language',
  'app.pages.myAccount.theme': 'Theme',

  //managers
  'app.pages.app.managers.firstPage': 'First page',
  'app.pages.app.managers.prevPage': 'Prev. page',
  'app.pages.app.managers.nextPage': 'Next page',
  'app.pages.app.managers.lastPage': 'Last page',
  'app.pages.app.managers.cancel': 'Cancel',
  'app.pages.app.managers.create': 'Create',
  'app.pages.app.managers.update': 'Update',
  'app.pages.app.managers.search': 'Search',
  'app.pages.app.managers.searchHelperText': 'Please add at least 3 characters',
  'app.pages.app.managers.companyManager': 'Company manager',
  'app.pages.app.managers.folder': 'Folder',
  'app.pages.app.managers.departmentManager': 'Department manager',
  'app.pages.app.managers.rowsPerPage': 'Rows per page',
  'app.pages.app.managers.company': 'Company',
  'app.pages.app.managers.company.companies': 'Companies',
  'common.name.isRequired': 'Name is required',
  'app.pages.app.managers.company.notFound': 'Company not found',
  'app.pages.app.managers.company.placeholder': 'Please select a company',
  'app.pages.app.managers.company.isRequired': 'Company is required',
  'app.pages.app.managers.roleManager': 'Role manager',
  'app.pages.managers.invalidJSON': 'It is not a valid JSON',
  'app.pages.managers.actions': 'Actions',
  'app.pages.managers.departments': 'Departments',
  'app.components.departmentSelector.searchPlaceholder': 'Type to search departments...',
  'app.pages.managers.mainDepartment': 'Main department',
  'app.pages.managers.add': 'Add',
  'app.pages.managers.role': 'Role',
  'app.pages.managers.roles': 'Roles',
  'app.pages.app.managers.back': 'Back',
  'app.pages.app.managers.unkwownStep': 'Unknown step',
  'app.pages.app.managers.saveButton': 'Save',
  'app.pages.app.managers.nextButton': 'Next',
  'app.pages.app.managers.companies': 'Companies',
  'app.pages.managers.password': 'Password',
  'app.pages.managers.newPassword': 'New password',
  'app.pages.managers.confirmPassword': 'Confirm password',
  'app.pages.managers.passwordIsRequired': 'Password is required',
  'app.pages.managers.ConfirmPasswordIsRequired': 'Password confirmation required',
  'app.pages.managers.passwordMinLength':
    'Password is too short - should be {number} chars minimum',
  'app.pages.managers.passwordInvalidRequisites':
    'Password must have at least one uppercase, one lowercase, one number and one special character',
  'app.pages.managers.passwordsNotMatch': 'Passwords do not match',
  'app.pages.managers.send': 'Send',
  'app.pages.app.managers.delete': 'Delete',
  'app.pages.app.managers.createAppFromThis': 'Create app from this',
  'app.pages.app.managers.applicationSuccessfullyCreated': 'Successfully created application in',
  'app.pages.app.managers.newFolder': 'New folder',
  'app.pages.app.managers.newFile': 'New file',
  'app.pages.app.managers.rename': 'Rename',
  'app.pages.app.managers.set_permission': 'Set permissions',
  'app.pages.app.managers.duplicate': 'Duplicate',
  'app.pages.app.managers.openAsReadOnly': 'Open as read-only',
  'app.pages.app.managers.copyAppToWorkspace': 'Copy app to workspace',
  'app.pages.app.managers.copyAppToTeam': 'Copy app to team',
  'app.pages.app.managers.copyAppToPublic': 'Copy app to Public',
  'app.pages.app.managers.downloadApp': 'Download app',
  'app.pages.app.managers.appDownloaded': 'Application downloaded',
  'app.pages.app.managers.copyInterfaceId': 'Copy interface id',
  'app.pages.app.managers.idCopied': 'Id copied',
  'app.pages.app.managers.folderExists': 'Folder already exists',

  // Connections Manager
  'app.pages.app.managers.connectionsManager.connection': 'Connection',
  'app.pages.app.managers.connectionsManager.connections': 'Connections',
  'app.pages.app.managers.connectionsManager.addNewConnection': 'Add new connection',
  'app.pages.connectionsManager.addConnection': 'Add connection',
  'app.pages.app.managers.connectionsManager.stablishingConnection': 'Establishing connection',
  'app.pages.app.managers.connectionsManager.createConnection': 'Create connection',
  'app.pages.app.managers.connectionsManager.testConnection': 'Test connection',
  'app.pages.managers.connectionsManager.successfullyTestedConnection':
    'Successfully tested connection',
  'app.pages.app.managers.editConnection': 'Edit connection',
  'app.pages.app.managers.removeConnection': 'Remove connection',
  'app.pages.app.managers.areYouSureYouWantToRemoveConnection':
    'Are you sure you want to remove this connection?',
  'app.pages.connectionsManager.erpSystems': 'ERP systems',
  'app.pages.connectionsManager.crmSystems': 'CRM systems',
  'app.pages.connectionsManager.relationalDatabases': 'Relational databases',
  'app.pages.connectionsManager.nosqlDatabases': 'NoSQL databases',
  'app.pages.connectionsManager.flatFiles': 'Flat files',
  'app.pages.connectionsManager.cloudPlatforms': 'Cloud platforms',
  'app.pages.connectionsManager.dataWarehouses': 'Data warehouses',
  'app.pages.connectionsManager.apisAndServices': 'APIs and services',
  'app.pages.connectionsManager.supplyChainServices': 'Supply chain services',
  'app.pages.managers.connectionsManager.connectionsNotFound': 'Connections not found',
  'app.pages.managers.connectionsManager.successfullyCreatedConnection':
    'Successfully created connection',
  'app.pages.managers.connectionsManager.successfullyUpdatedConnection':
    'Successfully updated connection',
  'app.pages.managers.connectionsManager.successfullyRemovedConnection':
    'Successfully removed connection',
  'app.pages.managers.connectionsManager.executed': 'executed',

  // Translation Manager
  'app.pages.app.managers.translationsManager': 'Translations',
  'app.pages.app.managers.translationsManager.initialText': 'Initial text',
  'app.pages.app.managers.translationsManager.parent': 'Parent',
  'app.pages.app.managers.translationsManager.node': 'Node',
  'app.pages.app.managers.translationsManager.node.plural': 'Nodes',
  'app.pages.app.managers.translationsManager.interface': 'Interface',
  'app.pages.app.managers.translationsManager.interface.plural': 'Interfaces',
  'app.pages.app.managers.translationsManager.component': 'Interface component',
  'app.pages.app.managers.translationsManager.component.plural': 'Interface components',
  'app.pages.app.managers.translationsManager.menuItemText': 'Menu item text',
  'app.pages.app.managers.translationsManager.menuItemText.plural': 'Menu item texts',
  'app.pages.app.managers.translationsManager.menuItemSubtitle': 'Menu item subtitle',
  'app.pages.app.managers.translationsManager.menuItemSubtitle.plural': 'Menu item subtitles',
  'app.pages.app.managers.translationsManager.menuActionText': 'Menu action text',
  'app.pages.app.managers.translationsManager.menuActionText.plural': 'Menu action texts',
  'app.pages.app.managers.translationsManager.menuActionSubtitle': 'Menu action subtitle',
  'app.pages.app.managers.translationsManager.menuActionSubtitle.plural': 'Menu action subtitles',
  'app.pages.app.managers.translationsManager.translationsNotFound': 'Translations not found',
  'app.pages.app.managers.translationsManager.filterType': 'Filter by type',
  'app.pages.app.managers.translationsManager.interfaceDocumentationSuccessfullyUpdated':
    'Interface documentation successfully updated',
  'app.pages.app.managers.translationsManager.automaticallyCompleteTranslations':
    'Automatically complete translations',
  'app.pages.app.managers.translationsManager.confirmAutomaticTranslations':
    'Confirm automatic translations',
  'app.pages.app.managers.translationsManager.translationsCompleted': 'Translations completed',
  'app.pages.app.managers.translationsManager.confirmAutomaticTranslationsContent':
    'The following items will be automatically translated: ',
  'app.pages.app.managers.translationsManager.translateCurrentRow': 'Translate current row',
  'app.pages.app.managers.translationsManager.translatingCurrentRow': 'Translating current row',
  'app.pages.app.managers.translationsManager.translatingItems': 'Translating {numbers} items',
  'app.pages.app.managers.translationsManager.translationsSettings': 'Translations settings',
  'app.pages.app.managers.translationsManager.automaticTranslationsError':
    'An error occurred while trying to automatically translate the items. Please try again later.',

  // Notifications Manager
  'app.pages.app.notificationsManager.notificationsManager': 'Notifications manager',
  'app.pages.app.notificationsManager.addNotification': 'Add notification',
  'app.pages.app.notificationsManager.editNotification': 'Edit notification',
  'app.pages.app.notificationsManager.successChangedNotificationStatus':
    'Successfully changed notification status',
  'app.pages.app.notificationsManager.removeNotification': 'Remove notification',
  'app.pages.app.notificationsManager.removeNotificationConfirmation':
    'Are you sure you want to remove this notification?',
  'app.pages.app.notificationsManager.successRemovedNotification':
    'Successfully removed notification',
  'app.pages.app.notificationsManager.successAddedNotification': 'Successfully added notification',
  'app.pages.app.notificationsManager.effectiveDate': 'Effective date',
  'app.pages.app.notificationsManager.noNotifications': 'No notifications',
  'app.pages.app.notificationsManager.notificationTitle': 'Notification title',
  'app.pages.app.notificationsManager.notificationDescription': 'Notification description',
  'app.pages.app.notificationsManager.notification': 'Notification',

  //companyManager
  'app.pages.app.companyManager.newCompany': 'Create company',
  'app.pages.app.companyManager.editCompany': 'Update company',
  'app.pages.app.companyManager.companyPreferences': 'Preferences',
  'app.pages.app.companyManager.scimTokens': 'SCIM tokens',
  'app.pages.app.companyManager.successChangedStatus': 'Successfully changed company status',
  //companyManager.companyTable
  'app.pages.app.companyManager.companyTable.companyStatusColumn': 'Status',
  'app.pages.app.companyManager.companyTable.companyTableAriaLabel': 'Company table',
  'app.pages.app.companyManager.companyTable.companiesNotFound': 'Companies not found',
  'app.pages.app.companyManager.companyTable.deleteCompanyDataTitle':
    'Delete company {companyName}',
  'app.pages.app.companyManager.companyTable.deleteCompanyDataWarning':
    'This will permanently delete the company and unassign all its users. Its departments, teams, roles, scheduled tasks, AI settings, secrets, api keys, email history and workflow processes will be permanently deleted, and the Public, Teams and Media folders along with every user workspace will be erased. This action cannot be undone.',
  'app.pages.app.companyManager.companyTable.deleteCompanyDataInputLabel':
    'Type "{keyword}" to confirm',
  'app.pages.app.companyManager.companyTable.deleteCompanyDataConfirmButton': 'Delete company',
  'app.pages.app.companyManager.companyTable.deleteCompanyDataDisabledCurrentCompany':
    'You cannot delete the company you are currently logged into',
  'app.pages.app.companyManager.companyTable.successDeletedCompanyData':
    'Company deleted successfully',
  'app.pages.app.companyManager.hasSaml': 'Has SAML config',
  'app.pages.app.companyManager.noSamlConfiguration':
    'The company {company} does not have SAML configured',
  'app.pages.login.samlCompanyAccessDenied':
    'Your account does not belong to company {company}. Sign in with a valid company or contact your administrator.',

  //companyManager.addOrEdit
  'app.pages.companyManager.addOrEdit.companyNameField': 'Company name',
  'app.pages.companyManager.addOrEdit.companyCodeField': 'Folder name',
  'app.pages.companyManager.addOrEdit.companyActivationCodeField': 'Activation code',
  'app.pages.companyManager.addOrEdit.copiedCompanyActivationCode': 'Activation code - Copied ✓',
  'app.pages.companyManager.addOrEdit.companyLicenseField': 'License',
  'app.pages.companyManager.addOrEdit.companyLogos': 'Logos',
  'app.pages.companyManager.addOrEdit.companyLogo': 'Company logo',
  'app.pages.companyManager.addOrEdit.companyLogoHelp':
    'Shown inside the application and on the login screen.',
  'app.pages.companyManager.addOrEdit.companyEmailLogo': 'Email logo',
  'app.pages.companyManager.addOrEdit.companyEmailLogoHelp':
    'Shown on the emails the platform sends. Rendered 36 px high on white, so a wide, light image works best.',
  'app.pages.companyManager.addOrEdit.emailLogoDropzoneFirstRow': 'Drag and drop the email logo or',
  'app.pages.companyManager.addOrEdit.dropzoneFirstRow': 'Drag and drop company logo or',
  'app.pages.companyManager.addOrEdit.dropzoneLinkRow': 'browse files.',
  'app.pages.companyManager.addOrEdit.companyFieldRequiredError': 'Required field',
  'app.pages.companyManager.addOrEdit.companyFieldMaxLengthError': 'Can not exceed 255 characters',
  'app.pages.companyManager.addOrEdit.companyFolderAlreadyExists':
    'Company Folder already exists, choose a different code',
  'app.pages.companyManager.addOrEdit.copyToClipboard': 'Copy to clipboard',
  'app.pages.companyManager.addOrEdit.copiedData': 'Data copied to clipboard',
  'app.pages.companyManager.addOrEdit.invalidFileExtension': 'Invalid file. Image is required',
  'app.pages.app.companyManager.successAddedCompany': 'Successfully created new company',
  'app.pages.app.companyManager.successEditedCompany': 'Successfully edited company',
  'app.pages.app.companyManager.removeLicense': 'Remove license',
  'app.pages.companyManager.addOrEdit.licenseExpirationDateField': 'License expiration date',
  'app.pages.companyManager.addOrEdit.licensesAssignedField': 'Licenses assigned',
  'app.pages.companyManager.addOrEdit.licensesAvailableField': 'Licenses available',
  'app.pages.companyManager.addOrEdit.licensesOccupiedField': 'Licenses occupied',
  'app.pages.companyManager.addOrEdit.licenseUsageTitle': 'Seats by role',
  'app.pages.companyManager.addOrEdit.licenseUsageExceeded': 'Exceeded',
  'app.pages.companyManager.addOrEdit.licenseUsageNoRole': 'No matching role',
  'app.pages.companyManager.addOrEdit.licenseWarningsTitle':
    'This license has warnings. It can be saved anyway.',
  'app.pages.license.savedWithWarnings': 'The license was saved with warnings',
  'app.pages.companyManager.addOrEdit.licenseExpirationRecipientsField':
    'Notify license expiration to',
  'app.pages.companyManager.addOrEdit.invalidLicenseExpirationRecipients':
    'One or more license expiration recipients are no longer active users of the company. The list was updated: review it and save again.',
  'app.pages.companyManager.addOrEdit.licenseExpirationRecipientsHelp':
    'If none is selected, the notice is sent to users with the Super Administrator, Administrator and App Administrator roles.',

  //Department Manager
  'app.pages.DepartmentPage.addDepartment': 'Add department',
  'app.pages.DepartmentPage.editDepartment': 'Edit department',
  'app.pages.DepartmentPage.engineDefinitions': 'Engine definitions',
  'app.pages.DepartmentPage.loginAction': 'Login Action',
  'app.pages.DepartmentPage.deniedItems': 'Denied Items',
  'app.pages.DepartmentPage.allowedItems': 'Allowed Items',
  'app.pages.DepartmentPage.name.maxLengthError':
    'The department name max length is {number} characters',
  'app.pages.DepartmentPage.department.notFound': 'Departments not found',
  'app.pages.DepartmentPage.department.created': 'Department created',
  'app.pages.DepartmentPage.department.updated': 'Department updated',
  'app.pages.DepartmentPage.departmentManagerTable': 'Department manager table',
  'app.pages.DepartmentPage.addLoginAction': 'Add login action',
  'app.pages.DepartmentPage.downloadReport': 'Download departments report',
  'app.pages.DepartmentPage.reportDownloaded': 'Departments report downloaded',
  'app.pages.DepartmentPage.department': 'Department',

  //Role Manager
  'app.pages.RolePage.addRole': 'Add role',
  'app.pages.RolePage.editRole': 'Edit role',
  'app.pages.RolePage.role.notFound': 'Roles not found',
  'app.pages.RolePage.role.permission.template': 'Permission template',
  'app.pages.RolePage.role.permission.administrator': 'Admininistrator',
  'app.pages.RolePage.role.permission.appAdministrator': 'App Administrator',
  'app.pages.RolePage.role.permission.creatorWithPublicAccess': 'Creator with Public Access',
  'app.pages.RolePage.role.permission.creator': 'Creator',
  'app.pages.RolePage.role.permission.explorer': 'Explorer',
  'app.pages.RolePage.role.permission.viewer': 'Viewer',
  'app.pages.RolePage.role.permission.loginOnlyUser': 'Login Only User',
  'app.pages.RolePage.role.permission.override': 'This will override all permissions',
  'app.pages.RolePage.role.created': 'Role created',
  'app.pages.RolePage.role.updated': 'Role updated',
  'app.pages.RolePage.name.maxLengthError': 'The role name max length is {number} characters',
  'app.pages.RolePage.name.exist': 'The role name already exist',
  'app.pages.RolePage.roleManagerTable': 'Role manager table',

  //notFoundPage
  'app.components.notFoundPage.message': 'The page you are looking for does not exist',
  'app.components.notFoundPage.orGoTo': 'or go to',
  'app.components.notFoundPage.returnToThe': 'Return to the',
  'app.components.notFoundPage.previousPage': 'previous page',
  'app.components.notFoundPage.homePage': 'home page',

  //Company Preferences
  'app.pages.app.companyManager.companyPreferences.notFound': 'Preferences not found',
  'app.pages.app.companyManager.companyPreferences.title': 'Company Preferences of ',
  'app.pages.app.companyManager.companyPreferences.copyDefaultValue': 'Copy Default value',
  'app.pages.app.companyManager.companyPreferences.defaultValueCopied': 'Default value copied',
  'app.pages.app.companyManager.companyPreferences.preferenceUpdated': 'Preference updated',
  'app.pages.app.companyManager.companyPreferences.preferenceCreated': 'Preference created',
  'app.pages.app.companyManager.companyPreferences.preferenceDelete': 'Preference deleted',
  'app.pages.app.companyManager.companyPreferences.saveCustomValue': 'Save custom value',
  'app.pages.app.companyManager.companyPreferences.removeCustomValue': 'Remove custom value',
  'app.pages.app.companyManager.companyPreferences.openJsonEditor': 'Open JSON editor',
  'app.pages.app.companyManager.companyPreferences.jsonEditorTitle': 'Edit JSON value',
  'app.pages.app.companyManager.companyPreferences.editDefaultValue': 'Edit default value',
  'app.pages.app.companyManager.companyPreferences.invalidValue':
    'Not a valid value. Available values: {values}',
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingUploadTooltip':
    'Upload {fileName}',
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingUploaded': 'File uploaded',
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingUploadError':
    'Error uploading file',
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingWrongFileName':
    "Expected a file named '{expectedName}'",
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingManageFiles':
    'Manage uploaded files',
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingStatusUploaded': 'Uploaded',
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingStatusError': 'Upload failed',
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingStatusPending':
    'Not uploaded yet',

  //Permissions by role
  'app.pages.app.permissionsByRole': 'Permissions by role',
  'app.pages.app.permissionsByRole.permissionActivated': 'Permission activated',
  'app.pages.app.permissionsByRole.permissionDeactivated': 'Permission deactivated',
  'app.pages.app.permissionsByRole.allPermissionsActivated':
    'All permissions for {name} have been activated',
  'app.pages.app.permissionsByRole.permission': 'Permission',
  'app.pages.app.permissionsByRole.permissionsUpdated': 'Permissions updated',

  //team manager
  'app.pages.app.teamManager.team': 'Team manager',
  'app.pages.app.teamManager.addTeam': 'Add team',
  'app.pages.app.teamManager.editTeam': 'Edit team',
  'app.pages.app.teamManager.accessLevel': 'Access level',
  'app.pages.app.teamManager.teamDeleted': 'Team {name} deleted',
  'app.pages.app.teamManager.deleteTeam': 'Delete team',
  'app.pages.app.teamManager.areYouSureToDeleteTeam':
    'Are you sure you want to delete team {name}?',
  'app.pages.app.teamManager.departmentsAsociated':
    'It is associated with the following departments:',
  'app.pages.app.teamManager.readOnly': 'Read only',
  'app.pages.app.teamManager.readAndWrite': 'Read and write',
  'app.pages.app.teamManager.updateTeam': 'Update team',
  'app.pages.app.teamManager.createTeam': 'Create team',
  'app.pages.app.teamManager.teamDepartments': 'There is no departments',
  'app.pages.app.teamManager.downloadReport': 'Download teams report',
  'app.pages.app.teamManager.reportDownloaded': 'Teams report downloaded',
  'app.pages.app.teamManager.teamUpdated': 'Team updated',
  'app.pages.app.teamManager.teamCreated': 'Team created',
  'app.pages.teamManager.name.maxLengthError': 'The team name max length is {number} characters',
  'app.pages.teamManager.teamsNotFound': 'Teams not found',
  //User Manager
  'app.pages.UserPage.userManager': 'User manager',
  'app.pages.UserPage.addUser': 'Add user',
  'app.pages.UserPage.editUser': 'Edit user',
  'app.pages.UserPage.email': 'Email',
  'app.pages.UserPage.login': 'Username',
  'app.pages.UserPage.usersNotFound': 'Users not found',
  'app.pages.UserPage.changePassword': 'Change password',
  'app.pages.UserPage.manageCompanies': 'Manage companies',
  'app.pages.UserPage.passwordChanged': 'Password changed',
  'app.pages.UserPage.downloadReport': 'Download Users report',
  'app.pages.UserPage.reportsDownloaded': 'Users report downloaded',
  'app.pages.UserPage.firstName': 'First name',
  'app.pages.UserPage.firstNameIsRequired': 'First name is required',
  'app.pages.UserPage.firstNameMaxLength': 'The first name max length is {number} characters',
  'app.pages.UserPage.firstNamePlaceholder': 'Insert your name',
  'app.pages.UserPage.lastNamePlaceholder': 'Insert your last name',
  'app.pages.UserPage.lastNameIsRequired': 'Last name is required',
  'app.pages.UserPage.lastNameMaxLength': 'The last name max length is {number} characters',
  'app.pages.UserPage.emailPlaceholder': 'Insert your email',
  'app.pages.UserPage.emailIsInvalid': 'Invalid email',
  'app.pages.UserPage.emailContainingÑ': 'Email can not contain "Ñ"',
  'app.pages.UserPage.emailIsRequired': 'Email is required',
  'app.pages.UserPage.emailAlreadyExist': 'Email already exists',
  'app.pages.UserPage.lastName': 'Last name',
  'app.pages.UserPage.userNameIsRequired': 'Username is required',
  'app.pages.UserPage.userNamePlaceholder': 'Insert your username',
  'app.pages.UserPage.passwordPlaceholder': 'Insert your password',
  'app.pages.UserPage.usernameAlreadyExist': 'Username already Exist',
  'app.pages.UserPage.usernameInvalid':
    'Username can have "@", "+", "-", "_" or "." characters. Whitespaces are not allowed.',
  'app.pages.UserPage.steps.userInformation': 'User information',
  'app.pages.UserPage.steps.roleAndCompanySelection': 'Role and company selection',
  'app.pages.UserPage.steps.roleAndCompanySelection.departmentPlaceholder':
    'Please select a department',
  'app.pages.UserPage.steps.roleAndCompanySelection.rolePlaceholder': 'Please select a role',
  'app.pages.UserPage.steps.roleAndCompanySelection.addCompany': 'Add company',
  'app.pages.UserPage.steps.roleAndCompanySelection.removeCompany': 'Remove company',
  'app.pages.UserPage.steps.roleAndCompanySelection.noCompaniesAdded':
    'No companies added, please add one',
  'app.pages.UserPage.steps.roleAndCompanySelection.roleWarning':
    'This role applies to all companies, except for those that have a specific role assigned.',
  'app.pages.UserPage.steps.roleAndCompanySelection.noPermissionToRemove':
    'You do not have permission to remove company assignments. Only Super Admins can modify user-company assignments.',
  'app.pages.UserPage.steps.roleAndCompanySelection.emailDomainWarningTitle':
    'Email Domain Validation Warning',
  'app.pages.UserPage.steps.roleAndCompanySelection.emailDomainWarningMessage':
    'No users with the email domain "@{domain}" exist in company "{companyName}". This may indicate an incorrect company assignment.',
  'app.pages.UserPage.steps.roleAndCompanySelection.emailDomainConfirmPlaceholder':
    'Type the user email to confirm',
  'app.pages.UserPage.steps.roleAndCompanySelection.emailDomainConfirmLabel':
    'Confirm by typing the full email address',
  'app.pages.UserPage.toggleActiveUser.errorNoRoles':
    '{user} does not have a role for the company {company}',
  'app.pages.UserPage.toggleActiveUser.activated': 'User activated',
  'app.pages.UserPage.toggleActiveUser.desactivated': 'User deactivated',
  'app.pages.UserPage.userUnlocked': 'User unlocked',
  'app.pages.UserPage.userCreated': 'User created',
  'app.pages.UserPage.userUpdated': 'User updated',
  'app.pages.UserPage.errorCompanyWithNoRoles': 'There is a company without roles',
  'app.pages.UserPage.errorCompanyWithNoDepartments': 'There is a company without departments',
  'app.pages.UserPage.deleteUser': 'Delete user',
  'app.pages.UserPage.areYouSureToDeleteUser': 'Are you sure you want to delete user {name}?',
  'app.pages.UserPage.userDeleted': 'User deleted',
  'app.pages.UserPage.changeStatus': 'Change status',
  'app.pages.UserPage.unlockUser': 'Unlock user',
  'app.pages.UserPage.ChangePasswordLogin': 'Change password upon login',
  'app.pages.UserPage.enableMfa': 'Enable multi-factor authentication',
  'app.pages.UserPage.setNewQrCode': 'Set new QR code',
  'app.pages.UserPage.validateSetNewQRCode':
    'A new QR code will be set for the user {user}. Do you want to continue?',
  'app.pages.UserPage.qrCodeSuccesfullySeted': 'New QR code set',
  'app.pages.UserPage.lastLogin': 'Last login',
  'app.pages.UserPage.creationDate': 'Creation date',
  'app.pages.UserPage.clearFilters': 'Clear filters',
  'app.pages.UserPage.activeUsersOnly': 'Active users only',
  'app.pages.UserPage.addMultipleUsers': 'Add multiple users',
  'app.pages.UserPage.dragDropCsvMultipleUsers': 'Drag and drop a CSV file with user information',
  'app.pages.UserPage.roleAndDepartmentAppliedToAll':
    'The selected role and department will be applied to all users',
  'app.pages.UserPage.bulkCreationSummary': 'Bulk creation summary',
  'app.pages.UserPage.bulkUsersTotal': 'Total users',
  'app.pages.UserPage.bulkUsersCreated': 'Created',
  'app.pages.UserPage.bulkUsersAssignedExisting': 'Existing users assigned to the company',
  'app.pages.UserPage.bulkUsersAlreadyInCompany': 'Existing users already in the company',
  'app.pages.UserPage.bulkUsersErrorsTitle': 'Errors',
  'app.pages.UserPage.bulkUsersStatusUnavailable':
    'Could not get the progress of the bulk creation. Check the user list to see the result.',
  'app.pages.UserPage.downloadSampleCsv': 'Download sample CSV',

  //Code Diagram Nodes
  'app.pages.Code.Diagram.Nodes.variable': 'Variable',
  'app.pages.Code.Diagram.Nodes.datareading': 'Data reading',
  'app.pages.Code.Diagram.Nodes.button': 'Button',
  'app.pages.Code.Diagram.Nodes.index': 'Index',
  'app.pages.Code.Diagram.Nodes.module': 'Module',
  'app.pages.Code.Diagram.Nodes.inputscalar': 'Scalar',
  'app.pages.Code.Diagram.Nodes.inputselector': 'Selector',
  'app.pages.Code.Diagram.Nodes.inputdateselector': 'Date selector',
  'app.pages.Code.Diagram.Nodes.inputchoice': 'Choice',
  'app.pages.Code.Diagram.Nodes.inputdataframe': 'DataFrame',
  'app.pages.Code.Diagram.Nodes.inputdataarray': 'DataArray',
  'app.pages.Code.Diagram.Nodes.inputcube': 'Cube',
  'app.pages.Code.Diagram.Nodes.text': 'Text',
  'app.pages.Code.Diagram.Nodes.generic': 'Generic',
  'app.pages.Code.Diagram.Nodes.form': 'Form',
  'app.pages.Code.Diagram.Nodes.inputInitialName': 'Set node name',
  'app.pages.Code.Diagram.Nodes.inputData': 'Input data',
  'app.pages.Code.Diagram.Nodes.chooseInputType': 'Choose input data type',
  'app.pages.Code.Diagram.Nodes.report': 'Report',
  'app.pages.Code.Diagram.Nodes.outputnode': 'Output',
  'app.pages.Code.Diagram.Nodes.reportwizard': 'Report wizard',
  'app.pages.Code.Diagram.Nodes.beingUsedInInterfaces': 'The node is being used in interfaces',
  'app.pages.Code.Diagram.Nodes.nodeHasNoInterfaces': 'The node has no interfaces',
  'app.pages.Code.Diagram.Nodes.beingUsedInModulesAndInterfaces':
    'Has outputs outside its module and is being used in interfaces',
  'app.pages.Code.Diagram.Nodes.someNodesAreBeingUsedInInterfaces':
    'Some nodes are being used in interfaces',
  'app.pages.Code.Diagram.Nodes.nextStep': 'Next step',
  'app.pages.Code.Diagram.Nodes.outsideModule': 'This node is located outside the current module',

  //Code Diagram Menu
  'app.pages.Code.Diagram.Menu.hideMenu': 'Hide menu',
  'app.pages.Code.Diagram.Menu.wizards': 'Wizards',
  'app.pages.Code.Diagram.Menu.importModule': 'Import module',
  'app.pages.Code.Diagram.Menu.importModule.steps.selectModule': 'Select module',
  'app.pages.Code.Diagram.Menu.importModule.steps.importType': 'Import type',
  'app.pages.Code.Diagram.Menu.importModule.steps.importType.switch': 'Switch',
  'app.pages.Code.Diagram.Menu.importModule.steps.importType.merge': 'Merge',
  'app.pages.Code.Diagram.Menu.importModule.sucessful': 'Module successfully imported',
  'app.pages.Code.Diagram.Menu.importModule.hasOutputsOutsideItsModule':
    'Has outputs outside its module',
  //Code Diagram Delete dialog
  'app.pages.Code.Diagram.DeleteDialog.deleteNodes': 'Delete nodes?',
  'app.pages.Code.Diagram.DeleteDialog.confirmationtext':
    'Are you sure you want to delete {number} selected nodes?',
  //Node Properties Dialog
  'app.pages.Code.Diagram.Nodes.properties.title': 'Node title',
  'app.pages.Code.Diagram.Nodes.properties.id': 'Node identifier',
  'app.pages.Code.Diagram.Nodes.properties.nodeClass': 'Node type',
  'app.pages.Code.Diagram.Nodes.properties.units': 'Units',
  'app.pages.Code.Diagram.Nodes.properties.evaluateOnStart': 'Evaluate on start',
  'app.pages.Code.Diagram.Nodes.properties.releaseMemory': 'Release memory',
  'app.pages.Code.Diagram.Nodes.properties.prefixIdentifier': 'Module prefix',
  'app.pages.Code.Diagram.Nodes.properties.setIdFromTitle': 'Use title as identifier',
  'app.pages.Code.Diagram.Nodes.properties.normalizeIdentifier':
    'Normalize identifier (lowercase, strip invalid characters, resolve conflicts)',
  'app.pages.Code.Diagram.Nodes.properties.idHelperText':
    'Identifier must start with a letter, and only lowercase letters, numbers and underscores are allowed',
  'app.pages.Code.Diagram.Nodes.properties.idRequired': 'Node identifier can not be empty',
  'app.pages.Code.Diagram.Nodes.properties.prefixIdHelperText':
    'Module prefix must start with a letter, and only lowercase letters, numbers and underscores are allowed',
  'app.pages.Code.Diagram.Nodes.properties.hierarchyMap': 'Hierarchy map',
  'app.pages.Code.Diagram.Nodes.inputs': 'Inputs',
  'app.pages.Code.Diagram.Nodes.outputs': 'Outputs',
  'app.pages.Code.Diagram.Nodes.general': 'General',
  'app.pages.Code.Diagram.Nodes.metadata': 'Metadata',
  'app.pages.Code.Diagram.Nodes.translations': 'Translations',
  'app.pages.Code.Diagram.Nodes.addNewTranslation': 'Add new translation',
  'app.pages.Code.Diagram.Nodes.noLanguageConfiguredMessage':
    'The application must have a default language configured to add translations',
  'app.pages.Code.Diagram.Nodes.creationDate': 'Creation date',
  'app.pages.Code.Diagram.Nodes.lastModification': 'Last modification',
  'app.pages.Code.Diagram.Nodes.lastModificationUser': 'User',
  'app.pages.Code.Diagram.Nodes.lastUserThatModified': 'Last user that modified',
  'app.pages.Code.Diagram.Nodes.noInputs': 'There are no inputs',
  'app.pages.Code.Diagram.Nodes.noOutputs': 'There are no outputs',
  'app.pages.Code.Diagram.Nodes.docs': 'Documentation',
  'app.pages.Code.Diagram.Nodes.noDocs': 'There is no documentation for this section',
  'app.pages.Code.Diagram.Nodes.editDocs': 'Edit docs',
  'app.pages.Code.Diagram.Nodes.docsEdited': 'Docs edited',
  'app.pages.Code.Diagram.Nodes.selectNodeToShowDocs': 'Select a node to display the docs',
  'app.pages.Code.itemHeader.saveDefaultView': 'Save default view',
  //Context Menu
  'app.pages.Code.Diagram.ContextMenu.resize': 'Resize nodes as {string}',
  'app.pages.Code.Diagram.ContextMenu.alignment': 'Align nodes to {string}',
  'app.pages.Code.Diagram.ContextMenu.showInputs': 'Show inputs',
  'app.pages.Code.Diagram.ContextMenu.showOutputs': 'Show outputs',
  'app.pages.Code.Diagram.ContextMenu.moveNodeToBackground': 'Move node to background',
  'app.pages.Code.Diagram.ContextMenu.nodeMovedToBackground': 'Node moved to background',
  'app.pages.Code.Diagram.ContextMenu.moveNodeToFront': 'Move node to front',
  'app.pages.Code.Diagram.ContextMenu.nodeMovedToFront': 'Node moved to front',
  'app.pages.Code.Diagram.ContextMenu.sizes.width': 'Make same width',
  'app.pages.Code.Diagram.ContextMenu.sizes.height': 'Make same height',
  'app.pages.Code.Diagram.ContextMenu.sizes.size': 'Make same size',
  'app.pages.Code.Diagram.ContextMenu.alignment.top': 'Top edges',
  'app.pages.Code.Diagram.ContextMenu.alignment.centerH': 'Center horizontally',
  'app.pages.Code.Diagram.ContextMenu.alignment.centerV': 'Center vertically',
  'app.pages.Code.Diagram.ContextMenu.alignment.bottom': 'Bottom edges',
  'app.pages.Code.Diagram.ContextMenu.alignment.right': 'Right edges',
  'app.pages.Code.Diagram.ContextMenu.alignment.left': 'Left edges',
  'app.pages.Code.Diagram.ContextMenu.exportModule': 'Export module',
  'app.pages.Code.Diagram.ContextMenu.moduleExported': 'Module exported',
  'app.pages.Code.Diagram.ContextMenu.setRestriction': 'Set restriction',
  'app.pages.Code.Diagram.ContextMenu.pinNode': 'Pin node',
  'app.pages.Code.Diagram.ContextMenu.unpinNode': 'Unpin node',
  'app.pages.Code.pinnedNodes.allGroups': 'All',
  'app.pages.Code.pinnedNodes.createGroup': 'New group',
  'app.pages.Code.pinnedNodes.createGroupTooltip': 'Create a new group of pinned nodes',
  'app.pages.Code.pinnedNodes.newGroup': 'New group',
  'app.pages.Code.pinnedNodes.groupColorTooltip': 'Select the group color',
  'app.pages.Code.pinnedNodes.groupName': 'Group name',
  'app.pages.Code.pinnedNodes.groupNameInUse': 'There is already a group with that name',
  'app.pages.Code.pinnedNodes.renameGroup': 'Rename group',
  'app.pages.Code.pinnedNodes.deleteGroup': 'Delete group',
  'app.pages.Code.pinnedNodes.deleteGroupConfirmation':
    'The group "{name}" will be deleted. Its nodes stay pinned, without a group.',
  'app.pages.Code.pinnedNodes.emptyGroup': 'Pin nodes with this group selected to add them here',
  'app.pages.Code.Diagram.ContextMenu.apiEndpoint': 'Get API endpoint',
  'app.pages.Code.Diagram.apiEndpoint.endpointFor': 'Endpoint for: ',
  'app.pages.Code.Diagram.apiEndpoint.shareInstance': 'Share instance',
  'app.pages.Code.Diagram.apiEndpoint.apiURLcopied': 'API URL copied ',
  'app.pages.Code.Diagram.apiEndpoint.message':
    'and send function parameters as JSON in the request body.',
  'app.pages.Code.Diagram.ContextMenu.openWizard': 'Open wizard',
  'app.pages.Code.Diagram.ContextMenu.compareNodes': 'Compare nodes',
  'app.pages.Code.Diagram.ContextMenu.handlingDataWidget': 'Handling data',
  'app.pages.Code.Diagram.Wizards.dropDuplicates': 'Drop duplicates',
  'app.pages.Code.Diagram.ContextMenu.dataSystemNodeNoData': 'Data system node has no data',

  //Code Diagram Wizards
  'app.pages.Code.Diagram.Wizards.openWizard': 'Open wizard',
  'app.pages.Code.Diagram.Wizards.selectColumns': 'Select columns',
  'app.pages.Code.Diagram.Wizards.editInExcel': 'Edit in Excel',
  'app.pages.Code.Diagram.Wizards.selectRows': 'Select rows',
  'app.pages.Code.Diagram.Wizards.name': 'Column name',
  'app.pages.Code.Diagram.Wizards.isIndex': 'Is index',
  'app.pages.Code.Diagram.Wizards.dtype': 'Data type',
  'app.pages.Code.Diagram.Wizards.editTableDefinition': 'Edit Table definition',
  'app.pages.Code.Diagram.Wizards.removeColumn': 'Remove column',
  'app.pages.Code.Diagram.Wizards.addNewColumn': 'Add new column',
  'app.pages.Code.Diagram.Wizards.column': 'Column',
  'app.pages.Code.Diagram.Wizards.editCubeDefinition': 'Edit Cube definition',
  'app.pages.Code.Diagram.Wizards.deleteCubeData': 'Delete Cube data',
  'app.pages.Code.Diagram.Wizards.deleteCubeDataMessage':
    'Are you sure you want to delete the Cube data from the database?',
  'app.pages.Code.Diagram.Wizards.deleteCubeDataConfirm':
    'The Cube data was successfully deleted from the database',
  'app.pages.Code.Diagram.Wizards.availableIndexes': 'Available indexes',
  'app.pages.Code.Diagram.Wizards.selectedIndexes': 'Selected indexes',
  'app.pages.Code.Diagram.Wizards.filter': 'Filter',
  'app.pages.Code.Diagram.Wizards.defaultValue': 'Default value',
  'app.pages.Code.Diagram.Wizards.defaultValueType': 'Default value type',
  'app.pages.Code.Diagram.Wizards.scalar': 'Scalar',
  'app.pages.Code.Diagram.Wizards.model_node': 'Model node',
  'app.pages.Code.Diagram.Wizards.app_node': 'App node',
  'app.pages.Code.Diagram.Wizards.node_id': 'Node id already exists, select another one',
  'app.pages.Code.Diagram.Wizards.calculatedField': 'Calculated field',
  'app.pages.Code.Diagram.Wizards.setIndex': 'Set index',
  'app.pages.Code.Diagram.Wizards.groupAgregate': 'Group/aggregate',
  'app.pages.Code.Diagram.Wizards.createindex': 'Create Index',
  'app.pages.Code.Diagram.Wizards.createcube': 'Create Cube',
  'app.pages.Code.Diagram.Wizards.form': 'Form',
  'app.pages.Code.Diagram.Wizards.report': 'Report',
  'app.pages.Code.Diagram.Wizards.editFormDefinition': 'Edit Form definition',
  'app.pages.Code.Diagram.Wizards.deleteFormData': 'Delete Form data',
  'app.pages.Code.Diagram.Wizards.deleteFormDataMessage':
    'Are you sure you want to delete the Form data from the database?',
  'app.pages.Code.Diagram.Wizards.deleteFormDataConfirm':
    'The Form data was successfully deleted from the database',
  'app.pages.Code.Diagram.Wizards.formFieldError': 'Id or field title cannot be "id"',
  'app.pages.Code.Diagram.Wizards.formFieldNoWhiteSpacesError':
    'Field ID cannot contain whitespaces.',
  'app.pages.Code.Diagram.Wizards.fieldId': 'Field ID',
  'app.pages.Code.Diagram.Wizards.fieldTitle': 'Field title',
  'app.pages.Code.Diagram.Wizards.columnType': 'Column type',
  'app.pages.Code.Diagram.Wizards.hidden': 'Hidden',
  'app.pages.Code.Diagram.Wizards.readOnly': 'Read-only',
  'app.pages.Code.Diagram.Wizards.formula': 'Formula',
  'app.pages.Code.Diagram.Wizards.values': 'Values',
  'app.pages.Code.Diagram.Wizards.filterRowsByDomain': 'Filter rows by domain',
  'app.pages.Code.Diagram.Wizards.strict': 'Strict',
  'app.pages.Code.Diagram.Wizards.relatedMap': 'Related map',
  'app.pages.Code.Diagram.Wizards.relatedMapColumnValues': 'Column with values',
  'app.pages.Code.Diagram.Wizards.relatedColumns': 'Related columns',
  'app.pages.Code.Diagram.Wizards.fromNode': 'From node',
  'app.pages.Code.Diagram.Wizards.fromNodeDetails':
    'Node result must be a function that takes a Pandas DataFrame as a parameter and returns a Pandas DataFrame',
  'app.pages.Code.Diagram.Wizards.advancedOptions': 'Advanced options',
  'app.pages.Code.Diagram.Wizards.appNode': 'App node',
  'app.pages.Code.Diagram.Wizards.typeNewValues': 'Type new values. Press Enter to confirm',
  'app.pages.Code.Diagram.Wizards.columnType.input': 'Input',
  'app.pages.Code.Diagram.Wizards.columnType.checkbox': 'Checkbox',
  'app.pages.Code.Diagram.Wizards.columnType.selector': 'Selector',
  'app.pages.Code.Diagram.Wizards.columnType.related_selector': 'Related selector',
  'app.pages.Code.Diagram.Wizards.columnType.calc': 'Calc',
  'app.pages.Code.Diagram.Wizards.columnType.dataframe_column': 'DataFrame column',
  'app.pages.Code.Diagram.Wizards.columnType.system': 'System',
  'app.pages.Code.Diagram.Wizards.tableName': 'Table name',
  'app.pages.Code.Diagram.Wizards.formSettings': 'Form settings',
  'app.pages.Code.Diagram.Wizards.editFormSettings': 'Edit form settings',
  'app.pages.Code.Diagram.Wizards.addNewField': 'Add new field',
  'app.pages.Code.Diagram.Wizards.addNewItem': 'Add new item',
  'app.pages.Code.Diagram.Wizards.databaseEngine': 'Database engine',
  'app.pages.Code.Diagram.Wizards.databaseConnection': 'Database connection',
  'app.pages.Code.Diagram.Wizards.databasePath': 'Database path',
  'app.pages.Code.Diagram.Wizards.host': 'Host',
  'app.pages.Code.Diagram.Wizards.database': 'Database',
  'app.pages.Code.Diagram.Wizards.databaseCustomURL': 'Custom URL',
  'app.pages.Code.Diagram.Wizards.initialEmptyRows': 'Initial empty rows',
  'app.pages.Code.Diagram.Wizards.allowAddRows': 'Allow add rows',
  'app.pages.Code.Diagram.Wizards.allowRemoveRows': 'Allow remove rows',
  'app.pages.Code.Diagram.Wizards.allowAddNewColumns': 'Allow add new columns',
  'app.pages.Code.Diagram.Wizards.allowRowReordering': 'Allow row reordering',
  'app.pages.Code.Diagram.Wizards.validateSelectorsOnInitialRender':
    'Validate selector values when loading the form',
  'app.pages.Code.Diagram.Wizards.trackHistory': 'Track data history',
  'app.pages.Code.Diagram.Wizards.fixedColumns': 'Fixed columns',
  'app.pages.Code.Diagram.Wizards.formRecreateTableMessage':
    'All data in the form will be erased, and it will be recreated from scratch',
  'app.pages.Code.Diagram.Wizards.formSubmitConfirmation':
    'This will overwrite current form definition.',
  'app.pages.Code.Diagram.Wizards.fromDataFrame': 'From DataFrame',
  'app.pages.Code.Diagram.Wizards.sourceDataFrameNode': 'Source DataFrame node',
  'app.pages.Code.Diagram.Wizards.sourceDataFrameIdColumn': 'Source DataFrame ID column',
  'app.pages.Code.Diagram.Wizards.removeOldRows': 'Remove old rows',
  'app.pages.Code.Diagram.Wizards.newFieldName': 'New field name',
  'app.pages.Code.Diagram.Wizards.newItemName': 'New item name',
  'app.pages.Code.Diagram.Wizards.expression': 'Expression',
  'app.pages.Code.Diagram.Wizards.fieldList': 'Available fields',
  'app.pages.Code.Diagram.Wizards.agregate': 'Aggregate functions',
  'app.pages.Code.Diagram.Wizards.groupBy': 'Group by',
  'app.pages.Code.Diagram.Wizards.filterDataFrame': 'Filter DataFrame',
  'app.pages.Code.Diagram.Wizards.condition': 'Condition',
  'app.pages.Code.Diagram.Wizards.addNewFilter': 'Add new filter',
  'app.pages.Code.Diagram.Wizards.valueIsRequired': 'Value is required',
  'app.pages.Code.Diagram.Wizards.mustHaveAtLeastValues': 'Must have at least {number} value/s',
  'app.pages.Code.Diagram.Wizards.filterDataArray': 'Filter DataArray',
  'app.pages.Code.Diagram.Wizards.dimension': 'Dimension',
  'app.pages.Code.Diagram.Wizards.editIndex': 'Edit index',
  'app.pages.Code.Diagram.Wizards.itemList': 'List of items',
  'app.pages.Code.Diagram.Wizards.count': 'Count',
  'app.pages.Code.Diagram.Wizards.insertAbove': 'Insert row above',
  'app.pages.Code.Diagram.Wizards.insertBelow': 'Insert row below',
  'app.pages.Code.Diagram.Wizards.removeRow': 'Remove row',
  'app.pages.Code.Diagram.Wizards.index': 'Index',
  'app.pages.Code.Diagram.Wizards.renameIndex': 'Rename index',
  'app.pages.Code.Diagram.Wizards.filterIndexes': 'Filter indexes',
  'app.pages.Code.Diagram.Wizards.files': 'Files',
  'app.pages.Code.Diagram.Wizards.databases': 'Databases',
  'app.pages.Code.Diagram.Wizards.online': 'Online',
  'app.pages.Code.Diagram.Wizards.dataReadingNode': 'Data reading node',
  'app.pages.Code.Diagram.Wizards.readCsvFile': 'Read CSV file',
  'app.pages.Code.Diagram.Wizards.readExcelFile': 'Read Excel file',
  'app.pages.Code.Diagram.Wizards.dataPreview': 'Data preview',
  'app.pages.Code.Diagram.Wizards.schema': 'Schema',
  'app.pages.Code.Diagram.Wizards.csvDataSource': 'CSV data source',
  'app.pages.Code.Diagram.Wizards.excelDataSource': 'Excel data source',
  'app.pages.Code.Diagram.Wizards.backStep': 'Back',
  'app.pages.Code.Diagram.Wizards.finishingDataRead':
    'Finalizing the creation of the node, please wait...',
  'app.pages.Code.Diagram.Wizards.nextStep': 'Next',
  'app.pages.Code.Diagram.Wizards.chooseDataSource': 'Choose a data source',
  'app.pages.Code.Diagram.Wizards.selectFile': 'Select file from server',
  'app.pages.Code.Diagram.Wizards.selectFolder': 'Select folder',
  'app.pages.Code.Diagram.Wizards.selectFileFromUrl': 'Select file from URL',
  'app.pages.Code.Diagram.Wizards.encoding': 'Encoding',
  'app.pages.Code.Diagram.Wizards.separator': 'Separator',
  'app.pages.Code.Diagram.Wizards.dataSetSample': 'DataSet sample',
  'app.pages.Code.Diagram.Wizards.sheetName': 'Sheet name',
  'app.pages.Code.Diagram.Wizards.definedRanges': 'Defined ranges',
  'app.pages.Code.Diagram.Wizards.customRange': 'Custom range',
  'app.pages.Code.Diagram.Wizards.setNewHeaderFirstRow': 'Set new header with first row',
  'app.pages.Code.Diagram.Wizards.exampleCustomRange': 'Example: A1:B10',
  'app.pages.Code.Diagram.Wizards.sortDataFrame': 'Sort DataFrame',
  'app.pages.Code.Diagram.Wizards.criteria': 'Criteria',
  'app.pages.Code.Diagram.Wizards.addNewOrderCondition': 'Add new order condition',
  'app.pages.Code.Diagram.Wizards.indexOptions': 'Index options',
  'app.pages.Code.Diagram.Wizards.transform': 'Transform',
  'app.pages.Code.Diagram.Wizards.toDataFrame': 'To DataFrame',
  'app.pages.Code.Diagram.Wizards.changeIndex': 'Change index',
  'app.pages.Code.Diagram.Wizards.oldIndex': 'Old index',
  'app.pages.Code.Diagram.Wizards.newIndex': 'New index',
  'app.pages.Code.Diagram.Wizards.compareMode': 'Compare mode',
  'app.pages.Code.Diagram.Wizards.searchIndex': 'Search index',
  'app.pages.Code.Diagram.Wizards.byPosition': 'By position',
  'app.pages.Code.Diagram.Wizards.byValue': 'By value',
  'app.pages.Code.Diagram.Wizards.list': 'List',
  'app.pages.Code.Diagram.Wizards.rangeType': 'Range type',
  'app.pages.Code.Diagram.Wizards.frequency': 'Frequency',
  'app.pages.Code.Diagram.Wizards.cumulative': 'Cumulative',
  'app.pages.Code.Diagram.Wizards.periods': 'Periods',
  'app.pages.Code.Diagram.Wizards.stringPrefix': 'String prefix',
  'app.pages.Code.Diagram.Wizards.to': 'To',
  'app.pages.Code.Diagram.Wizards.steps': 'Steps',
  'app.pages.Code.Diagram.Wizards.enterNumericalValue': 'Enter a numerical value',
  'app.pages.Code.Diagram.Wizards.invalidDate':
    'Invalid date, please enter a date with format: YYYY-MM-DD',
  'app.pages.Code.Diagram.Wizards.startDateIsRequired': 'Start date is required',
  'app.pages.Code.Diagram.Wizards.endDateIsRequired': 'End date is required',
  'app.pages.Code.Diagram.Wizards.yearly': 'Yearly',
  'app.pages.Code.Diagram.Wizards.monthly': 'Monthly',
  'app.pages.Code.Diagram.Wizards.weekly': 'Weekly',
  'app.pages.Code.Diagram.Wizards.daily': 'Daily',
  'app.pages.Code.Diagram.Wizards.saveLabels': 'Save labels',
  'app.pages.Code.Diagram.Wizards.nestedHeaders': 'Nested headers',
  'app.pages.Code.Diagram.Wizards.nestedHeadersTypeNewValues':
    'Type new nested headers. Press Enter to confirm',
  'app.pages.Code.Diagram.Wizards.deleteAndRecreateTable': 'Delete and recreate table',
  'app.pages.Code.Diagram.Wizards.itemName': 'Item name',
  'app.pages.Code.Diagram.Wizards.editReportDefinition': 'Edit Report definition',
  'app.pages.Code.Diagram.Wizards.itemsFromIndex': 'Items from index',
  'app.pages.Code.Diagram.Wizards.indexNode': 'Index node',
  'app.pages.Code.Diagram.Wizards.addItemsFromIndex': 'Add items from index',
  'app.pages.Code.Diagram.Wizards.asNegative': 'As negative',
  'app.pages.Code.Diagram.Wizards.itemIsNotInItemsList':
    'Item "{item}" is not in items list from node "{nodeId}"',
  'app.pages.Code.Diagram.Wizards.reportSubmitConfirmation':
    'This will overwrite current report definition.',
  'app.pages.Code.Diagram.Wizards.outputType': 'Output type',
  'app.pages.Code.Diagram.Wizards.removeNonExistingCombinations':
    'Remove non-existing combinations',
  'app.pages.Code.Diagram.Wizards.allowDimensionChanges': 'Allow dimension changes',
  'app.pages.Code.Diagram.Wizards.confirmWizardChanges': 'Confirm wizard changes',
  'app.pages.Code.Diagram.Wizards.overWriteDefinition': 'Overwrite current node definition',
  'app.pages.Code.Diagram.Wizards.createNewNodeWithCurrentChanges':
    'Create new node with current changes',
  'app.pages.Code.Diagram.Wizards.renameColumn': 'Rename column',
  'app.pages.Code.Diagram.Wizards.deleteColumn': 'Delete column',
  'app.pages.Code.Diagram.Wizards.duplicateColumn': 'Duplicate column',
  'app.pages.Code.Diagram.Wizards.changeDataType': 'Change data type',
  'app.pages.Code.Diagram.Wizards.sortColumn': 'Sort column',
  'app.pages.Code.Diagram.Wizards.removeDuplicates': 'Remove duplicates',
  'app.pages.Code.Diagram.Wizards.newColumnName': 'New column name',
  'app.pages.Code.Diagram.Wizards.deleteColumnMessage':
    'The column {column} will be removed from the DataFrame. Do you want to continue?',
  'app.pages.Code.Diagram.Wizards.newDuplicateColumnName': 'New duplicate column name',
  'app.pages.Code.Diagram.Wizards.changeColumnType': 'Change column type',
  'app.pages.Code.Diagram.Wizards.columnSanitization': 'Column sanitization',
  'app.pages.Code.Diagram.Wizards.addNewSanitizeAction': 'Add new sanitize action',
  'app.pages.Code.Diagram.Wizards.sanitizationColumnOptions': 'Sanitization column options',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.RemoveDuplicatesWords':
    'Remove duplicate words from column',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.ReplaceMultiSpace':
    'Replace multiple spaces with a single space',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.RemovePunctuation':
    'Remove punctuation from text',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.RemoveNumbers': 'Remove numbers from text',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.KeepOnlyAlphaNumeric':
    'Keep only alphanumeric characters',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.NormalizeAccents':
    'Normalize accents from text',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.RemoveSpaces': 'Remove spaces from text',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.AddSpaceBetweenWords':
    'Add space between words',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.RemoveRepeatedChars':
    'Remove repeated characters',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.UpperWordCase': 'Upper word case',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.LowerWordCase': 'Lower word case',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.TitleWordCase': 'Title word case',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.RemoveHiddenChars': 'Remove hidden characters',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.ReplaceHypensWithSpace':
    'Replace hyphens with space',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.ReplaceText': 'Replace text',
  'app.pages.Code.Diagram.Wizards.textToReplace': 'Text to replace',
  'app.pages.Code.Diagram.Wizards.replaceWith': 'Replace with',
  'app.pages.Code.Diagram.Wizards.stopWords': 'Stop words',
  'app.pages.Code.Wizards.Upper': 'Upper',
  'app.pages.Code.Wizards.Lower': 'Lower',
  'app.pages.Code.Wizards.Title': 'Title',
  'app.pages.Code.Wizards.Capitalize': 'Capitalize',
  'app.pages.Code.Wizards.Swapcase': 'Swapcase',
  'app.pages.Code.Diagram.Wizards.applyChangesInNewColumn': 'Apply changes in new column',
  'app.pages.Code.Diagram.Wizards.fillEmptyValues': 'Fill empty values',
  'app.pages.Code.Diagram.Wizards.fillValue': 'Fill value',
  'app.pages.Code.Diagram.Wizards.fillMethod': 'Fill method',
  'app.pages.Code.Diagram.Wizards.searchConditionValue': 'Search condition value',
  'app.pages.Code.Diagram.Wizards.selectorType': 'Selector type',
  'app.pages.Code.Diagram.Wizards.selectorType.standard': 'Standard',
  'app.pages.Code.Diagram.Wizards.selectorType.date': 'Date',

  //Interfaces
  'app.pages.Interfaces.Table.add1RowAbove': 'Add 1 row above',
  'app.pages.Interfaces.Table.add5RowsAbove': 'Add 5 rows above',
  'app.pages.Interfaces.Table.add1RowBelow': 'Add 1 row below',
  'app.pages.Interfaces.Table.add5RowsBelow': 'Add 5 rows below',
  'app.pages.Interfaces.Table.addRow': 'Add row',
  'app.pages.Interfaces.Table.removeRow': 'Remove row/s',
  'app.pages.Interfaces.Table.copy': 'Copy',
  'app.pages.Interfaces.Table.copyTable': 'Copy table',
  'app.pages.Interfaces.Table.copyWithHeaders': 'Copy with headers',
  'app.pages.Interfaces.Table.copyOnlyHeaders': 'Copy only headers',
  'app.pages.Interfaces.Table.copyAllGroupHeaders': 'Copy with all group headers',
  'app.pages.Interfaces.Form.addRowsAbove': 'Add rows above',
  'app.pages.Interfaces.Form.addRowsBelow': 'Add rows below',
  'app.pages.Interfaces.Form.multiselectSelected': 'Selected',
  'app.pages.Interfaces.Form.multiselectNotSelected': 'Not selected',
  'app.pages.Interfaces.Form.multiselectLoadingMore': 'Loading more...',
  'app.pages.Interfaces.Form.multiselectSearch': 'Search...',
  'app.pages.Interfaces.Form.refreshData': 'Refresh data',
  'app.pages.Interfaces.Form.refreshDataAlert':
    'Refreshing the data will re-read it from the database. Any changes that have not been confirmed will be lost.',
  'app.pages.Interfaces.Form.confirmChangesAndRefresh': 'Confirm changes and refresh',
  'app.pages.Interfaces.Form.discardChangesAndRefresh': 'Discard changes and refresh',
  'app.pages.Interfaces.History.title': 'Data history',
  'app.pages.Interfaces.History.source': 'Source',
  'app.pages.Interfaces.History.oldValue': 'Previous value',
  'app.pages.Interfaces.History.newValue': 'New value',
  'app.pages.Interfaces.History.viewRowHistory': 'View row history',
  'app.pages.Interfaces.History.changedCells': '{count, plural, one {# cell} other {# cells}}',
  'app.pages.Interfaces.History.inRows': 'in {count, plural, one {# row} other {# rows}}',
  'app.pages.Interfaces.History.insertedRows':
    '{count, plural, one {# row added} other {# rows added}}',
  'app.pages.Interfaces.History.deletedRows':
    '{count, plural, one {# row removed} other {# rows removed}}',
  'app.pages.Interfaces.History.editSession': '{count, plural, one {# edit} other {# edits}}',
  'app.pages.Interfaces.History.batches': 'Batches',
  'app.pages.Interfaces.History.users': 'Users',
  'app.pages.Interfaces.History.lastChange': 'Last change',
  'app.pages.Interfaces.History.empty': 'No changes recorded',
  'app.pages.Interfaces.History.operation.update': 'Value changed',
  'app.pages.Interfaces.History.operation': 'Operation',
  'app.pages.Interfaces.History.fullName': 'Full name',
  'app.pages.Interfaces.History.batch': 'Batch',
  'app.pages.Interfaces.History.download': 'Download history',
  'app.pages.Interfaces.History.operation.insert': 'Row added',
  'app.pages.Interfaces.History.operation.delete': 'Row removed',
  'app.pages.Interfaces.History.source.interface': 'Interface',
  'app.pages.Interfaces.History.source.diagram': 'Diagram',
  'app.pages.Interfaces.History.source.html_interface': 'HTML interface',
  'app.pages.Interfaces.History.source.agent': 'Agent',
  'app.pages.Interfaces.History.source.office_addin': 'Excel add-in',
  'app.pages.Interfaces.History.source.code': 'Code',
  'app.pages.Interfaces.Table.drilldownBy': 'Drilldown by:',
  'app.pages.Interfaces.Table.drilldownBack': 'Back to:',
  'app.pages.Interfaces.Table.drilldownsApplied': 'Drilldowns applied:',
  'app.pages.Interfaces.Table.removeDrilldowns': 'Remove drilldowns',
  'app.pages.Interfaces.Table.drilldownBackOneLevel': 'Drilldown back one level',
  'app.pages.Interfaces.SelectWithAutocomplete.noOptions': 'No options',
  'app.pages.Interfaces.SelectWithAutocomplete.loading': 'Loading...',
  'app.pages.Interfaces.IndexFilterDialog.availableElements': 'Available elements',
  'app.pages.Interfaces.IndexFilterDialog.selectedElements': 'Selected elements',
  'app.pages.Interfaces.IndexFilterDialog.filterElements': 'Filter elements',
  'app.pages.Interfaces.IndexFilterDialog.contains': 'Contains',
  'app.pages.Interfaces.IndexFilterDialog.notcontains': 'Does not contain',
  'app.pages.Interfaces.IndexFilterDialog.equal': 'Equal to',
  'app.pages.Interfaces.IndexFilterDialog.equal_to_node_values': 'Equal to node values',
  'app.pages.Interfaces.IndexFilterDialog.regular_expression': 'Regular expression',
  'app.pages.Interfaces.IndexFilterDialog.notequal': 'Not equal to',
  'app.pages.Interfaces.IndexFilterDialog.greater_than': 'Greater than',
  'app.pages.Interfaces.IndexFilterDialog.greater_than_equal_to': 'Greater than or equal to',
  'app.pages.Interfaces.IndexFilterDialog.less_than': 'Less than',
  'app.pages.Interfaces.IndexFilterDialog.less_than_equal_to': 'Less than or equal to',
  'app.pages.Interfaces.IndexFilterDialog.begin_with': 'Begins with',
  'app.pages.Interfaces.IndexFilterDialog.not_begin_with': 'Does not begin with',
  'app.pages.Interfaces.IndexFilterDialog.end_with': 'Ends with',
  'app.pages.Interfaces.IndexFilterDialog.not_end_with': 'Does not end with',
  'app.pages.Interfaces.IndexFilterDialog.naDisplayValue': '(empty)',
  'app.pages.Interfaces.IndexFilterDialog.earliest': 'Earliest',
  'app.pages.Interfaces.IndexFilterDialog.latest': 'Latest',
  'app.pages.Interfaces.IndexFilterDialog.between': 'Between',
  'app.pages.Interfaces.IndexFilterDialog.notbetween': 'Not Between',
  'app.pages.Interfaces.IndexFilterDialog.matches_pattern': 'Matches pattern',
  'app.pages.Interfaces.IndexFilterDialog.not_matches_pattern': 'Does not match pattern',
  'app.pages.Interfaces.IndexFilterDialog.rowsCount': 'Count',
  'app.pages.Interfaces.ConditionFilterDialog.filterApplied': 'Condition filter applied',
  'app.pages.Interfaces.ConditionFilterDialog.clearFilter': 'Clear filter',
  'app.pages.Interfaces.ConditionFilterDialog.showWhen': 'Show items that match',
  'app.pages.Interfaces.ConditionFilterDialog.combinator': 'How to combine the conditions',
  'app.pages.Interfaces.ConditionFilterDialog.all': 'all conditions (AND)',
  'app.pages.Interfaces.ConditionFilterDialog.any': 'any condition (OR)',
  'app.pages.Interfaces.ConditionFilterDialog.and': 'AND',
  'app.pages.Interfaces.ConditionFilterDialog.or': 'OR',
  'app.pages.Interfaces.ConditionFilterDialog.addCondition': 'Add condition',
  'app.pages.Interfaces.ConditionFilterDialog.removeCondition': 'Remove condition',
  'app.pages.Interfaces.ConditionFilterDialog.patternHelp':
    'Pattern wildcards: * any number of characters, ? a single character, ~ before * ? ~ to search for them literally.\nExample: *oil*sunflower*. Not case-sensitive.',
  'app.pages.Interfaces.ItemHeader.filterByValues': 'Filter by values',
  'app.pages.Interfaces.ItemHeader.filterByCondition': 'Filter by condition',
  'app.pages.Interfaces.ItemHeader.filterByNodeValues': 'Filter by node values',
  'app.pages.Interfaces.NodeFilterDialog.filterApplied': 'Node values filter applied',
  'app.pages.Interfaces.NodeFilterDialog.node': 'Node',
  'app.pages.Interfaces.NodeFilterDialog.help':
    'The elements matching the values of the node (a list, an index or a single value) are filtered every time the view is loaded. Node values that are not in the dimension are ignored.',
  'app.pages.Interfaces.SelectFormColumnsDialog.nodeHelp':
    "The columns whose name or title is in the node's result (a list, an index or a single value) are shown every time the view is loaded. Node values that are not columns are ignored.",
  'app.pages.Interfaces.SelectFormColumnsDialog.conditionHelp':
    'The conditions are evaluated on the column titles every time the view is loaded.',
  'app.pages.Interfaces.Components.core.Node': 'Node',
  'app.pages.Interfaces.Components.core.Index': 'Index',
  'app.pages.Interfaces.Components.core.Selector': 'Selector',
  'app.pages.Interfaces.Components.core.Chart': 'Chart',
  'app.pages.Interfaces.Components.core.PlotlyChart': 'Plotly chart',
  'app.pages.Interfaces.Components.core.InputValue': 'Input value',
  'app.pages.Interfaces.Components.core.Table': 'Table',
  'app.pages.Interfaces.Components.core.InputDataArray': 'Input dataarray',
  'app.pages.Interfaces.Components.core.InputDataFrame': 'Input dataframe',
  'app.pages.Interfaces.Components.core.Html': 'Rich text',
  'app.pages.Interfaces.Components.core.Menu': 'Menu',
  'app.pages.Interfaces.Components.core.Empty': 'Empty',
  'app.pages.Interfaces.Components.core.Generic': 'Generic',
  'app.pages.Interfaces.Components.core.Indicator': 'Indicator',
  'app.pages.Interfaces.Components.core.Choice': 'Choice',
  'app.pages.Interfaces.Components.core.Button': 'Button',
  'app.pages.Interfaces.Components.core.Button.disable': 'Disable button',
  'app.pages.Interfaces.Components.core.Button.runButtonDefaultMessage':
    'Are you sure you want to execute this button?',
  'app.pages.Interfaces.Components.core.Form': 'Form',
  'app.pages.Interfaces.Components.core.MyTasks': 'Tasks',
  'app.pages.Interfaces.Components.core.ScheduledTasks': 'Scheduled tasks',
  'app.pages.Interfaces.Components.core.InputData': 'Input data',
  'app.pages.Interfaces.Components.core.MatplotlibChart': 'Matplotlib chart',
  'app.pages.Interfaces.Components.core.Assistant': 'Assistant',
  'app.pages.Interfaces.Components.core.Notifications': 'Notifications',
  'app.pages.Interfaces.Components.core.DynamicHtml': 'HTML Menu',
  'app.pages.Interfaces.Components.core.Filter': 'Filter',
  'app.pages.Interfaces.Components.core.Filters': 'Filters',
  'app.pages.Interfaces.Components.core.ApplyFilters': 'Apply filters',
  'app.pages.Interfaces.Components.core.multiple': 'Multiple',
  'app.pages.Interfaces.Components.core.multiSelect': 'Multiselect',
  'app.pages.Interfaces.Components.core.UploadManager': 'Upload manager',
  'app.pages.Interfaces.Components.core.HtmlVisualization': 'HTML Visualization',
  'app.pages.Interfaces.Components.core.numberOfValuesToDisplayInCell':
    'Number of values to display in cell',
  'app.pages.Interfaces.View.InterfaceName': 'Interface {name}',
  'app.pages.Interfaces.View.share': 'Share',
  'app.pages.Interfaces.View.Empty':
    'Interface is currently empty. Enter edit mode and add a component',
  'app.pages.Interfaces.View.openMenu': 'Open menu',
  'app.pages.Interfaces.Edit': 'Edit interface',
  'app.pages.Interfaces.Edit.Menu.componentConfig': 'Component configuration',
  'app.pages.Interfaces.Edit.Menu.newComponent': 'New component',
  'app.pages.Interfaces.Edit.Menu.title': 'Title',
  'app.pages.Interfaces.Edit.Menu.chartEvents': 'Events',
  'app.pages.Interfaces.Edit.Menu.data': 'Data',
  'app.pages.Interfaces.Edit.Menu.indexSync': 'Index sync',
  'app.pages.Interfaces.Edit.Menu.indexSync.all': 'Sync all indexes',
  'app.pages.Interfaces.Edit.Menu.indexSync.syncedCount': '{synced} of {total} synced',
  'app.pages.Interfaces.Edit.Menu.styleEditor': 'Styles',
  'app.pages.Interfaces.Edit.Menu.icon': 'Icon',
  'app.pages.Interfaces.Edit.Menu.advancedPivot': 'Advanced pivot',
  'app.pages.Interfaces.Edit.Menu.layoutProperties': 'Layout',
  'app.pages.Interfaces.Edit.Menu.valueFormat': 'Value format',
  'app.pages.Interfaces.Edit.Menu.valueFormatSecondaryAxis': 'Value format - Secondary axis',
  'app.pages.Interfaces.Edit.Menu.conditionalFormat': 'Conditional format',
  'app.pages.Interfaces.Edit.Menu.cellProperties': 'Cell properties',
  'app.pages.Interfaces.Edit.Menu.progressBar': 'Progress bar',
  'app.pages.Interfaces.Edit.Menu.heatmap': 'Heatmap',
  'app.pages.Interfaces.Edit.Menu.componentStyle': 'Component',
  'app.pages.Interfaces.Edit.Menu.general': 'General',
  'app.pages.Interfaces.Edit.Menu.scenarios': 'Scenarios',
  'app.pages.Interfaces.Edit.Menu.columnsToShow': 'Columns to show',
  'app.pages.Interfaces.Edit.Menu.scheduledTasksOptions': 'Options',
  'app.pages.Interfaces.Edit.Menu.notificationsOptions': 'Options',
  'app.pages.Interfaces.Edit.Menu.confirmationDialog': 'Confirmation dialog',
  'app.pages.Interfaces.Edit.Menu.showConfirmationDialog': 'Show dialog',
  'app.pages.Interfaces.Edit.Menu.confirmationDialogMessage': 'Message',
  'app.pages.Interfaces.Edit.Menu.editConfirmationDialogMessage': 'Edit message',
  'app.pages.Interfaces.Edit.Menu.confirmationDialogMessageEditorTitle':
    'Confirmation dialog message',
  'app.pages.Interfaces.Edit.Menu.confirmationDialogMessageEmpty':
    'The default message will be shown',
  'app.pages.Interfaces.Edit.Menu.formProperties': 'Form properties',
  'app.pages.Interfaces.Edit.Menu.validations': 'Validations',
  'app.pages.Interfaces.Edit.Menu.inputCubeProperties': 'Input cube properties',
  'app.pages.Interfaces.Edit.selectNode': 'Select a node to create a new component type',
  'app.pages.Interfaces.Edit.nodeType': 'Node type',
  'app.pages.Interfaces.Edit.selectedNodeId': 'Selected node id',
  'app.pages.Interfaces.Edit.refresh': 'Refresh interface',
  'app.pages.Interfaces.Edit.refreshAndReset': 'Refresh interface and restore its view',
  'app.pages.Interfaces.Edit.copy': 'Copy interface',
  'app.pages.Interfaces.Edit.detachSidebar': 'Detach sidebar',
  'app.pages.Interfaces.Edit.fixSidebar': 'Fix sidebar',
  'app.pages.Interfaces.Edit.hidePanel': 'Hide panel',
  'app.pages.Interfaces.Edit.showPanel': 'Show panel',
  'app.pages.Interfaces.Edit.removeComponent': 'Remove component',
  'app.pages.Interfaces.Edit.remove': 'Remove',
  'app.pages.Interfaces.Edit.removeConfirmationText':
    'Are you sure you want to remove this component?',
  'app.pages.Interfaces.Edit.discardUnsavedChanges': 'Discard unsaved changes?',
  'app.pages.Interfaces.Edit.discardUnsavedChangesText':
    'Are you sure you want to discard the unsaved changes?',
  'app.pages.Interfaces.Edit.showInterfaceCode': 'Show interface code',
  'app.pages.Interfaces.Edit.gridSettings': 'Edit grid settings',
  'app.pages.Interfaces.Edit.interfaceCodeEditor': 'Interface code editor',
  'app.pages.Interfaces.Edit.closeComponentCodeEditor': 'Close component code editor',
  'app.pages.Interfaces.Edit.customComponentCode': 'Custom component code',
  'app.pages.Interfaces.Edit.HTMLEditor': 'HTML editor',
  'app.pages.Interfaces.Edit.menuEditor': 'Menu editor',
  'app.pages.Interfaces.Edit.title.enabled': 'Enabled',
  'app.pages.Interfaces.Edit.title.editTitle': 'Edit title',
  'app.pages.Interfaces.Edit.title.customTitle': 'Custom title',
  'app.pages.Interfaces.Edit.table.size.rowsPerPage': 'Rows per page',
  'app.pages.Interfaces.Edit.table.size.columnsPerPage': 'Columns per page',
  'app.pages.Interfaces.Edit.table.data.showRowTotals': 'Show row totals',
  'app.pages.Interfaces.Edit.table.data.rowTotalsPosition': 'Row totals position',
  'app.pages.Interfaces.Edit.table.data.rowTotalsAggregation': 'Row totals aggregation',
  'app.pages.Interfaces.Edit.table.data.showColumnTotals': 'Show column totals',
  'app.pages.Interfaces.Edit.table.data.removeColumnTotals': 'Remove column totals',
  'app.pages.Interfaces.Edit.table.data.removeRowTotals': 'Remove row totals',
  'app.pages.Interfaces.Edit.table.data.columnTotalsPosition': 'Column totals position',
  'app.pages.Interfaces.Edit.table.data.columnTotalsAggregation': 'Column totals aggregation',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationByMember': 'Aggregation by member',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationByMemberHelp':
    'Set the aggregation method per member of each dimension. It is applied to the bottom total when the dimension is in columns and to the right total when it is in rows. The setting is kept when the dimension is moved or hidden.',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationByField': 'Aggregation by field',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationByFieldHelp':
    'Set the bottom total aggregation method per field. Fields without an exception use the general method.',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationFieldsGroup': 'Fields',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationGeneral': 'General',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationNoMembers':
    'The dimension has no members to display.',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationNoDimensions':
    'The table has no dimensions to configure.',
  'app.pages.Interfaces.Edit.table.data.compareScenarios': 'Compare scenarios',
  'app.pages.Interfaces.Edit.table.data.disableCompareScenarios': 'Disable compare scenarios',
  'app.pages.Interfaces.Edit.table.data.compareAllInterfaceScenarios':
    'Compare scenarios across all components',
  'app.pages.Interfaces.Edit.table.data.scenariosPlacement': 'Scenarios placement',
  'app.pages.Interfaces.Edit.table.data.scenariosInRows': 'In rows',
  'app.pages.Interfaces.Edit.table.data.scenariosInColumns': 'In columns',
  'app.pages.Interfaces.Edit.table.data.showValues': 'Show values',
  'app.pages.Interfaces.Edit.table.data.showDifference': 'Show difference',
  'app.pages.Interfaces.Edit.table.data.showPercentageDifference': 'Show percentage difference',
  'app.pages.Interfaces.Edit.table.data.fillMissingWithZero': 'Fill missing values with zero',
  'app.pages.Interfaces.Edit.table.data.fillMissingWithZeroTooltip':
    'Replaces missing values in the selected and base scenarios with 0 before calculating differences.',
  'app.pages.Interfaces.Edit.table.data.zeroDivisionReturnsZero': 'Zero division returns zero',
  'app.pages.Interfaces.Edit.table.data.zeroDivisionReturnsZeroTooltip':
    'For percentage difference only, returns 0 when the base scenario value is 0 instead of dividing by zero.',
  'app.pages.Interfaces.Edit.table.data.differenceEndText': 'Difference end text',
  'app.pages.Interfaces.Edit.table.data.percentageDifferenceEndText':
    'Percentage difference end text',
  'app.pages.Interfaces.Edit.table.data.columnsProperties': 'Columns properties',
  'app.pages.Interfaces.Edit.table.data.hideEmptyData': 'Hide empty data',
  'app.pages.Interfaces.Edit.chart.data.hideEmptyLegend': 'Hide empty legends',
  'app.pages.Interfaces.Edit.chart.data.syncYAxesRange': 'Synchronize Y axes scales',
  'app.pages.Interfaces.Edit.table.data.totalsPositions.end': 'End',
  'app.pages.Interfaces.Edit.table.data.totalsPositions.beginning': 'Beginning',
  'app.pages.Interfaces.Edit.table.data.hideEmptyData.column': 'Column',
  'app.pages.Interfaces.Edit.table.data.hideEmptyData.row': 'Row',
  'app.pages.Interfaces.Edit.table.data.hideEmptyData.both': 'Both',
  'app.pages.Interfaces.Edit.table.data.processingEngine': 'Processing engine',
  'app.pages.Interfaces.Edit.table.data.processingEngine.pandas': 'Pandas',
  'app.pages.Interfaces.Edit.table.data.processingEngine.polars': 'Polars',
  'app.pages.Interfaces.Edit.table.data.showColumnFilterIcon': 'Show column filter icon',
  'app.pages.Interfaces.Edit.table.data.enableQuickPivot': 'Enable quick pivot',
  'app.pages.Interfaces.Edit.table.data.hideFooter': 'Hide footer',
  'app.pages.Interfaces.Edit.table.data.pagination': 'Pagination',
  'app.pages.Interfaces.Edit.table.data.fixedColumns': 'Fixed columns',
  'app.pages.Interfaces.Edit.table.data.subtotalLabel': 'Subtotal label',
  'app.pages.Interfaces.Edit.table.data.subtotalLabelHelperText':
    "Use '{dimension}' as a placeholder for the value. Leave empty to use the default label: '{dimension} - Subtotal'",
  'app.pages.Interfaces.Edit.table.data.showIndex': 'Show "index" column',
  'app.pages.Interfaces.Edit.events.selectedEvent': 'Selection event',
  'app.pages.Interfaces.Edit.events.hoverEvent': 'Hover event',
  'app.pages.Interfaces.Edit.events.drilldownEvent': 'Drilldown event',
  'app.pages.Interfaces.Edit.pivot': 'Pivot',
  'app.pages.Interfaces.Edit.filter': 'Filter',
  'app.pages.Interfaces.Edit.dataHandling': 'Data handling',
  'app.pages.Interfaces.Edit.appliedFiltersOn': 'Applied filters on',
  'app.pages.Interfaces.Edit.appliedConditionFiltersOn': 'Applied condition filters on',
  'app.pages.Interfaces.Edit.appliedNodeFiltersOn': 'Applied node values filters on',
  'app.pages.Interfaces.Edit.isolateStyles': 'Isolate styles',
  'app.pages.Interfaces.Edit.style.fontSize': 'Font size',
  'app.pages.Interfaces.Edit.style.fixedColumnWidth': 'Fixed column width',
  'app.pages.Interfaces.Edit.style.fontStyle': 'Font style',
  'app.pages.Interfaces.Edit.style.fontStyle.bold': 'Bold',
  'app.pages.Interfaces.Edit.style.fontStyle.italic': 'Italic',
  'app.pages.Interfaces.Edit.style.fontStyle.underline': 'Underline',
  'app.pages.Interfaces.Edit.style.fontColor': 'Font color',
  'app.pages.Interfaces.Edit.style.backgroundColor': 'Background color',
  'app.pages.Interfaces.Edit.style.headerBackgroundColor': 'Header background color',
  'app.pages.Interfaces.Edit.style.headerColor': 'Header color',
  'app.pages.Interfaces.Edit.style.textAlign': 'Text align',
  'app.pages.Interfaces.Edit.style.textAlign.left': 'Left',
  'app.pages.Interfaces.Edit.style.textAlign.center': 'Center',
  'app.pages.Interfaces.Edit.style.textAlign.right': 'Right',
  'app.pages.Interfaces.Edit.style.textAlign.justify': 'Justify',
  'app.pages.Interfaces.Edit.style.verticalAlign': 'Vertical align',
  'app.pages.Interfaces.Edit.style.verticalAlign.top': 'Top',
  'app.pages.Interfaces.Edit.style.verticalAlign.middle': 'Middle',
  'app.pages.Interfaces.Edit.style.verticalAlign.bottom': 'Bottom',
  'app.pages.Interfaces.Edit.style.hideHeader': 'Hide header',
  'app.pages.Interfaces.Edit.style.hideBorder': 'Hide border',
  'app.pages.Interfaces.Edit.style.hideMaximizeButton': 'Hide maximize button',
  'app.pages.Interfaces.Edit.style.hidePivotIcon': 'Hide pivot icon',
  'app.pages.Interfaces.Edit.style.showViewAsTableChartIcon': 'Show “View as table/chart” icon',
  'app.pages.Interfaces.Edit.style.showComponentSettingsIcon': 'Show component settings icon',
  'app.pages.Interfaces.Edit.style.note': '(applies in display mode)',
  'app.pages.Interfaces.Edit.style.setDefaultColor': 'Set default color',
  'app.pages.Interfaces.Edit.style.applyAndClose': 'Apply and close',
  'app.pages.Interfaces.Edit.style.seriesColors': 'Series colors',
  'app.pages.Interfaces.Edit.style.colorPalette.increasing': 'Increasing',
  'app.pages.Interfaces.Edit.style.colorPalette.decreasing': 'Decreasing',
  'app.pages.Interfaces.Edit.style.hideCharacters': 'Hide characters',
  'app.pages.Interfaces.Edit.layout.style.axesTitles': 'Axes titles',
  'app.pages.Interfaces.Edit.layout.style.showYAxisTitle': 'Show Y axis title',
  'app.pages.Interfaces.Edit.layout.style.showXAxisTitle': 'Show X axis title',
  'app.pages.Interfaces.Edit.layout.color_palette': 'Color palette',
  'app.pages.Interfaces.Edit.layout.color_palette.color_continuous_scale': 'Continuous scale',
  'app.pages.Interfaces.Edit.layout.color_palette.color_discrete_sequence': 'Discrete sequence',
  'app.pages.Interfaces.Edit.layout.legend': 'Legend',
  'app.pages.Interfaces.Edit.layout.legend.showlegend': 'Show legend',
  'app.pages.Interfaces.Edit.layout.legend.toggleOthersWithSingleClick':
    'Toggle others with single click',
  'app.pages.Interfaces.Edit.layout.legend.coloraxis_showscale': 'Show scale',
  'app.pages.Interfaces.Edit.layout.legend.orientation': 'Orientation',
  'app.pages.Interfaces.Edit.layout.legend.xanchor': 'X anchor point',
  'app.pages.Interfaces.Edit.layout.legend.x': 'X',
  'app.pages.Interfaces.Edit.layout.legend.yanchor': 'Y anchor point',
  'app.pages.Interfaces.Edit.layout.legend.y': 'Y',
  'app.pages.Interfaces.Edit.layout.margins': 'Margins',
  'app.pages.Interfaces.Edit.layout.selectValues.auto': 'Auto',
  'app.pages.Interfaces.Edit.layout.selectValues.left': 'Left',
  'app.pages.Interfaces.Edit.layout.selectValues.center': 'Center',
  'app.pages.Interfaces.Edit.layout.selectValues.right': 'Right',
  'app.pages.Interfaces.Edit.layout.selectValues.top': 'Top',
  'app.pages.Interfaces.Edit.layout.selectValues.middle': 'Middle',
  'app.pages.Interfaces.Edit.layout.selectValues.bottom': 'Bottom',
  'app.pages.Interfaces.Edit.layout.chartMode': 'Chart mode',
  'app.pages.Interfaces.Edit.layout.chartMode.modePreset': 'Mode preset',
  'app.pages.Interfaces.Edit.layout.chartMode.stack': 'Stack',
  'app.pages.Interfaces.Edit.layout.chartMode.relative': 'Relative',
  'app.pages.Interfaces.Edit.layout.chartMode.group': 'Group',
  'app.pages.Interfaces.Edit.layout.chartMode.overlay': 'Overlay',
  'app.pages.Interfaces.Edit.layout.chartMode.barmode': 'Bar mode',
  'app.pages.Interfaces.Edit.layout.chartMode.boxmode': 'Box mode',
  'app.pages.Interfaces.Edit.layout.chartMode.funnelmode': 'Funnel mode',
  'app.pages.Interfaces.Edit.layout.chartMode.violinmode': 'Violin mode',
  'app.pages.Interfaces.Edit.layout.chartMode.waterfallmode': 'Waterfall mode',
  'app.pages.Interfaces.Edit.layout.chartMode.percent': 'Percent',
  'app.pages.Interfaces.Edit.layout.chartNorm': 'Chart norm',
  'app.pages.Interfaces.Edit.layout.chartNorm.barnorm': 'Bar norm',
  'app.pages.Interfaces.Edit.layout.chartNorm.groupnorm': 'Group norm',
  'app.pages.Interfaces.Edit.layout.chartNorm.fraction': 'Fraction',
  'app.pages.Interfaces.Edit.layout.chartNorm.percent': 'Percent',
  'app.pages.Interfaces.Edit.layout.chartNorm.labels': 'Labels',
  'app.pages.Interfaces.Edit.layout.chartNorm.labelsSecondaryAxis': 'Labels - Secondary axis',
  'app.pages.Interfaces.Edit.layout.chartNorm.labels.showLabels': 'Show labels',
  'app.pages.Interfaces.Edit.layout.chartNorm.labels.labelField': 'Field',
  'app.pages.Interfaces.Edit.layout.chartNorm.labels.minSize': 'Minimum size',
  'app.pages.Interfaces.Edit.layout.chartNorm.labels.mode': 'Mode',
  'app.pages.Interfaces.Edit.layout.customSeriesColors': 'Custom series colors',
  'app.pages.Interfaces.Edit.layout.customName': 'Custom name',
  'app.pages.Interfaces.Edit.layout.addValue': 'Add value',
  'app.pages.Interfaces.Edit.layout.addColor': 'Add color',
  'app.pages.Interfaces.Edit.layout.generateValuesFromColumn': 'Generate values from column',
  'app.pages.Interfaces.Edit.layout.y_axis_range': 'Y-axis range',
  'app.pages.Interfaces.Edit.layout.y_axis_range_secondary_axis': 'Y-axis range - Secondary axis',
  'app.pages.Interfaces.Edit.layout.yAxisTitle': 'Y-axis title',
  'app.pages.Interfaces.Edit.layout.xAxisTitle': 'X-axis title',
  'app.pages.Interfaces.Edit.valueFormat.formatPreset': 'Format preset',
  'app.pages.Interfaces.Edit.valueFormat.number': 'Number',
  'app.pages.Interfaces.Edit.valueFormat.decimal': 'Decimal',
  'app.pages.Interfaces.Edit.valueFormat.integer': 'Integer',
  'app.pages.Interfaces.Edit.valueFormat.percent': 'Percent',
  'app.pages.Interfaces.Edit.valueFormat.currency': 'Currency',
  'app.pages.Interfaces.Edit.valueFormat.currencyRounded': 'Currency (rounded)',
  'app.pages.Interfaces.Edit.valueFormat.accounting': 'Accounting',
  'app.pages.Interfaces.Edit.valueFormat.accountingRounded': 'Accounting (rounded)',
  'app.pages.Interfaces.Edit.valueFormat.finance': 'Finance',
  'app.pages.Interfaces.Edit.valueFormat.financeRounded': 'Finance (rounded)',
  'app.pages.Interfaces.Edit.valueFormat.showNegativeInParentheses':
    'Show negative numbers in parentheses',
  'app.pages.Interfaces.Edit.valueFormat.date': 'Date',
  'app.pages.Interfaces.Edit.valueFormat.datetime': 'Date time',
  'app.pages.Interfaces.Edit.valueFormat.general': 'General',
  'app.pages.Interfaces.Edit.valueFormat.thousandsSeparator': 'Thousands separator',
  'app.pages.Interfaces.Edit.valueFormat.decimalPlaces': 'Decimals',
  'app.pages.Interfaces.Edit.valueFormat.prefix': 'Prefix',
  'app.pages.Interfaces.Edit.valueFormat.suffix': 'Suffix',
  'app.pages.Interfaces.Edit.valueFormat.dateFormat': 'Date format',
  'app.pages.Interfaces.Edit.valueFormat.datetimeFormat': 'Datetime format',
  'app.pages.Interfaces.Edit.valueFormat.seePatternReference': 'See pattern reference',
  'app.pages.Interfaces.Run.runningButton': 'Running button',
  'app.pages.Interfaces.Edit.editTitle.showUnits': 'Show units',
  'app.pages.Interfaces.Edit.progressBar.applyProgressBar': 'Apply progress bar',
  'app.pages.Interfaces.Edit.progressBar.max_value': 'Max value',
  'app.pages.Interfaces.Edit.progressBar.min_hue': 'Min hue',
  'app.pages.Interfaces.Edit.progressBar.max_hue': 'Max hue',
  'app.pages.Interfaces.Edit.progressBar.saturation': 'Saturation',
  'app.pages.Interfaces.Edit.progressBar.lightness': 'Lightness',
  'app.pages.Interfaces.Edit.progressBar.show_value': 'Show value',
  'app.pages.Interfaces.Edit.heatmap.applyHeatmap': 'Apply heatmap',
  'app.pages.Interfaces.Edit.heatmap.by': 'By',
  'app.pages.Interfaces.Edit.heatmap.hex_base_background_color': 'Base background color',
  'app.pages.Interfaces.Edit.heatmap.hex_text_color': 'Text color',
  'app.pages.Interfaces.Edit.heatmap.exclude_nans': 'Exclude NaNs',
  'app.pages.Interfaces.Edit.heatmap.exclude_right_total': 'Exclude row totals',
  'app.pages.Interfaces.Edit.heatmap.exclude_bottom_total': 'Exclude column totals',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor': 'Heatmap color',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.red_green_alt': 'red-green-alt',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.green_red_alt': 'green-red-alt',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.red_green': 'red-green',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.green_red': 'green-red',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.red_white': 'red-white',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.white_red': 'white-red',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.white_green': 'white-green',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.green_white': 'green-white',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.green_blue': 'green-blue',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.blue_green': 'blue-green',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.red_blue': 'red-blue',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.blue_red': 'blue-red',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.custom': 'Custom',
  'app.pages.Interfaces.Edit.conditionalFormat.addCondition': 'Add condition',
  'app.pages.Interfaces.Edit.conditionalFormat.deleteAll': 'Delete all',
  'app.pages.Interfaces.Edit.conditionalFormat.Conditions': 'Conditions',
  'app.pages.Interfaces.Edit.conditionalFormat.showIconOnly': 'Show icon only',
  'app.pages.Interfaces.Edit.conditionalFormat.expressionInfo1':
    'Enter an expression where each column name is enclosed with # at the beginning and end. All column names used must exist in the final table.',
  'app.pages.Interfaces.Edit.conditionalFormat.expressionInfo2':
    'The expression must always return a boolean series.',
  'app.pages.Interfaces.Edit.conditionalFormat.expressionInfo3': 'For example:',
  'app.pages.Interfaces.Edit.style.addNewStyle': 'Add new style',
  'app.pages.Interfaces.Edit.style.deleteStyle': 'Delete style',
  'app.pages.Interfaces.Edit.style.editStyle': 'Edit style',
  'app.pages.Interfaces.Edit.style.dimensionName': 'Dimension name',
  'app.pages.Interfaces.Edit.style.filterType': 'Filter type',
  'app.pages.Code.Diagram.Wizards.styleConditions': 'Style conditions',
  'app.pages.Interfaces.Edit.colorPicker.themeColors': 'Theme colors',
  'app.pages.Interfaces.Edit.colorPicker.standardColors': 'Standard colors',
  'app.pages.Interfaces.Edit.colorPicker.recentColors': 'Recent colors',
  'app.pages.Interfaces.Edit.colorPicker.selectedColor': 'Selected color',
  'app.pages.Interfaces.Edit.leaveInterfaceTitle': 'Interface with unconfirmed changes',
  'app.pages.Interfaces.Edit.leaveInterfaceContent':
    'Do you want to confirm changes or discard them?',
  'app.pages.Interfaces.Edit.inputNodeProperties.hideIdColumn': 'Hide ID column',
  'app.pages.Interfaces.Edit.inputNodeProperties.confirmOnChange': 'Confirm on change',
  'app.pages.Interfaces.Edit.inputNodeProperties.invalidateOutputsOnChange':
    'Invalidate outputs on change',
  'app.pages.Interfaces.Edit.inputNodeProperties.invalidateOutputsOnConfirm':
    'Invalidate outputs on confirm',
  'app.pages.Interfaces.Edit.inputNodeProperties.updateCalcColumnsOnChange':
    'Update calculated columns on change',
  'app.pages.Interfaces.Edit.inputNodeProperties.updateCalcColumnsOnConfirm':
    'Update calculated columns on confirm',
  'app.pages.Interfaces.Edit.inputNodeProperties.showSelectColumnsIcon': 'Show Select columns icon',
  'app.pages.Interfaces.Edit.inputNodeProperties.showEditExcelIcon': 'Show Edit in Excel icon',
  'app.pages.Interfaces.Edit.inputNodeProperties.showRefreshIcon': 'Show Refresh data icon',
  'app.pages.Interfaces.Edit.inputNodeProperties.showHistoryIcon': 'Show Data history icon',
  'app.pages.Interfaces.Edit.inputNodeProperties.newRowsPosition': 'New rows position',
  'app.pages.Interfaces.Edit.filterIndexValues': 'Filter index values',
  'app.pages.Interfaces.Edit.filterIndexValues.fromToError':
    'The "From" value should be less than or equal to the "To" value.',
  'app.pages.Interfaces.Edit.style.applyConditionTo': 'Apply condition to',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.customView': 'Custom view',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.customViewWithName': 'Custom view: {name}',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.editingCustomView':
    'You are editing the custom view "{name}"',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.originalView': 'Original view',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.myView': 'My view',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.opensByDefault': 'Opens by default',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.openByDefault': 'Open this view by default',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.saveChangesInView': 'Save changes to "{name}"',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.saveAsNewView': 'Save as new view…',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.newView': 'New custom view',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.editView': 'Edit custom view',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.deleteViewConfirm':
    'Delete the custom view "{name}"?',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.deleteCustomView': 'Delete custom view',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.customViewSaved':
    'The custom view of the interface has been saved successfully',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.customViewDeleted':
    'The custom view of the interface has been deleted successfully',
  'app.pages.Interfaces.components.options.showPivotArea': 'Show pivot area',
  'app.pages.Interfaces.components.options.hidePivotArea': 'Hide pivot area',
  'app.pages.app.properties.componentOptions': 'Component options',

  //Instance manager
  'app.pages.managers.instances': 'Instances',
  'app.pages.app.instanceManager.noInstances': 'There are no instances',
  'app.pages.app.instanceManager.open': 'Open',
  'app.pages.app.instanceManager.currentApplication': 'Current application',
  'app.pages.app.instanceManager.active': 'Active',
  'app.pages.app.instanceManager.timeoutIn': 'Timeout in',
  'app.pages.app.instanceManager.minutes': ' min',
  'app.pages.app.instanceManager.cpu': 'CPU',
  'app.pages.app.instanceManager.memory': 'Memory',
  'app.pages.app.instanceManager.peak': 'Peak',
  'app.pages.app.instanceManager.apiResources': `Application's resources`,
  'app.pages.app.instanceManager.systemMemory': 'Total',
  'app.pages.app.instanceManager.inUse': 'In use',
  'app.pages.app.instanceManager.disk': 'Disk',
  'app.pages.app.instanceManager.time': 'Time',
  'app.pages.app.instanceManager.selectedInstance': 'Selected instance',
  'app.pages.app.instanceManager.pid': 'PID',
  'app.pages.app.instanceManager.memoryPeak': 'Memory peak',
  'app.pages.app.instanceManager.lastProcessedNode': 'Last processed node',
  'app.pages.app.instanceManager.requireLogoutTitle': 'Logout required',
  'app.pages.app.instanceManager.requireLogoutMessage':
    'Are you sure you want to send a request for logout?',
  'app.pages.app.instanceManager.killInstanceTitle': 'Kill instance',
  'app.pages.app.instanceManager.killInstanceMessage':
    'Unsaved instance data will be lost. Are you sure?',
  'app.pages.app.instanceManager.requestSent': 'Request sent',
  'app.pages.app.instanceManager.instanceClosed': 'Instance closed',
  'app.pages.app.instanceManager.editionAvailable': 'Edition available',
  'app.pages.app.instanceManager.processing': 'Processing',
  'app.pages.app.instanceManager.info': 'Info',
  'app.pages.app.instanceManager.openAppsOnly': 'Open apps only',
  'app.pages.app.instanceManager.noSelectedInstance': 'There is no selected instance',
  'app.pages.app.instanceManager.scheduledTask': 'Scheduled task',
  'app.pages.app.instanceManager.hasOpenedBrowser': 'Has opened browser',
  'app.pages.app.instanceManager.yourInstanceIsAboutToExpire': 'Your instance is about to expire',
  'app.pages.app.instanceManager.pressConfirmToExtendYourInstance':
    'Press confirm to extend your instance',
  'app.pages.app.instanceManager.yourInstanceHasBeenExtended': 'Your instance has been extended',
  'app.pages.app.instanceManager.cpuArchitecture': 'Architecture',
  'app.pages.app.instanceManager.userOrigin': 'Origin',
  'app.pages.app.instanceManager.internalUser': 'Internal',
  'app.pages.app.instanceManager.externalUser': 'External',
  'app.pages.app.instanceManager.agentUser': 'Agent',
  'app.pages.app.instanceManager.poolOrigin': 'Pool',
  'app.pages.app.instanceManager.poolForUser': 'Pool {user}',
  'app.pages.app.instanceManager.noFilteredInstances': 'No instances match the filters',
  'app.pages.app.instanceManager.lastUpdate': 'Last update: {lastUpdate}',
  'app.pages.app.instanceManager.useOfMemoryAndCPUByPOD': 'Use of CPU and Memory by POD',
  'app.pages.app.instanceManager.restartPodsInfo': 'Clear Pods CPU/Memory usage data',
  'app.pages.app.instanceManager.totalByPod': 'Total by pod',

  //Log manager
  'app.pages.managers.logs': 'Logs',
  'app.pages.managers.logManager.startDate': 'Start date',
  'app.pages.managers.logManager.endDate': 'End date',
  'app.pages.managers.logManager.instanceKey': 'Instance',
  'app.pages.managers.logManager.podName': 'Pod',
  'app.pages.managers.logManager.user': 'User',
  'app.pages.managers.logManager.user.notFound': 'User not found',
  'app.pages.managers.logManager.user.selectUser': 'Select or search an user',
  'app.pages.managers.logManager.action': 'Action',
  'app.pages.managers.logManager.action.notFound': 'Action not found',
  'app.pages.managers.logManager.action.selectAction': 'Select or search an action',
  'app.pages.managers.logManager.model': 'Model',
  'app.pages.managers.logManager.reportDownloaded': 'Report downloaded',
  'app.pages.managers.logManager.clearFilters': 'Clear filters',
  'app.pages.managers.logManager.filter': 'Filter',
  'app.pages.managers.logManager.table.date': 'Date',
  'app.pages.managers.logManager.table.query': 'Query',
  'app.pages.managers.logManager.table.body': 'Body',
  'app.pages.managers.logManager.table.podName': 'Pod',
  'app.pages.managers.logManager.table.memory': 'Memory (MB)',
  'app.pages.managers.logManager.appOrQuery': 'App or query',
  'app.pages.managers.logManager.lastHour': 'Last hour',
  'app.pages.managers.logManager.last24Hours': 'Last 24 hours',
  'app.pages.managers.logManager.last7Days': 'Last 7 days',
  'app.pages.managers.logManager.rangeError':
    'This range is {range} days. Choose up to {days} days.',
  'app.pages.managers.logManager.rangeOrderError': '"To" must be later than "From".',
  'app.pages.managers.logManager.empty.title': 'No requests match these filters',
  'app.pages.managers.logManager.empty.hint':
    'Nothing was logged for this combination between {range}. Try widening the date range or removing a filter.',
  'app.pages.managers.logManager.rangeFrom': 'From',
  'app.pages.managers.logManager.rangeTo': 'To',
  'app.pages.managers.logManager.rangeHelper': 'Up to {days} days',
  'app.pages.managers.logManager.downloadCsv': 'Download CSV',
  'app.pages.managers.logManager.filtering': 'Filtering…',
  'app.pages.managers.logManager.detail.title': 'Request details',
  'app.pages.managers.logManager.detail.properties': 'Properties',
  'app.pages.managers.logManager.detail.company': 'Company',
  'app.pages.managers.logManager.detail.appVersion': 'App version',
  'app.pages.managers.logManager.detail.noQuery': 'No query parameters were sent.',
  'app.pages.managers.logManager.detail.noBody': 'No body was sent.',
  'app.pages.managers.logManager.detail.clientAndServer': 'Client and server',
  'app.pages.managers.logManager.detail.ip': 'IP address',
  'app.pages.managers.logManager.detail.browser': 'Browser',
  'app.pages.managers.logManager.detail.os': 'Operating system',
  'app.pages.managers.logManager.detail.device': 'Device',
  'app.pages.managers.logManager.detail.sessionDuration': 'Session duration',
  'app.pages.managers.logManager.detail.onlyThisUser': "Show only this user's requests",
  'app.pages.managers.instanceLogs': 'Instance logs',
  'app.pages.managers.instanceLogs.userOrInstance': 'User or instance id',
  'app.pages.managers.instanceLogs.pleaseSelectLog':
    'Select a log from the table to view its details',
  'app.pages.managers.instanceLogs.emptyLog': 'Empty log',
  'app.pages.managers.instanceLogs.copyLog': 'Copy log',
  'app.pages.managers.instanceLogs.logCopied': 'Log copied',
  'app.pages.managers.instanceLogs.searchInLogs': 'Search in logs',
  'app.pages.managers.instanceLogs.searchInLogs.notFound': 'No match found for: {text}',

  // App documentation
  'app.pages.managers.appDocumentation': 'Documentation',
  'app.pages.managers.appDocumentation.includeInterfaces': 'Include interfaces',
  'app.pages.managers.appDocumentation.uploadingDocumentation': 'Uploading documentation',
  'app.pages.managers.appDocumentation.uploadSuccess': 'Documentation uploaded successfully',
  'app.pages.managers.appDocumentation.includeNodes': 'Include nodes',
  'app.pages.managers.appDocumentation.generateAutomatically': 'Generate automatically',
  'app.pages.managers.appDocumentation.generating': 'Generating application documentation...',
  'app.pages.managers.appDocumentation.options.title': 'Generate documentation',
  'app.pages.managers.appDocumentation.options.description':
    'By default every interface in the application is documented. Optionally, restrict this run to a subset of interfaces and/or add extra instructions for the documenter agent.',
  'app.pages.managers.appDocumentation.options.interfaces': 'Interfaces to document (optional)',
  'app.pages.managers.appDocumentation.options.extraInstructions': 'Extra instructions (optional)',
  'app.pages.managers.appDocumentation.options.extraInstructionsPlaceholder':
    'E.g. focus on the sales module, use a formal tone, skip the overview section...',

  // Documenter agents
  'app.pages.documentation.documentAutomatically': 'Generate documentation automatically',
  'app.pages.documentation.generateDocumentation': 'Generate documentation',
  'app.pages.documentation.generatingDocumentation': 'Generating documentation...',
  'common.documentationGenerated': 'Documentation generated successfully',
  'common.documentation.languageRequired':
    'The application must have a default language configured to generate documentation automatically',
  'app.pages.Code.Diagram.ContextMenu.documentNode': 'Document node',
  'app.pages.Code.Diagram.ContextMenu.documentModule': 'Document module',
  'app.pages.Code.Diagram.ContextMenu.documentSelectedNodes': 'Document {count} selected nodes',
  'app.pages.Code.Diagram.ContextMenu.documentSelectedModules': 'Document {count} selected modules',
  'app.pages.Code.Diagram.documentingSelectedNodes': 'Documenting nodes',
  'app.pages.Code.Diagram.documentingSelectedModules': 'Documenting modules',
  'app.pages.Code.Diagram.ContextMenu.documentOptions': 'Document diagram',
  'app.pages.interfaceManager.htmlInterfaceType': 'HTML',
  'app.pages.interfaceManager.documentAllInterfaces': 'Document all interfaces',
  'app.pages.interfaceManager.documentingInterfaces': 'Documenting interfaces',
  'app.pages.interfaceManager.documentSelectedInterfaces': 'Document {count} selected interfaces',
  'app.pages.interfaceManager.documentInterface': 'Document interface',
  'app.pages.interfaceManager.documentFolderContent': 'Document folder interfaces',
  'app.pages.interfaceManager.documentSelectedFoldersContent':
    'Document content of {count} selected folders',
  'app.pages.interfaceManager.documentFolder.scope.direct':
    'Only interfaces directly in the selected folder(s)',
  'app.pages.interfaceManager.documentFolder.scope.recursive':
    'Interfaces in the selected folder(s) and every sub-folder (recursive)',
  'app.pages.moduleDocumentation.dialogTitle': 'Document module',
  'app.pages.moduleDocumentation.dialogTitle.multi': 'Document {count} modules',
  'app.pages.moduleDocumentation.generating':
    'Automatic module documentation is being generated. This may take a few seconds.',
  'app.pages.moduleDocumentation.generating.multi':
    'Automatic documentation for {count} modules is being generated. This may take a few seconds.',
  'app.pages.moduleDocumentation.scope.moduleOnly': 'Module only (based on its child nodes)',
  'app.pages.moduleDocumentation.scope.moduleAndNodes': 'Module and direct child nodes',
  'app.pages.moduleDocumentation.scope.moduleAndNodesRecursive':
    'Module, child nodes and inner modules (recursive)',
  'app.pages.documentation.options.mode.label': 'How should existing documentation be handled?',
  'app.pages.documentation.options.mode.overwrite': 'Overwrite existing documentation',
  'app.pages.documentation.options.mode.missingOnly':
    'Only document items without existing documentation',
  'app.pages.documentation.options.scope.label': 'Scope',
  'app.pages.documentation.error.generic': 'Documentation generation failed.',
  'app.pages.documentCurrentView.scope.nodesOnly': 'Only direct nodes in this view diagram',
  'app.pages.documentCurrentView.scope.includeModules':
    'Direct nodes and the modules in this view diagram',
  'app.pages.documentCurrentView.scope.recursive':
    'Direct nodes, modules and their content (recursive)',

  //Interface toolbar
  'app.pages.interfaces.toolbar.cancel': 'Cancel',
  'app.pages.interfaces.toolbar.mode': 'Mode',
  'app.pages.interfaces.toolbar.hideMinMaxLabels': 'Hide min and max labels',
  'app.pages.interfaces.toolbar.mode.single': 'Single select',
  'app.pages.interfaces.toolbar.mode.multi': 'Multi select',
  'app.pages.interfaces.toolbar.format': 'Format',
  'app.pages.interfaces.toolbar.menu.alignment': 'Alignment',
  'app.pages.interfaces.toolbar.format.small': 'Small',
  'app.pages.interfaces.toolbar.format.hidden': 'Hidden',
  'app.pages.interfaces.toolbar.format.range': 'Range',
  'app.pages.interfaces.toolbar.format.select': 'Select',
  'app.pages.interfaces.toolbar.format.radio': 'Radio',
  'app.pages.interfaces.toolbar.format.slider': 'Slider',
  'app.pages.interfaces.toolbar.format.options_list': 'Options list',
  'app.pages.interfaces.toolbar.format.selectable_chips': 'Selectable chips',
  'app.pages.interfaces.toolbar.orientation': 'Orientation',
  'app.pages.interfaces.toolbar.orientation.horizontal': 'Horizontal',
  'app.pages.interfaces.toolbar.orientation.vertical': 'Vertical',
  'app.pages.interfaces.toolbar.chartType': 'Chart type',
  'app.pages.interfaces.toolbar.chartSubtype': 'Chart subtype',
  'app.pages.interfaces.toolbar.chartType.bar': 'Bar',
  'app.pages.interfaces.toolbar.chartType.column': 'Column',
  'app.pages.interfaces.toolbar.chartType.normal': 'Normal',
  'app.pages.interfaces.toolbar.chartType.stacked': 'Stacked',
  'app.pages.interfaces.toolbar.chartType.percentStacked': 'Percent stacked',
  'app.pages.interfaces.toolbar.chartType.line': 'Line',
  'app.pages.interfaces.toolbar.chartType.linesOnly': 'Lines only',
  'app.pages.interfaces.toolbar.chartType.linesAndPoints': 'Lines and points',
  'app.pages.interfaces.toolbar.chartType.pointsOnly': 'Points only',
  'app.pages.interfaces.toolbar.chartType.pie': 'Pie',
  'app.pages.interfaces.toolbar.chartType.donut': 'Donut',
  'app.pages.interfaces.toolbar.chartType.sunburst': 'Sunburst',
  'app.pages.interfaces.toolbar.chartType.area': 'Area',
  'app.pages.interfaces.toolbar.chartType.percent': 'Percent',
  'app.pages.interfaces.toolbar.chartType.scatter': 'Scatter',
  'app.pages.interfaces.toolbar.chartType.combined': 'Combined',
  'app.pages.interfaces.toolbar.chartType.scatterWithTrendline': 'Scatter with trendline',
  'app.pages.interfaces.toolbar.chartType.others': 'Others',
  'app.pages.interfaces.toolbar.chartType.waterfall': 'Waterfall',
  'app.pages.interfaces.toolbar.chartType.funnel': 'Funnel',
  'app.pages.interfaces.toolbar.chartType.timeline': 'Timeline',
  'app.pages.interfaces.toolbar.chartType.treemap': 'Treemap',
  'app.pages.interfaces.toolbar.chartType.icicle': 'Icicle',
  'app.pages.interfaces.toolbar.chartType.funnelArea': 'Funnel area',
  'app.pages.interfaces.toolbar.chartType.histogram': 'Histogram',
  'app.pages.interfaces.toolbar.chartType.box': 'Box',
  'app.pages.interfaces.toolbar.chartType.violin': 'Violin',
  'app.pages.interfaces.toolbar.chartType.strip': 'Strip',
  'app.pages.interfaces.toolbar.chartType.densityHeatmap': 'Density heatmap',
  'app.pages.interfaces.toolbar.chartType.densityContour': 'Density contour',
  'app.pages.interfaces.toolbar.chartType.scatter3d': 'Scatter 3D',
  'app.pages.interfaces.toolbar.chartType.line3d': 'Line 3D',
  'app.pages.interfaces.toolbar.chartType.scatterMatrix': 'Scatter matrix',
  'app.pages.interfaces.toolbar.chartType.parallelCoordinates': 'Parallel coordinates',
  'app.pages.interfaces.toolbar.chartType.parallelCategories': 'Parallel categories',
  'app.pages.interfaces.toolbar.chartType.scatterMapbox': 'Scatter mapbox',
  'app.pages.interfaces.toolbar.chartType.lineMapbox': 'Line mapbox',
  'app.pages.interfaces.toolbar.chartType.choroplethMapbox': 'Choropleth mapbox',
  'app.pages.interfaces.toolbar.chartType.densityMapbox': 'Density mapbox',
  'app.pages.interfaces.toolbar.chartType.scatterPolar': 'Scatter polar',
  'app.pages.interfaces.toolbar.chartType.linePolar': 'Line polar',
  'app.pages.interfaces.toolbar.chartType.barPolar': 'Bar polar',
  'app.pages.interfaces.toolbar.chartType.scatterTernary': 'Scatter ternary',
  'app.pages.interfaces.toolbar.chartType.lineTernary': 'Line ternary',
  'app.pages.interfaces.toolbar.chartType.groups.basics': 'Basics',
  'app.pages.interfaces.toolbar.chartType.groups.financial': 'Financial',
  'app.pages.interfaces.toolbar.chartType.groups.partOfWhole': 'Part-of-whole',
  'app.pages.interfaces.toolbar.chartType.groups.1dDistributions': '1D distributions',
  'app.pages.interfaces.toolbar.chartType.groups.2dDistributions': '2D distributions',
  'app.pages.interfaces.toolbar.chartType.groups.3dimensional': '3-Dimensional',
  'app.pages.interfaces.toolbar.chartType.groups.multidimensional': 'Multidimensional',
  'app.pages.interfaces.toolbar.chartType.groups.tileMaps': 'Tile maps',
  'app.pages.interfaces.toolbar.chartType.groups.polarCharts': 'Polar charts',
  'app.pages.interfaces.toolbar.chartType.groups.ternaryCharts': 'Ternary charts',
  'app.pages.interfaces.toolbar.showComponentCode': 'Show component code',
  'app.pages.interfaces.toolbar.openComponentCode': 'Open component code',
  'app.pages.interfaces.toolbar.clearFilters': 'Clear filters',
  'app.pages.interfaces.toolbar.componentCodeEditor': 'Component code editor',
  'app.pages.interfaces.toolbar.menuFormat': 'Menu format',
  'app.pages.interfaces.toolbar.menuFormat.accordion': 'Accordion',
  'app.pages.interfaces.toolbar.menuFormat.compact_menu': 'Compact menu',
  'app.pages.interfaces.toolbar.menuFormat.boxes': 'Boxes',
  'app.pages.interfaces.toolbar.menuFormat.mini': 'Mini',
  'app.pages.interfaces.toolbar.menu.newItem': 'New item',
  'app.pages.interfaces.toolbar.menu.newAction': 'New action',
  'app.pages.interfaces.toolbar.menu.addItem': 'Add menu item',
  'app.pages.interfaces.toolbar.menu.addAction': 'Add action',
  'app.pages.interfaces.toolbar.menu.removeItem': 'Remove item',
  'app.pages.interfaces.toolbar.menu.removeAction': 'Remove action',
  'app.pages.interfaces.toolbar.menu.root': 'Root',
  'app.pages.interfaces.toolbar.menu.actionType': 'Action type',
  'app.pages.interfaces.toolbar.menu.navigateTo': 'Navigate to',
  'app.pages.interfaces.toolbar.menu.target': 'Target',
  'app.pages.interfaces.toolbar.menu.customPath': 'Custom Path',
  'app.pages.interfaces.toolbar.menu.manualPath': 'Enter path manually',
  'app.pages.interfaces.toolbar.menu.currentTab': 'Current tab',
  'app.pages.interfaces.toolbar.menu.newTab': 'New tab',
  'app.pages.interfaces.toolbar.menu.expanded': 'Expanded',
  'app.pages.interfaces.toolbar.menu.subtitle': 'Subtitle',
  'app.pages.interfaces.toolbar.menu.openInterface': 'Open interface',
  'app.pages.interfaces.toolbar.menu.navigate': 'Navigate',
  'app.pages.interfaces.toolbar.menu.textColor': 'Text color',
  'app.pages.interfaces.toolbar.menu.iconColor': 'Icon color',
  'app.pages.interfaces.toolbar.menu.backgroundColor': 'Background color',
  'app.pages.interfaces.toolbar.menu.hoverColor': 'Hover color',
  'app.pages.interfaces.toolbar.menu.textTranslations': 'Text translations',
  'app.pages.interfaces.toolbar.menu.subtitleTranslations': 'Subtitle translations',
  'app.pages.interfaces.toolbar.menu.customTitleTranslations': 'Custom title translations',
  'app.pages.interfaces.componentHasCustomCodeMessage':
    'This component has custom code, which may prevent certain settings from being applied.',
  'app.pages.interfaces.toolbar.openHtmlEditor': 'Open HTML editor',
  'app.pages.interfaces.toolbar.openDynamicHtmlEditor': 'Open dynamic HTML editor',
  'app.pages.interfaces.toolbar.dynamicHtmlCustomization': 'Dynamic HTML customization',
  'app.pages.interfaces.toolbar.selectSectionToGo': 'Select section to go',
  'app.pages.interfaces.toolbar.selectRunAppNode': 'Select run app node',
  'app.pages.interfaces.toolbar.openInNewTab': 'Open in new tab',
  'app.pages.interfaces.toolbar.openMenuEditor': 'Open menu editor',
  'app.pages.interfaces.toolbar.autoOpenSingleAction': 'Automatically open single action',
  'app.pages.interfaces.toolbar.showSearchInput': 'Show search input',
  'app.pages.interfaces.toolbar.exportComponent': 'Export component',
  'app.pages.interfaces.toolbar.fileFormat': 'File format',
  'app.pages.interfaces.toolbar.numberFormat': 'Number format',
  'app.pages.interfaces.toolbar.exportShape': 'Layout',
  'app.pages.interfaces.toolbar.exportShapeSeen': 'As seen',
  'app.pages.interfaces.toolbar.exportShapeList': 'List (one row per figure)',
  'app.pages.interfaces.tableSheet.failed': 'Could not download the table as a sheet',
  'app.pages.interfaces.tableSheet.failedBecause':
    'Could not download the table as a sheet: {reason}',
  'app.pages.interfaces.tableSheet.linkedName': '{title} (linked)',
  'app.pages.interfaces.tableSheet.openDownloaded': 'Open the downloaded file with Excel',
  'app.pages.interfaces.toolbar.exportIncludeTotals': 'Include subtotals and totals',
  'app.pages.interfaces.toolbar.exportKeepFormats': 'Keep number formats ($, %, decimals)',
  'app.pages.interfaces.toolbar.columnSeparator': 'Column separator',
  'app.pages.interfaces.toolbar.compressToDownload': 'Compress file to download',
  'app.pages.interfaces.toolbar.excludeNullAndZero': 'Exclude null and zero values',
  'app.pages.interfaces.toolbar.fullNode': 'Full node',
  'app.pages.interfaces.toolbar.currentView': 'Current view',
  'app.pages.interfaces.toolbar.useTitlesInExport': 'Use visible column names',
  'app.pages.interfaces.toolbar.includeNestedHeaders': 'Include all header levels',
  'app.pages.interfaces.toolbar.fileName': 'File name',
  'app.pages.interfaces.toolbar.multiline': 'Multiline',
  'app.pages.interfaces.toolbar.uppercase': 'Uppercase',
  'app.pages.interfaces.toolbar.fixedPositionOnTop': 'Fixed position on top',
  'app.pages.interfaces.toolbar.stickyHeader': 'Sticky header',
  'app.pages.interfaces.toolbar.openFilterEditor': 'Open filter editor',
  'app.pages.interfaces.toolbar.visibilityController': 'Visibility controller',
  'app.pages.interfaces.toolbar.buttonFormat.default': 'Full container',
  'app.pages.interfaces.toolbar.buttonFormat.compact': 'Compact',
  'app.pages.interfaces.chart': 'Chart',
  'app.pages.interfaces.indicator': 'Indicator',
  'app.pages.interfaces.interfaceDeleted': 'Interface deleted',
  'app.pages.interfaces.folderDeleted': 'Folder deleted',
  'app.pages.interfaces.interfaceDuplicated': 'Interface duplicated',
  'app.pages.interfaces.folderDuplicated': 'Folder duplicated',
  'app.pages.interfaces.viewAsChart': 'View as chart',
  'app.pages.interfaces.viewAsTable': 'View as table',
  'app.pages.interfaces.defaultInterface': 'Default interface',
  'app.pages.interfaces.tooManyComponents':
    'This interface contains a large number of components. Consider splitting it into smaller views to improve organization and maintainability.',
  'app.pages.interfaces.closeAllTabs': 'Close all tabs',
  'app.pages.interfaces.noTabsOpened': 'There are no more tabs open',
  'app.pages.interfaces.closeSelectedTab': 'Close selected tab',
  'app.pages.interfaces.openTabActions': 'Open tab actions',
  'app.pages.interfaces.compareAllScenarios': 'Compare scenarios in all components',
  'app.pages.interfaces.openDefaultInterface': 'Open default interface',
  'app.pages.interfaces.closeAllButThis': 'Close all but this',
  'app.pages.interfaces.importInterface': 'Import interfaces or folders',
  'app.pages.interfaces.interfaceImportedSuccessfully': 'Import completed successfully',
  'app.pages.interfaces.exportInterfaceSuccess': 'Interface exported successfully',
  'app.pages.interfaces.exportInterfacesSuccess': 'Interfaces exported successfully',
  'app.pages.interfaces.exportFolderSuccess': 'Folder exported successfully',
  'app.pages.interfaces.exportFoldersSuccess': 'Folders exported successfully',
  'app.pages.interfaces.interfaceCopied': 'Interface copied successfully',
  'app.pages.interfaces.interfaceMoved': 'Interface moved successfully',
  'app.pages.interfaces.deleteFolder': 'Delete folder',
  'app.pages.interfaces.deleteInterfaces': 'Delete interfaces',
  'app.pages.interfaces.folderCopied': 'Folder copied successfully',
  'app.pages.interfaces.folderMoved': 'Folder moved successfully',
  'app.pages.interfaces.interfacePermissionChanged': 'Interface permissions changed',
  'app.pages.interfaces.htmlPreview': 'HTML preview',
  'app.pages.interfaces.attribute': 'Attribute',
  'app.pages.interfaces.attributeValue': 'Attribute value',
  'app.pages.interfaces.typeActionValue': 'Type action value',
  'app.pages.interfaces.typeActionValue.modifyTypeActionValue': 'Modify type action value',
  'app.pages.interfaces.runAppNode': 'Run app node',
  'app.pages.interfaces.sendHtmlAttributeToNode': 'Send HTML attribute to node',
  'app.pages.interfaces.attributesFromNode': 'Attributes from node',
  'app.pages.interfaces.childrenFromNode': 'Children from node',
  'app.pages.interfaces.addNodeResultLikeChildren': 'Add node result like children element',
  'app.pages.interfaces.getAttributesFromNode': 'Get attributes from node',
  'app.pages.interfaces.selectNodeToReceiveHtmlAttribute':
    'Select the node that will receive the HTML attribute',
  'app.pages.interfaces.sourceAttribute': 'HTML attribute',
  'app.pages.interfaces.functionParameter': 'Function parameter',
  'app.pages.interfaces.targetAttribute': 'Target attribute',
  'app.pages.interfaces.targetAttributeValue': 'Target attribute value',
  'app.pages.interfaces.toolbar.runNodeToPreviewResult': 'Run node to preview result',
  'app.pages.interfaces.toolbar.insertHereYourHtmlCode': 'Insert here your HTML code',
  'app.pages.interfaces.toolbar.previewAvailableAfterTypingCode':
    'Preview available after typing code',
  'app.pages.interfaces.toolbar.runPreviewHtml': 'Run preview HTML',
  'app.pages.interfaces.htmlEditor.inlineChangedOtherPart':
    'The agent only changed the {part} tab.',
  'app.pages.interfaces.toolbar.inputValue.dataType': 'Data type',
  'app.pages.interfaces.toolbar.inputValue.rule': 'Rule',
  'app.pages.interfaces.toolbar.inputValue.rule.notRange': 'Not in range',
  'app.pages.interfaces.toolbar.inputValue.rule.textLength': 'Text length',
  'app.pages.interfaces.toolbar.inputValue.rule.any': 'Any',
  'app.pages.interfaces.toolbar.inputValue.customErrorMessage': 'Custom error message',

  // Interface pivot
  'app.pages.interfaces.pivot.x': 'X',
  'app.pages.interfaces.pivot.y': 'Y',
  'app.pages.interfaces.pivot.z': 'Z',
  'app.pages.interfaces.pivot.facet_row': 'Facet row',
  'app.pages.interfaces.pivot.facet_column': 'Facet column',
  'app.pages.interfaces.pivot.text': 'Text',
  'app.pages.interfaces.pivot.animation_frame': 'Animation frame',
  'app.pages.interfaces.pivot.animation_group': 'Animation group',
  'app.pages.interfaces.pivot.error_x': 'Error X',
  'app.pages.interfaces.pivot.error_x_minus': 'Error X minus',
  'app.pages.interfaces.pivot.error_y': 'Error Y',
  'app.pages.interfaces.pivot.error_y_minus': 'Error Y minus',
  'app.pages.interfaces.pivot.error_z': 'Error Z',
  'app.pages.interfaces.pivot.error_z_minus': 'Error Z minus',
  'app.pages.interfaces.pivot.latitude': 'Latitude',
  'app.pages.interfaces.pivot.longitude': 'Longitude',
  'app.pages.interfaces.pivot.r': 'R',
  'app.pages.interfaces.pivot.theta': 'Theta',
  'app.pages.interfaces.pivot.measure_1': 'Measure 1',
  'app.pages.interfaces.pivot.measure_2': 'Measure 2',
  'app.pages.interfaces.pivot.measure_3': 'Measure 3',
  'app.pages.interfaces.pivot.color': 'Color',
  'app.pages.interfaces.pivot.size': 'Size',
  'app.pages.interfaces.pivot.base': 'Base',
  'app.pages.interfaces.pivot.symbol': 'Symbol',
  'app.pages.interfaces.pivot.line_group': 'Line group',
  'app.pages.interfaces.pivot.line_dash': 'Line dash',
  'app.pages.interfaces.pivot.pattern_shape': 'Pattern shape',
  'app.pages.interfaces.pivot.dimensions': 'Dimensions',
  'app.pages.interfaces.pivot.locations': 'Locations',
  'app.pages.interfaces.pivot.names': 'Names',
  'app.pages.interfaces.pivot.values': 'Values',
  'app.pages.interfaces.pivot.x_start': 'X start',
  'app.pages.interfaces.pivot.x_end': 'X end',
  'app.pages.interfaces.pivot.path': 'Path',
  'app.pages.interfaces.pivot.parents': 'Parents',
  'app.pages.interfaces.pivot.ids': 'IDs',
  'app.pages.interfaces.pivot.chart_type_1': 'Chart type 1',
  'app.pages.interfaces.pivot.chart_type_2': 'Chart type 2',
  'app.pages.interfaces.pivot.dimension': 'Dimension',
  'app.pages.interfaces.pivot.measure': 'Measure',
  'app.pages.interfaces.pivot.rows': 'Rows',
  'app.pages.interfaces.pivot.columns': 'Columns',
  'app.pages.interfaces.pivot.measures': 'Measures',
  'app.pages.interfaces.pivot.series': 'Series',
  'app.pages.interfaces.pivot.sum': 'Sum',
  'app.pages.interfaces.pivot.avg': 'Average',
  'app.pages.interfaces.pivot.min': 'Min',
  'app.pages.interfaces.pivot.max': 'Max',
  'app.pages.interfaces.pivot.count': 'Count',
  'app.pages.interfaces.pivot.': 'None',
  'app.pages.interfaces.pivot.agg': 'Aggregate',
  'app.pages.interfaces.pivot.newMeasure': 'New measure',
  'app.pages.interfaces.pivot.newMeasureName': 'New measure name',
  'app.pages.interfaces.pivot.selectHierarchy': 'Select hierarchy',
  'app.pages.interfaces.pivot.editCalculatedMeasure': 'Edit calculated measure',
  'app.pages.interfaces.pivot.removeCalculatedMeasure': 'Remove calculated measure',
  'app.pages.interfaces.pivot.removeCalculatedMeasureMessage':
    'Are you sure you want to remove "{field}"?',
  'app.pages.interfaces.pivot.function': 'Function',
  'app.pages.interfaces.pivot.calculationMode': 'Calculation mode',
  'app.pages.interfaces.pivot.histnorm': 'Histogram normalization',
  'app.pages.interfaces.pivot.box': 'Box',
  'app.pages.interfaces.pivot.marginal': 'Marginal',
  'app.pages.interfaces.pivot.calculatedMeasure': 'Calculated measure',
  'app.pages.interfaces.pivot.calculatedItem': 'Calculated item',
  'app.pages.interfaces.pivot.editCalculatedItem': 'Edit calculated item',
  'app.pages.interfaces.pivot.removeCalculatedItem': 'Remove calculated item',
  'app.pages.interfaces.pivot.removeCalculatedItemMessage':
    'Are you sure you want to remove "{item}"?',
  'app.pages.interfaces.pivot.itemAlreadyExists': 'Item already exists',
  'app.pages.interfaces.pivot.addSubtotal': 'Add subtotal',
  'app.pages.interfaces.pivot.editSubtotal': 'Edit subtotal',
  'app.pages.interfaces.pivot.removeSubtotal': 'Remove subtotal',
  'app.pages.interfaces.pivot.addSubtotalFor': 'Add subtotal for',
  'app.pages.interfaces.pivot.editSubtotalFor': 'Edit subtotal for',
  'app.pages.interfaces.pivot.subtotalTypeHierarchical':
    'Hierarchical (based on the full row hierarchy)',
  'app.pages.interfaces.pivot.subtotalTypeByElement':
    'By element (one subtotal per consecutive run of equal values)',
  'app.pages.interfaces.pivot.includeSingleElementSegments': 'Include single-element segments',
  'app.pages.interfaces.pivot.subtotalAggregationMethod': 'Aggregation method',
  'app.pages.interfaces.pivot.sortAscending': 'Sort ascending',
  'app.pages.interfaces.pivot.sortDescending': 'Sort descending',
  'app.pages.interfaces.pivot.removeSorting': 'Remove sorting',
  'app.pages.interfaces.pivot.customSortValues': 'Custom sort values',
  'app.pages.interfaces.pivot.sortValuesFor': 'Sort values for',
  'app.pages.interfaces.pivot.resetCustomSort': 'Reset custom sort',
  'app.pages.interfaces.pivot.itemHasCustomSort': 'The item has a custom sort',
  'app.pages.interfaces.pivot.sortByIndexNode': 'Sort by index node',
  'app.pages.interfaces.pivot.selectIndexNode': 'Select an index node',
  'app.pages.interfaces.pivot.noIndexNodesFounded': 'No index nodes found',
  'app.pages.interfaces.pivot.multiSortTitle': 'Custom order',
  'app.pages.interfaces.pivot.multiSortOrderBy': 'Order by',
  'app.pages.interfaces.pivot.multiSortThenBy': 'Then by',
  'app.pages.interfaces.pivot.multiSortAscending': 'Ascending order',
  'app.pages.interfaces.pivot.multiSortDescending': 'Descending order',
  'app.pages.interfaces.pivot.multiSortAddOrder': 'Add Order',

  //Code widget
  'app.pages.app.code.widget.code.saveAndRun': 'Save and Run Code',
  'app.pages.app.code.widget.code.formatCode': 'Format code',
  'app.pages.app.code.widget.code.viewCodeDifferences': 'View code differences',
  'app.pages.app.code.widget.code.hideCodeDifferences': 'Hide code differences',
  'app.pages.app.code.widget.code.askAi': 'Ask AI',

  //Result widget
  'app.pages.app.code.widget.result.defaultview.saved':
    'The default view of node has been saved successfully',
  'app.pages.app.code.widget.result.notCalculated': 'The node is not calculated',
  'app.pages.app.code.widget.result.loading': 'Loading results..',
  'app.pages.app.code.widget.code.loading': 'Loading code..',
  'app.pages.app.code.widget.result.changeToPreviewWidget': 'Change to preview widget',

  //Preview widget
  'app.pages.app.code.widget.preview.resultType': 'Result type',
  'app.pages.app.code.widget.preview.indexes': 'Indexes',
  'app.pages.app.code.widget.preview.preview': 'Preview',
  'app.pages.app.code.widget.preview.clickToOpenSparkUI': 'Click here to open the spark UI',
  'app.pages.app.code.widget.preview.sparkui': 'Spark UI',
  'app.pages.app.code.widget.preview.changeToResultWidget': 'Change to result widget',
  'app.pages.app.code.widget.preview.getNodePreview': 'Get node preview',
  'app.pages.app.code.widget.preview.loading': 'Loading preview..',
  'app.pages.app.code.widget.preview.noPreview': 'No preview available',

  //Console widget
  'app.pages.app.code.widget.console.preserveLog': 'Preserve log',
  'app.pages.app.code.widget.console.clearLogs': 'Clear logs',
  'app.pages.app.code.widget.console.closeConsole': 'Close console',
  'app.pages.app.code.widget.console.showConsole': 'Show console',
  'app.pages.app.code.widget.console.clearErrors': 'Clear errors',
  'app.pages.app.code.widget.console.copyError': 'Copy error',
  'app.pages.app.code.widget.console.errorCopied': 'Error copied',
  'app.pages.app.code.widget.console.performanceAnalysis': 'Performance analysis',
  'app.pages.app.code.widget.console.performance': 'Performance',
  'app.pages.app.code.widget.console.percentOfTime': '% of time',
  'app.pages.app.code.widget.console.fromDynamic': 'From dynamic',
  'app.pages.app.code.widget.console.maxMemory': 'Max memory',
  'app.pages.app.code.widget.console.kind': 'Type',
  'app.pages.app.code.widget.console.title': 'Title',
  'app.pages.app.code.widget.console.identifier': 'Identifier',
  'app.pages.app.code.widget.console.kindNode': 'Node',
  'app.pages.app.code.widget.console.kindComponent': 'Component',
  'app.pages.app.code.widget.console.kindInterface': 'Interface',
  'app.pages.app.code.widget.console.usedMemory': 'Used memory',
  'app.pages.app.code.widget.console.processingTime': 'Processing time',
  'app.pages.app.code.widget.console.enableAnalysis': 'Enable analysis',
  'app.pages.app.code.widget.console.disableAnalysis': 'Disable analysis',
  'app.pages.app.code.widget.console.clearResults': 'Clear results',
  'app.pages.app.code.widget.console.logs': 'Logs',
  'app.pages.app.code.widget.console.resetAppResults': 'Reset app results',
  'app.pages.app.code.widget.console.exportPerformanceAnalysisCsv':
    'Export performance analysis as CSV',
  'app.pages.app.code.widget.console.exportPerformanceAnalysisExcel':
    'Export performance analysis as Excel',
  'app.pages.app.code.widget.console.performanceAnalysisDownloaded':
    'Performance analysis downloaded',
  'app.pages.app.code.widget.console.performanceAnalysisDownloadError':
    "Couldn't generate the performance analysis file",

  //Task manager
  'app.pages.app.taskManager.task': 'Task manager',
  'app.pages.app.taskManager.addTaskScheduled': 'Add scheduled task',
  'app.pages.app.taskManager.editTaskScheduled': 'Edit scheduled task',
  'app.pages.app.taskManager.createdBy': 'Created by',
  'app.pages.app.taskManager.executorUser': 'Executor user',
  'app.pages.app.taskManager.lastRunAt': 'Last run at',
  'app.pages.app.taskManager.nextExecution': 'Next execution',
  'app.pages.app.taskManager.lastStatus': 'Last status',
  'app.pages.app.taskManager.saveNeedsEveryStep':
    'Complete the required fields of every step before saving',
  'app.pages.app.taskManager.updateMode': 'Mode',
  'app.pages.app.taskManager.updateModeInterval': 'By interval',
  'app.pages.app.taskManager.updateModeLive': 'Live',
  'app.pages.app.taskManager.appPool': 'App pool',
  'app.pages.app.taskManager.schedulerType': 'Scheduler type',
  'app.pages.app.taskManager.params': 'Params',
  'app.pages.app.taskManager.enabled': 'Enabled',
  'app.pages.app.taskManager.showTaskLog': 'Show task log',
  'app.pages.app.taskManager.addAppPool': 'Add app pool',
  'app.pages.app.taskManager.interval': 'Interval',
  'app.pages.app.taskManager.clocked': 'Clocked',
  'app.pages.app.taskManager.taskDeleted': 'Task deleted',
  'app.pages.app.taskManager.deleteTask': 'Delete task {name}',
  'app.pages.app.taskManager.deleteTaskMessage': 'Are you sure you want to delete the task?',
  'app.pages.app.taskManager.taskActivated': 'Task activated',
  'app.pages.app.taskManager.taskDeactivated': 'Task deactivated',
  'app.pages.app.taskManager.taskAddedToQueue': 'The task has been added to the execution queue',
  'app.pages.app.taskManager.editAppPool': 'Edit app pool',
  'app.pages.app.taskManager.taskLogs': 'Task logs',
  'app.pages.app.taskManager.createdAt': 'Created at',
  'app.pages.app.taskManager.state': 'State',
  'app.pages.app.taskManager.lastTaskExecutions': 'Last task executions',
  'app.pages.app.taskManager.runTask': 'Run task',
  'app.pages.app.taskManager.runTaskConfirmTitle': 'Run task {name}',
  'app.pages.app.taskManager.runTaskConfirmMessage':
    'Are you sure you want to run the task {name}?',
  'app.pages.app.taskManager.taskAlreadyRunning': 'The task is already running',
  'app.pages.app.taskManager.taskRunningSince':
    'The task is already running: it was run on {date} hs.',
  'app.pages.app.taskManager.removeTaskFromInProgressState': 'Remove task from in-progress state',
  'app.pages.app.taskManager.taskRemovedFromInProgressState':
    'Task was removed from in-progress state',
  'app.pages.app.taskManager.advancedFilters': 'Advanced filters',
  'app.pages.app.taskManager.taskLogsDetails': 'Task logs details',
  'app.pages.app.taskManager.refreshLogs': 'Refresh logs',
  'app.pages.app.taskManager.taskDidNotRunYet': 'The task did not run yet',
  'app.pages.app.taskManager.description': 'Description',
  'app.pages.app.taskManager.activity': 'Activity',
  'app.pages.app.taskManager.info': 'Info',
  'app.pages.app.taskManager.periodicTaskLogNotFound': 'Task logs not found',
  'app.pages.app.taskManager.success': 'Success',
  'app.pages.app.taskManager.failure': 'Failure',
  'app.pages.app.taskManager.maxDateError': 'Max date cannot be before the min date',
  'app.pages.app.taskManager.minDate': 'Min date',
  'app.pages.app.taskManager.maxDate': 'Max date',
  'app.pages.app.taskManager.timeZones': 'Timezones',
  'app.pages.app.taskManager.clearForm': 'Clear form',
  'app.pages.app.taskManager.insertTheTaskName': 'Insert the task name',
  'app.pages.app.taskManager.disabled': 'Disabled',
  'app.pages.app.taskManager.days': 'Day',
  'app.pages.app.taskManager.hours': 'Hour',
  'app.pages.app.taskManager.minutes': 'Minute',
  'app.pages.app.taskManager.seconds': 'Seconds',
  'app.pages.app.taskManager.microseconds': 'Microseconds',
  'app.pages.app.taskManager.every': 'Every',
  'app.pages.app.taskManager.period': 'Period',
  'app.pages.app.taskManager.everyPlaceholder': 'Please enter an interval integer',
  'app.pages.app.taskManager.appPath': 'App path',
  'app.pages.app.taskManager.generalOptions': 'General options',
  'app.pages.app.taskManager.scheduler': 'Scheduler',
  'app.pages.app.taskManager.everyMinute': 'Every minute',
  'app.pages.app.taskManager.minutesPlaceholder': 'Select the minutes',
  'app.pages.app.taskManager.everyHour': 'Every hour',
  'app.pages.app.taskManager.hoursPlaceholder': 'Select the hours',
  'app.pages.app.taskManager.dayMonths': 'Days of month',
  'app.pages.app.taskManager.everyDayOfMonths': 'Every day of month',
  'app.pages.app.taskManager.everyMonths': 'Every month',
  'app.pages.app.taskManager.everyDays': 'Every day',
  'app.pages.app.taskManager.dayMonthsPlaceholder': 'Select the days of month',
  'app.pages.app.taskManager.months': 'Months',
  'app.pages.app.taskManager.monthsPlaceholder': 'Select the months',
  'app.pages.app.taskManager.daysPlaceholder': 'Select the days',
  'app.pages.app.taskManager.january': 'January',
  'app.pages.app.taskManager.february': 'February',
  'app.pages.app.taskManager.march': 'March',
  'app.pages.app.taskManager.april': 'April',
  'app.pages.app.taskManager.may': 'May',
  'app.pages.app.taskManager.june': 'June',
  'app.pages.app.taskManager.july': 'July',
  'app.pages.app.taskManager.august': 'August',
  'app.pages.app.taskManager.september': 'September',
  'app.pages.app.taskManager.october': 'October',
  'app.pages.app.taskManager.november': 'November',
  'app.pages.app.taskManager.december': 'December',
  'app.pages.app.taskManager.monday': 'Monday',
  'app.pages.app.taskManager.tuesday': 'Tuesday',
  'app.pages.app.taskManager.wednesday': 'Wednesday',
  'app.pages.app.taskManager.thursday': 'Thursday',
  'app.pages.app.taskManager.friday': 'Friday',
  'app.pages.app.taskManager.saturday': 'Saturday',
  'app.pages.app.taskManager.sunday': 'Sunday',
  'app.pages.app.taskManager.at': 'At ',
  'app.pages.app.taskManager.on': 'on ',
  'app.pages.app.taskManager.in': 'in ',
  'app.pages.app.taskManager.pastHour': 'Past hour ',
  'app.pages.app.taskManager.andOn': 'And on ',
  'app.pages.app.taskManager.and': 'and',
  'app.pages.app.taskManager.reset': 'Reset',
  'app.pages.app.taskManager.nameIsRequired': 'Task name is required',
  'app.pages.app.taskManager.nameMaxLength': 'Task name max length is {number} characters',
  'app.pages.app.taskManager.schedulerTypeIsRequired': 'Scheduler type is required',
  'app.pages.app.taskManager.periodIsRequired': 'Period is required',
  'app.pages.app.taskManager.everyIsRequired': 'Every is required',
  'app.pages.app.taskManager.everyMustBeInt': 'Every must be an integer number',
  'app.pages.app.taskManager.everyMaxLength': 'Every can not be greather than {number}',
  'app.pages.app.taskManager.clockedIsRequired': 'Clocked time is required',
  'app.pages.app.taskManager.nodeOrInterfaceIsRequired':
    'Required: select at least a node or an interface. You can select both.',
  'app.pages.app.taskManager.appPathIsRequired': 'App path is required',
  'app.pages.app.taskManager.type': 'Type',
  'app.pages.app.taskManager.label': 'Label',
  'app.pages.app.taskManager.defaultValue': 'Default value',
  'app.pages.app.taskManager.source': 'Source',
  'app.pages.app.taskManager.paramsTable': 'Params table',
  'app.pages.app.taskManager.noParamsData': 'There are not params',
  'app.pages.app.taskManager.select': 'Select',
  'app.pages.app.taskManager.input': 'Input',
  'app.pages.app.taskManager.checkbox': 'Checkbox',
  'app.pages.app.taskManager.paramNameIsRequired': 'Param name is required',
  'app.pages.app.taskManager.labelIsRequired': 'Label is required',
  'app.pages.app.taskManager.paramNameInvalid':
    'Must contain lowercase letters and/or numbers. Whitespaces and dashes are not allowed',
  'app.pages.app.taskManager.paramNamePlaceholder': 'Insert the param name',
  'app.pages.app.taskManager.labelPlaceholder': 'Insert the label',
  'app.pages.app.taskManager.defaultValuePlaceholder': 'Insert the default value',
  'app.pages.app.taskManager.sourcePlaceholder': 'Insert the source',
  'app.pages.app.taskManager.taskNameExists': 'The task name already exists',
  'app.pages.app.taskManager.taskCreated': 'Task created',
  'app.pages.app.taskManager.taskUpdated': 'Task updated',
  'app.pages.app.taskManager.keepForEveryone': 'Keep for everyone',
  'app.pages.app.taskManager.keepForDepartments': 'Keep for departments',
  'app.pages.app.taskManager.status.created': 'Created',
  'app.pages.app.taskManager.taskFinishedTitle': 'Scheduled task finished',
  'app.pages.app.taskManager.taskFinishedMessage': '{name} finished with status: {status}',
  'app.pages.app.taskManager.status.progress': 'In progress',
  'app.pages.app.taskManager.status.info': 'Info',
  'app.pages.app.taskManager.status.warning': 'Warning',
  'app.pages.app.taskManager.status.failure': 'Failure',
  'app.pages.app.taskManager.status.failed': 'Failed',
  'app.pages.app.taskManager.status.retry': 'Retry',
  'app.pages.app.taskManager.status.success': 'Success',
  'app.pages.app.taskManager.status.passed': 'Passed',
  'app.pages.app.taskManager.status.revoked': 'Revoked',
  'app.pages.app.taskManager.status.started': 'Started',
  'app.pages.app.taskManager.status.pending': 'Pending',
  'app.pages.app.taskManager.status.received': 'Received',
  'app.pages.app.taskManager.keepForUser': 'Keep for user',
  'app.pages.app.taskManager.actionOnDone': 'Action on done',
  'app.pages.app.taskManager.instances': 'Instances',
  'app.pages.app.taskManager.enableInstanceExpire': 'Enable instance expire',
  'app.pages.app.taskManager.expireAt': 'Expire at',
  'app.pages.app.taskManager.instanceExpiration': 'Instance expiration',
  'app.pages.app.taskManager.expirationModeNone': 'Never expire',
  'app.pages.app.taskManager.expirationModeTimeOfDay': 'At a time of day',
  'app.pages.app.taskManager.expirationModeMaxAge': 'After a period of time',
  'app.pages.app.taskManager.expirationModeHelp': 'How each expiration mode works',
  'app.pages.app.taskManager.expirationModeNoneHelp':
    'Never expire: instances stay in the pool until a user claims one.',
  'app.pages.app.taskManager.expirationModeTimeOfDayHelp':
    'At a time of day: every instance is recycled when that time comes, each day.',
  'app.pages.app.taskManager.expirationModeMaxAgeHelp':
    'After a period of time: each instance is recycled once it reaches that age, counted from when it entered the pool.',
  'app.pages.app.taskManager.periodMinutes': 'Minutes',
  'app.pages.app.taskManager.periodHours': 'Hours',
  'app.pages.app.taskManager.periodDays': 'Days',
  'app.pages.app.taskManager.expireAfter': 'Expire after',
  'app.pages.app.taskManager.maxAgePositive': 'Enter a period greater than zero',
  'app.pages.app.taskManager.maxAgeTooShort':
    'Instances cannot expire in less than {minutes} minutes',
  'app.pages.app.taskManager.sectionPool': 'Pool',
  'app.pages.app.taskManager.sectionCapacity': 'Capacity',
  'app.pages.app.taskManager.sectionExpiration': 'Expiration',
  'app.pages.app.taskManager.poolEnabled': 'Pool enabled',
  'app.pages.app.taskManager.instancesHelp': 'Instances kept ready',
  'app.pages.app.taskManager.keepForEveryoneHelp': 'Any user in the company can claim an instance',
  'app.pages.app.taskManager.keepForDepartmentsHelp':
    'Any member of the chosen departments can claim an instance',
  'app.pages.app.taskManager.keepForUserHelp': 'The instance is reserved for one user',
  'app.pages.app.taskManager.timezoneScopeBoth':
    'Applies to the expiration hour and to the active periods below',
  'app.pages.app.taskManager.timezoneScopeExpiration': 'Applies to the expiration hour below',
  'app.pages.app.taskManager.timezoneScopePeriods': 'Applies to the active periods below',
  'app.pages.app.taskManager.summaryTitle': 'This pool will',
  'app.pages.app.taskManager.summaryKeepForEveryone':
    'Keep {instances} instances ready for every user in the company',
  'app.pages.app.taskManager.summaryKeepForDepartments':
    'Keep {instances} instances ready for the chosen departments',
  'app.pages.app.taskManager.summaryKeepForUser':
    'Keep one instance ready for the chosen user, unless they already have this version of the app open',
  'app.pages.app.taskManager.summaryKeepUpToForDepartments':
    'Keep up to {instances} instances waiting for the chosen departments',
  'app.pages.app.taskManager.summaryMaxOpenInstances':
    'Stop creating new ones when {max} are open in total, until someone closes one',
  'app.pages.app.taskManager.maxOpenInstancesEnabled': 'Limit open instances',
  'app.pages.app.taskManager.maxOpenInstances': 'Max open at once',
  'app.pages.app.taskManager.maxOpenInstancesHelp':
    'Counts the pool instances and the ones department members open',
  'app.pages.app.taskManager.maxOpenInstancesPositive':
    'The maximum must be a positive whole number',
  'app.pages.app.taskManager.maxOpenInstancesBelowInstances':
    'Enter at least as many as the instances kept ready',
  'app.pages.app.taskManager.summaryExpireMaxAge':
    'Recycle each instance {age} after it enters the pool',
  'app.pages.app.taskManager.summaryUnitMinutes':
    '{every, plural, one {# minute} other {# minutes}}',
  'app.pages.app.taskManager.summaryUnitHours': '{every, plural, one {# hour} other {# hours}}',
  'app.pages.app.taskManager.summaryUnitDays': '{every, plural, one {# day} other {# days}}',
  'app.pages.app.taskManager.summaryExpireTimeOfDay':
    'Recycle every instance at {time}, every day, {timezone}',
  'app.pages.app.taskManager.summaryExpireNever':
    'Never recycle instances: they stay until a user claims one',
  'app.pages.app.taskManager.summaryActivePeriods': 'Run only {periods}, {timezone}',
  'app.pages.app.taskManager.summaryPeriodShape': '{days}, {from} to {to}',
  'app.pages.app.taskManager.summaryPeriodCount': '{count} periods',
  'app.pages.app.taskManager.summaryTakenDownOutside': 'Take the pool down outside those hours',
  'app.pages.app.taskManager.summaryAlwaysOn': 'Run around the clock, every day',
  'app.pages.app.taskManager.activePeriodsEnabled': 'Limit to active periods',
  'app.pages.app.taskManager.activePeriodsHelp':
    'Outside these periods the pool is taken down and no new instances are created',
  'app.pages.app.taskManager.timezone': 'Time zone',
  'app.pages.app.taskManager.activePeriodFrom': 'From',
  'app.pages.app.taskManager.activePeriodTo': 'To',
  'app.pages.app.taskManager.activePeriodCrossesMidnight': 'Crosses midnight',
  'app.pages.app.taskManager.addActivePeriod': 'Add period',
  'app.pages.app.taskManager.removeActivePeriod': 'Remove period',
  'app.pages.app.taskManager.activePeriodsRequired': 'Add at least one period',
  'app.pages.app.taskManager.activePeriodDaysRequired': 'Choose at least one day',
  'app.pages.app.taskManager.activePeriodSameBounds':
    'The start and the end cannot be the same time',
  'app.pages.app.taskManager.selectModelFIle': 'Select model file',
  'app.pages.app.taskManager.node': 'Node',
  'app.pages.app.taskManager.noNodesFounded': 'There are not nodes',
  'app.pages.app.taskManager.clockedWithTz': 'Clocked UTC {tz}',
  'app.pages.app.taskManager.appPoolCreated': 'App pool created',
  'app.pages.app.taskManager.appPoolUpdated': 'App pool updated',
  'app.pages.app.taskManager.actionIsRequired': 'Action on done is required',
  'app.pages.app.taskManager.instancesPositive': 'Instance value must be a positive number',
  'app.pages.app.taskManager.instancesIsRequired': 'Instances are required',
  'app.pages.app.taskManager.departmentsAreRequired': 'Select at least one department',
  'app.pages.app.taskManager.userIsRequired': 'User is required',
  'app.pages.app.taskManager.users': 'Users',
  'app.pages.app.taskManager.usersPlaceholder': 'Please select a user',
  'app.pages.app.taskManager.timezoneIsRequired': 'Timezone is required',
  'app.pages.app.taskManager.noTasksFound': 'No tasks found',
  'app.pages.app.taskManager.taskUser': 'Task user',
  'app.pages.app.taskManager.systemTask': 'System',
  'app.pages.app.taskManager.noPermissionsToListTasks':
    "You don't have enough permissions to list scheduled tasks",
  'app.pages.app.taskManager.resources': 'Resources',
  'app.pages.app.taskManager.instanceTimeoutInSeconds': 'Instance timeout in seconds',
  'app.pages.app.taskManager.minTimeRequiredMessage': 'Minimum time required is 120 seconds',
  'app.pages.app.taskManager.useDepartment': 'Department resources',
  'app.pages.app.taskManager.taskId': 'Task id',
  'app.pages.app.taskManager.scheduleParams': 'Schedule parameters',
  'app.pages.app.taskManager.taskParams': 'Task parameters',
  'app.pages.app.taskManager.notificationUsers': 'Notification users',
  'app.pages.app.taskManager.scheduleId': 'Schedule id',
  'app.pages.app.taskManager.currentAppOnly': 'Only this application',
  'app.pages.app.taskManager.showSearch': 'Show search bar',
  'app.pages.app.taskManager.hideDisabledTasks': 'Hide disabled tasks',
  'app.pages.app.taskManager.automaticUpdate': 'Automatic update',
  'app.pages.app.taskManager.automaticallyUpdate': 'Update automatically',
  'app.pages.app.taskManager.automaticUpdateEverySeconds': 'Every (seconds)',
  'app.pages.app.taskManager.showSystemTasks': 'Show System tasks',
  'app.pages.app.taskManager.viewResources': 'View resources',
  'app.pages.app.taskManager.manual': 'Manual',
  'app.pages.app.taskManager.emailNotificationMode': 'Email notification mode',
  'app.pages.app.taskManager.emailNotificationAlways': 'Always send emails',
  'app.pages.app.taskManager.emailNotificationOnFailure': 'Send emails only on failure',
  'app.pages.app.taskManager.emailNotificationOnSuccess': 'Send emails only on success',

  //Running node
  'app.pages.app.runningNodeModel.runningNode': 'Running node',
  'app.pages.app.runningNodeModel.stopping': 'Stopping',
  'app.pages.app.runningNodeModel.stuckTitle':
    'The application did not respond to the stop request.',
  'app.pages.app.runningNodeModel.stuckMessage': 'Choose an action or keep waiting:',
  'app.pages.app.runningNodeModel.stuckOption1': 'Save changes and force stop (recommended)',
  'app.pages.app.runningNodeModel.stuckOption2': 'Force stop (unsaved changes may be lost)',
  'app.pages.app.runningNodeModel.forceStop': 'Force stop',
  'app.pages.app.runningNodeModel.saveAndForceStop': 'Save changes and force stop',
  'app.pages.app.runningNodeModel.phaseKilling': 'Closing instance...',
  'app.pages.app.runningNodeModel.phaseCreating': 'Creating new instance...',
  'app.pages.app.runningNodeModel.phaseOpening': 'Opening application...',

  //Assets recovery
  'app.pages.app.assetsRecovery.brokenTitle': 'The application could not be reopened correctly',
  'app.pages.app.assetsRecovery.brokenMessage':
    'A problem was detected while reopening the application. The application may be missing its menu, interfaces or business rules.',
  'app.pages.app.assetsRecovery.brokenInstructions':
    'You can try to recover it from the latest backup copy, or go to the File Manager: look for a folder named "assets_old#..." next to the app version folder and rename it to "assets" to manually restore the last backup. If you are not sure how to do this, contact a responsible person before making further changes.',
  'app.pages.app.assetsRecovery.recoverFromBackupButton': 'Recover from backup',
  'app.pages.app.assetsRecovery.goToFileManagerButton': 'Go to File Manager',

  //Saving app
  'app.pages.savingApp.savingApp': 'Saving app',

  //Interface Manager
  'app.pages.interfaceManager': 'Interfaces manager',
  'app.pages.interfaceManager.newInterface': 'New interface',
  'app.pages.interfaceManager.createNewInterface': 'Create new interface',
  'app.pages.interfaceManager.editInterface': 'Edit interface',
  'app.pages.interfaceManager.createNewFolder': 'Create new folder',
  'app.pages.interfaceManager.name': 'Interface name',
  'app.pages.interfaceManager.interfaceType': 'Interface type',
  'app.pages.interfaceManager.interfaceType.dragDrop': 'Component interface',
  'app.pages.interfaceManager.interfaceType.dragDropHint':
    'Drag-and-drop dashboard composed of Pyplan components (tables, charts, selectors, forms).',
  'app.pages.interfaceManager.interfaceType.html': 'HTML interface',
  'app.pages.interfaceManager.interfaceType.htmlHint':
    'Custom full-page HTML/JS rendered in a sandboxed iframe, with Python callbacks.',
  'app.pages.interfaceManager.emptyHtml.title': 'What do you want to build?',
  'app.pages.interfaceManager.emptyHtml.subtitle':
    'Describe the dashboard or UI you have in mind. The Developer agent will generate the HTML and Python code for this interface.',
  'app.pages.interfaceManager.emptyHtml.placeholder':
    'e.g. "A table of sales per region with a bar chart on the side"',
  'app.pages.interfaceManager.emptyHtml.send': 'Send to Developer',
  'app.pages.interfaceManager.folderName': 'Folder name',
  'app.pages.interfaceManager.deleteInterface': 'Delete interfaces',
  'app.pages.interfaceManager.deleteFolder': 'Delete folder',
  'app.pages.interfaceManager.deleteInterfaceConfirmationText':
    'Are you sure you want to permanently delete this interface?',
  'app.pages.interfaceManager.deleteFolderConfirmationText':
    'Are you sure you want to permanently delete this folder and all its content?',
  'app.pages.interfaceManager.myInterfaces': 'My interfaces',
  'app.pages.interfaceManager.noInterfaces':
    'There are no available interfaces. Create a new one using the Create button',
  'app.pages.interfaceManager.deniedFor': 'Denied for',
  'app.pages.interfaceManager.allowedFor': 'Allowed for',
  'app.pages.interfaceManager.deniedForDetail': 'Deny access to',
  'app.pages.interfaceManager.slashNotAllowed':
    'Invalid character. "/" is not allowed in interface name',
  'app.pages.interfaceManager.interfaceNameRepeated': 'Interface name already exists',
  'app.pages.interfaceManager.removeDocumentation': 'Remove documentation',
  'app.pages.interfaceManager.removeDocumentationConfirm':
    'Do you want to remove the documentation?',
  'app.pages.interfaceManager.shareInterface': 'Share interface',
  'app.pages.interfaceManager.interfaceLinkCopied': 'Interface link copied',
  'app.pages.interfaceManager.copyInterfaceLink': 'Copy interface link',
  'app.pages.interfaceManager.interfaceLink': 'Interface link',
  'app.pages.interfaceManager.interfacesLinks': 'Interface links',
  'app.pages.interfaceManager.interfacesLinks.notFound': 'There are no interface links',
  'app.pages.interfaceManager.activateInterfaceEndpoint': 'Activate interface endpoint',
  'app.pages.interfaceManager.updateInterfaceLink': 'Update interface link',
  'app.pages.interfaceManager.interfaceLinkUpdated': 'Interface link updated successfully',
  'app.pages.interfaceManager.deleteInterfaceLink': 'Delete interface link: {interfaceName}',
  'app.pages.interfaceManager.deleteInterfaceLinkConfirmation':
    'Are you sure you want to delete this interface link?',
  'app.pages.interfaceManager.interfaceLinkDeleted': 'Interface link deleted successfully',
  'app.pages.interfaceManager.folderNameExists': 'Folder name already exists',
  'app.pages.externalLink.customEndpointExists': 'Custom endpoint already exists',
  'app.pages.externalLink.passwordRequiredDescription': 'Please enter the password to continue',
  'app.pages.externalLink.hasPassword': 'Has password',
  'app.pages.externalLink.requirePassword': 'Require password',
  'app.pages.interfaceManager.basicInformation': 'Basic information',

  //File manager
  'app.pages.FileManagerPage.download': 'Download',
  'app.pages.FileManagerPage.zipIt': 'Zip it',
  'app.pages.FileManagerPage.copyIn': 'Copy',
  'app.pages.FileManagerPage.archive': 'Archive',
  'app.pages.FileManagerPage.denyAccess': 'Deny access',
  'app.pages.FileManagerPage.folder': 'Folder',
  'app.pages.FileManagerPage.selectAll': 'Select all',
  'app.pages.FileManagerPage.unSelectAll': 'Unselect all',
  'app.pages.FileManagerPage.models': 'Models (.ppl)',
  'app.pages.FileManagerPage.csv': 'CSV {extension}',
  'app.pages.FileManagerPage.templates': 'Templates(.xls,.xlsx,.xlsm)',
  'app.pages.FileManagerPage.database': 'Database {extension}',
  'app.pages.FileManagerPage.modules': 'Modules (.ppm)',
  'app.pages.FileManagerPage.interfaces': 'Interfaces',
  'app.pages.FileManagerPage.zipFiles': 'Zip file {extension}',
  'app.pages.FileManagerPage.jsonFiles': 'JSON file {extension}',
  'app.pages.FileManagerPage.backup': 'Backup (.old)',
  'app.pages.FileManagerPage.others': 'Others',
  'app.pages.FileManagerPage.showHidden': 'Show hidden files/folders',
  'app.pages.FileManagerPage.filterBy': 'Filter by',
  'app.pages.FileManagerPage.model': 'Model',
  'app.pages.FileManagerPage.file': 'File',
  'app.pages.FileManagerPage.type': 'Type',
  'app.pages.FileManagerPage.location': 'Location',
  'app.pages.FileManagerPage.opened': 'Opened',
  'app.pages.FileManagerPage.size': 'Size',
  'app.pages.FileManagerPage.getSize': 'Get size',
  'app.pages.FileManagerPage.date': 'Date',
  'app.pages.FileManagerPage.access': 'Access',
  'app.pages.FileManagerPage.fileName': 'File name',
  'app.pages.FileManagerPage.folders': 'Folders',
  'app.pages.FileManagerPage.files': 'Files',
  'app.pages.FileManagerPage.root': 'Root',
  'app.pages.FileManagerPage.listView': 'List view',
  'app.pages.FileManagerPage.mosaicView': 'Mosaic view',
  'app.pages.FileManagerPage.folderEmpty': 'The folder is empty',
  'app.pages.FileManagerPage.denyAccessTo': 'Deny access',
  'app.pages.FileManagerPage.allowAccessTo': 'Allow access',
  'app.pages.FileManagerPage.allowAccessOnlyTo': 'Allow access only to',
  'app.pages.FileManagerPage.folderExceptions': 'Exceptions',
  'app.pages.FileManagerPage.folderExceptionsHint':
    'The restriction applies to every folder named "{folder}", except the paths listed below.',
  'app.pages.FileManagerPage.folderExceptionsHintAllowOnly':
    'The chosen departments can see every folder named {folder}, except the paths listed below, which stay restricted for everyone.',
  'app.pages.FileManagerPage.noFolderExceptions':
    'No exceptions: the restriction applies everywhere.',
  'app.pages.FileManagerPage.folderExceptionMissing':
    'This folder no longer exists, so the exception does not apply and the folder is restricted again. Remove it or add the new path.',
  'app.pages.FileManagerPage.addFolderException': 'Add exception for "{folder}"',
  'app.pages.FileManagerPage.pickFolderExceptionHint':
    'Pick the folder to leave accessible. Only folders named "{folder}" can be selected.',
  'app.pages.FileManagerPage.exceptionMustMatchFolderName':
    'That folder is not named "{folder}", so the exception would never apply. Pick a folder with that exact name.',
  'app.pages.FileManagerPage.exceptionAlreadyAdded': 'That path is already in the list.',
  'app.pages.FileManagerPage.addException': 'Add exception',
  'app.pages.FileManagerPage.selectedFolderException': 'Selected folder:',
  'app.pages.FileManagerPage.noFolderSelected': 'none yet',
  'app.pages.FileManagerPage.deletedMessage': '{name} deleted',
  'app.pages.FileManagerPage.wantToDeleteFolder': 'Are you sure you want to delete the folder?',
  'app.pages.FileManagerPage.wantToDeleteFile': 'Are you sure you want to delete the file?',
  'app.pages.FileManagerPage.deletedTitle': 'Delete {name}',
  'app.pages.FileManagerPage.deleteFileTitle': 'Delete file',
  'app.pages.FileManagerPage.deleteFilesTitle': 'Delete files',
  'app.pages.FileManagerPage.deleteFolderTitle': 'Delete folder',
  'app.pages.FileManagerPage.deleteFoldersTitle': 'Delete folders',
  'app.pages.FileManagerPage.deleteFilesAndFoldersTitle': 'Delete files/folders',
  'app.pages.FileManagerPage.wantToZipFile': 'Are you sure you want to zip this file?',
  'app.pages.FileManagerPage.zipFile': 'Zip {name}',
  'app.pages.FileManagerPage.unZipFile': 'Unzip {name}',
  'app.pages.FileManagerPage.fileZipped': '{name} zipped',
  'app.pages.FileManagerPage.fileUnZipped': '{name} unzipped',
  'app.pages.FileManagerPage.nodeChanged': 'Name changed to {name}',
  'app.pages.FileManagerPage.wantToUnZipFile': 'Are you sure you want to unzip this file?',
  'app.pages.FileManagerPage.unzip': 'Unzip',
  'app.pages.FileManagerPage.move': 'Move',
  'app.pages.FileManagerPage.fileCloned': '{name} cloned',
  'app.pages.FileManagerPage.createFolderTitle': 'Set folder name',
  'app.pages.FileManagerPage.folderCreated': 'Folder created',
  'app.pages.FileManagerPage.createFileTitle': 'Set file name',
  'app.pages.FileManagerPage.fileCreated': 'File created',
  'app.pages.FileManagerPage.creatingFile': 'Creating file',
  'app.pages.FileManagerPage.folderName': 'Folder name',
  'app.pages.FileManagerPage.deletedFilesMessage': 'Files or folder deleted',
  'app.pages.FileManagerPage.copyFileIn': 'Copy {name} in',
  'app.pages.FileManagerPage.upload': 'Upload',
  'app.pages.FileManagerPage.wantToDelete': 'Are you sure you want to delete :',
  'app.pages.FileManagerPage.duplicatedFiles': 'Duplicated files',
  'app.pages.FileManagerPage.zipTitle': 'Zip files',
  'app.pages.FileManagerPage.wantToZipFileS': 'Are you sure you want to zip the selected files?',
  'app.pages.FileManagerPage.departmentsRestrictions': 'Restricted department/s',
  'app.pages.FileManagerPage.folderNameError': 'The folder name is required and cannot be empty.',
  'app.pages.FileManagerPage.folderNameErrorSlash': 'The folder name cannot has slash',
  'app.pages.FileManagerPage.newNameIsRequired': 'The name is required and cannot be empty',
  'app.pages.FileManagerPage.filesUploaded': 'Files uploaded',
  'app.pages.FileManagerPage.filesZipped': 'Files zipped',
  'app.pages.FileManagerPage.zippingFiles': 'Compressing files',
  'app.pages.FileManagerPage.filesToCopy': 'Files to copy',
  'app.pages.FileManagerPage.pasteHere': 'Paste here',
  'app.pages.FileManagerPage.pleaseSelectAFile': 'Select a file or folder to see the details here.',
  'app.pages.FileManagerPage.filesCopied': 'Files copied',
  'app.pages.FileManagerPage.filesMoved': 'Files moved',
  'app.pages.FileManagerPage.filesDownloaded': 'Files downloaded',
  'app.pages.FileManagerPage.downloaded': 'Downloaded!',
  'app.pages.FileManagerPage.errorDownloading': 'There was an error downloading file',
  'app.pages.FileManagerPage.copyCompletedSuccessfully': 'Copy completed successfully',
  'app.pages.FileManagerPage.moveCompletedSuccessfully': 'Move completed successfully',
  'app.pages.FileManagerPage.fileOperationCompletedSuccessfully':
    'File operation completed successfully',
  'app.pages.FileManagerPage.fileOperationFailed': 'File operation failed',
  'app.pages.FileManagerPage.fileOperationError': 'An error occurred during the file operation',
  'app.pages.FileManagerPage.fileOperationInactivityTimeout':
    'The operation is still in progress, but no progress updates were received for too long.',
  'app.pages.FileManagerPage.copySourceChanged':
    'The copy could not be completed because the application was being saved while it was copied. Try again in a few minutes.',
  'app.pages.FileManagerPage.fileOperationStatusUnreachable':
    'The operation status is temporarily unreachable. Please wait and try again in a moment.',
  'app.pages.FileManagerPage.uploading': 'Uploading...',
  'app.pages.FileManagerPage.uploaded': 'Uploaded!',
  'app.pages.FileManagerPage.compressing': 'Compressing...',
  'app.pages.FileManagerPage.unzipping': 'Unzipping...',
  'app.pages.FileManagerPage.duplicating': 'Duplicating...',
  'app.pages.FileManagerPage.loadingLastPath': 'Loading last path..',
  'app.pages.FileManagerPage.uploadCancelled': 'Upload cancelled by the user',
  'app.pages.FileManagerPage.deleting': 'Deleting',
  'app.pages.FileManagerPage.creating': 'Creating the folder',
  'app.pages.FileManagerPage.pastingFiles': 'Pasting files',
  'app.pages.FileManagerPage.configuringAccess': 'Configuring access',
  'app.pages.FileManagerPage.downloading': 'Downloading...',
  'app.pages.FileManagerPage.downloadReady': 'Download ready',
  'app.pages.FileManagerPage.duplicateTitle': 'Duplicate {name}',
  'app.pages.FileManagerPage.wantToDuplicate':
    'Are you sure you want to duplicate the selected item at the same directory?',
  'app.pages.FileManagerPage.dragDropFilesHere': 'Drag and drop files here or',
  'app.pages.FileManagerPage.overWriteFileOrFolder': 'Overwrite file or folder',
  'app.pages.FileManagerPage.overWriteFileOrFolderMessage':
    'Are you sure you want to overwrite {name}?',
  'app.pages.FileManagerPage.clearClipboard': 'Empty clipboard',
  'app.pages.FileManagerPage.clipboardCleared': 'Clipboard empty',
  'app.pages.FileManagerPage.copyToWorkspaceTitle': 'Copy to workspace',
  'app.pages.FileManagerPage.copyToWorkspaceMessage':
    'Are you sure you want to copy {name} to your workspace?',
  'app.pages.FileManagerPage.copyingToWorkspace': 'Copying to workspace',
  'app.pages.FileManagerPage.copiedToWorkspace': 'Copied to workspace',
  'app.pages.FileManagerPage.openTextEditor': 'Open text editor',
  'app.pages.FileManagerPage.loadingFile': 'Loading file',
  'app.pages.FileManagerPage.savingFile': 'Saving file',
  'app.pages.FileManagerPage.fileSaved': 'File saved',
  'app.pages.FileManagerPage.fileTooLargeToRead': 'File too large to read. Max size: 1MB',
  'app.pages.FileManagerPage.copyUrl': 'Copy url',
  'app.pages.FileManagerPage.copyPath': 'Copy path',
  'app.pages.FileManagerPage.goToContainingFolder': 'Go to containing folder',
  'app.pages.FileManagerPage.urlCopied': 'URL copied',
  'app.pages.FileManagerPage.errorUploading': 'There was an error uploading file',
  'app.pages.FileManagerPage.errorUploadingFiles': 'The following files could not be uploaded:',
  'app.pages.FileManagerPage.pathCopied': 'Path copied',
  'app.pages.FileManagerPage.copyingFiles': 'Copying files',
  'app.pages.FileManagerPage.movingFiles': 'Moving files',
  'app.pages.FileManagerPage.preparingDownload': 'Preparing download',
  'app.pages.FileManagerPage.processingFiles': 'Processing files',

  //Actions (for logManager filter)
  'app.pages.managers.logManager.actions.openApp': 'Open app',
  'app.pages.managers.logManager.actions.navigateDiagram': 'Navigate diagram',
  'app.pages.managers.logManager.actions.getArrows': 'Get Arrows',
  'app.pages.managers.logManager.actions.getToolbars': 'Get Toolbars',
  'app.pages.managers.logManager.actions.lastOpenApps': 'Last Open Apps',
  'app.pages.managers.logManager.actions.changeToOtherInstance': 'Change to other instance',
  'app.pages.managers.logManager.actions.getNodeProperties': 'Get Node Properties',
  'app.pages.managers.logManager.actions.setNodeProperties': 'Set Node Properties',
  'app.pages.managers.logManager.actions.setNodesProperties': 'Set Nodes Properties',
  'app.pages.managers.logManager.actions.getNodeInputs': 'Get Node Inputs',
  'app.pages.managers.logManager.actions.getNodeOutputs': 'Get Node Outputs',
  'app.pages.managers.logManager.actions.searchNodes': 'Search Nodes',
  'app.pages.managers.logManager.actions.searchForAutocomplete': 'Search For Autocomplete',
  'app.pages.managers.logManager.actions.previewNode': 'Preview Node',
  'app.pages.managers.logManager.actions.getSelector': 'Get Selector',
  'app.pages.managers.logManager.actions.setNodesSize': 'Set Nodes Size',
  'app.pages.managers.logManager.actions.setNodesPosition': 'Set Nodes Position',
  'app.pages.managers.logManager.actions.getNodeProfile': 'Get Node Profile',
  'app.pages.managers.logManager.actions.createNode': 'Create Node',
  'app.pages.managers.logManager.actions.deleteNodes': 'Delete Nodes',
  'app.pages.managers.logManager.actions.createAlias': 'Create Alias',
  'app.pages.managers.logManager.actions.createInputNode': 'Create Input Node',
  'app.pages.managers.logManager.actions.copyNodes': 'Copy Nodes',
  'app.pages.managers.logManager.actions.copyAsValues': 'Copy As Values',
  'app.pages.managers.logManager.actions.moveNodes': 'Move Nodes',
  'app.pages.managers.logManager.actions.stop': 'Stop',
  'app.pages.managers.logManager.actions.setNodeZ': 'Set Node Z',
  'app.pages.managers.logManager.actions.setNodeIdFromTitle': 'Set Node Id From Title',
  'app.pages.managers.logManager.actions.executeForRefresh': 'Execute For Refresh',
  'app.pages.managers.logManager.actions.exportFlatNode': 'Export Flat Node',
  'app.pages.managers.logManager.actions.exportCurrentNode': 'Export Current Node',
  'app.pages.managers.logManager.actions.exportModuleToFile': 'Export Module to File',
  'app.pages.managers.logManager.actions.importModuleFromFile': 'Import Module from File',
  'app.pages.managers.logManager.actions.getFilesForImportWizard': 'Get Files for Import Wizard',
  'app.pages.managers.logManager.actions.callWizard': 'Call Wizard',
  'app.pages.managers.logManager.actions.executeButton': 'Execute Button',
  'app.pages.managers.logManager.actions.isInBackground': 'Is in Background',
  'app.pages.managers.logManager.actions.uploadFileToTemp': 'Upload File to Temp',
  'app.pages.managers.logManager.actions.installLibrary': 'Install Library',
  'app.pages.managers.logManager.actions.listInstalledLibraries': 'List Installed Libraries',
  'app.pages.managers.logManager.actions.uninstallLibrary': 'Uninstall Library',
  'app.pages.managers.logManager.actions.getInstallProgress': 'Get Install Progress',
  'app.pages.managers.logManager.actions.getMainFolders': 'Get Main Folders',
  'app.pages.managers.logManager.actions.getFiles': 'Get Files',
  'app.pages.managers.logManager.actions.createFolder': 'Create Folder',
  'app.pages.managers.logManager.actions.copyFileOrFolder': 'Copy File Or Folder',
  'app.pages.managers.logManager.actions.renameFile': 'Rename File',
  'app.pages.managers.logManager.actions.duplicateFiles': 'Duplicate Files',
  'app.pages.managers.logManager.actions.moveFiles': 'Move Files',
  'app.pages.managers.logManager.actions.copyFiles': 'Copy Files',
  'app.pages.managers.logManager.actions.deleteFiles': 'Delete Files',
  'app.pages.managers.logManager.actions.upload': 'Upload',
  'app.pages.managers.logManager.actions.unzipFile': 'Unzip File',
  'app.pages.managers.logManager.actions.zipFiles': 'Zip Files',
  'app.pages.managers.logManager.actions.getHome': 'Get Home',
  'app.pages.managers.logManager.actions.optimizeTemplates': 'Optimize Templates',
  'app.pages.managers.logManager.actions.myReports': 'My Reports',
  'app.pages.managers.logManager.actions.sharedWithMe': 'Reports Shared with Me',
  'app.pages.managers.logManager.actions.mySharedReports': 'My Shared Reports',
  'app.pages.managers.logManager.actions.reportManager': 'Report Endpoints',
  'app.pages.managers.logManager.actions.getNavigator': 'Report - Get Navigator',
  'app.pages.managers.logManager.actions.bulkDelete': 'Report - Bulk Delete',
  'app.pages.managers.logManager.actions.changeOrder': 'Report - Change Order',
  'app.pages.managers.logManager.actions.search': 'Report - Search',
  'app.pages.managers.logManager.actions.duplicateItems': 'Report - Duplicate Items',
  'app.pages.managers.logManager.actions.copyToMyReports': 'Report - Copy to My Reports',
  'app.pages.managers.logManager.actions.setAsFav': 'Report - Set as Fav',
  'app.pages.managers.logManager.actions.dropOnReport': 'Report - Drop on Report',
  'app.pages.managers.logManager.actions.exportItems': 'Report - Export Items',
  'app.pages.managers.logManager.actions.importItems': 'Report - Import Items',
  'app.pages.managers.logManager.actions.publishItems': 'Report - Publish Items',
  'app.pages.managers.logManager.actions.shares': 'Get Shares',
  'app.pages.managers.logManager.actions.setShares': 'Set Shares',
  'app.pages.managers.logManager.actions.myDashboards': 'My Dashboards',
  'app.pages.managers.logManager.actions.companyDashboards': 'Dashboard - Company Dashboards',
  'app.pages.managers.logManager.actions.dashboardsSharedWithMe': 'Dashboard - Shared with Me',
  'app.pages.managers.logManager.actions.allMyDashboards': 'Dashboard - All My Dashboards',
  'app.pages.managers.logManager.actions.mySharedDashboards': 'Dashboard - My Shared Dashboards',
  'app.pages.managers.logManager.actions.dashboardById': 'Dashboard - By id',
  'app.pages.managers.logManager.actions.getNodeFullData': 'Dashboard - Get Node Full Data',
  'app.pages.managers.logManager.actions.evaluateNode': 'Dashboard - Evaluate Node',
  'app.pages.managers.logManager.actions.getOrCreate': 'Dashboard - Get or Create',
  'app.pages.managers.logManager.actions.dashboardManager': 'Dashboard Endpoints',
  'app.pages.managers.logManager.actions.dashboardBulkDelete': 'Dashboard - Bulk Delete',
  'app.pages.managers.logManager.actions.dashboardChangeOrder': 'Dashboard - Change Order',
  'app.pages.managers.logManager.actions.getIndexValues': 'Dashboard - Get Index Values',
  'app.pages.managers.logManager.actions.getNodeIndexes': 'Dashboard - Get Node Indexes',
  'app.pages.managers.logManager.actions.isResultComputed': 'Dashboard - Is Result Computed',
  'app.pages.managers.logManager.actions.lastOpenDashboards': 'Dashboard - Last Open Dashboards',
  'app.pages.managers.logManager.actions.copy': 'Dashboard - Copy',
  'app.pages.managers.logManager.actions.getCubeMetadata':
    'Dashboard - Pivot Grid - Get Cube Metadata',
  'app.pages.managers.logManager.actions.getCubeValues': 'Dashboard - Pivot Grid - Get Cube Values',
  'app.pages.managers.logManager.actions.setCubeChanges':
    'Dashboard - Pivot Grid - Set Cube Changes',
  'app.pages.managers.logManager.actions.getDimensionValues':
    'Dashboard - Pivot Grid - Get Dimension Values',
  'app.pages.managers.logManager.actions.tokenAuthEndpoints': 'Token Auth Endpoints',
  'app.pages.managers.logManager.actions.sendPasswordResetEmail': 'Send Password Reset Email',
  'app.pages.managers.logManager.actions.passwordReset': 'Password Reset',
  'app.pages.managers.logManager.actions.authEndpoints': 'Auth Endpoints',
  'app.pages.managers.logManager.actions.createInstance': 'Create Instance',
  'app.pages.managers.logManager.actions.getInstance': 'Get Instance',
  'app.pages.managers.logManager.actions.logout': 'Logout',
  'app.pages.managers.logManager.actions.getAllInstances': 'Get All Instances',
  'app.pages.managers.logManager.actions.getMyInstances': 'Get My Instances',
  'app.pages.managers.logManager.actions.killInstanceById': 'Kill Instance by Id',
  'app.pages.managers.logManager.actions.createNewInstance': 'Create New Instance',
  'app.pages.managers.logManager.actions.useExternalLink': 'Use External Link',
  'app.pages.managers.logManager.actions.getSystemResources': 'Get System Resources',
  'app.pages.managers.logManager.actions.requireLogout': 'Require Logout',
  'app.pages.managers.logManager.actions.getGeoData': 'Geo - Get Geo Data',
  'app.pages.managers.logManager.actions.getGeoDetail': 'Geo - Get Geo Detail',
  'app.pages.managers.logManager.actions.getBubbleInfo': 'Geo - Get Bubble Info',
  'app.pages.managers.logManager.actions.inputForm': 'Input Templates - List',
  'app.pages.managers.logManager.actions.getMetadata': 'Input Forms - Get Metadata',
  'app.pages.managers.logManager.actions.getData': 'Input Templates - Get Data',
  'app.pages.managers.logManager.actions.setData': 'Input Templates - Set Data',
  'app.pages.managers.logManager.actions.result': 'Result Endpoints',
  'app.pages.managers.logManager.actions.resultByNodeId': 'Result - By node id',
  'app.pages.managers.logManager.actions.activities': 'Activities Endpoints',
  'app.pages.managers.logManager.actions.groups': 'Groups Endpoints',
  'app.pages.managers.logManager.actions.updateGroupsPermissions':
    'Groups - Update Groups Permissions',
  'app.pages.managers.logManager.actions.users': 'Users Endpoints',
  'app.pages.managers.logManager.actions.companies': 'Companies Endpoints',
  'app.pages.managers.logManager.actions.preferenceByCode': 'Companies - Preference by code',
  'app.pages.managers.logManager.actions.preferences': 'Companies - Preferences',
  'app.pages.managers.logManager.actions.usercompanies': 'User Companies Endpoints',
  'app.pages.managers.logManager.actions.listByCompanyId': 'User Companies - List by Company id',
  'app.pages.managers.logManager.actions.userPreferenceByCode':
    'User Companies - Preference by code',
  'app.pages.managers.logManager.actions.userPreferences': 'User Companies - Preferences',
  'app.pages.managers.logManager.actions.permissions': 'Permissions Endpoints',
  'app.pages.managers.logManager.actions.departments': 'Departments Endpoints',
  'app.pages.managers.logManager.actions.byCurrentCompany': 'Departments - By Current Company',
  'app.pages.managers.logManager.actions.denied': 'Departments - Denied',
  'app.pages.managers.logManager.actions.denyItems': 'Departments - Deny Items',
  'app.pages.managers.logManager.actions.dashboardComments': 'Dashboard Comments Endpoints',
  'app.pages.managers.logManager.actions.dashboardStyles': 'Dashboard Styles Endpoints',
  'app.pages.managers.logManager.actions.diagramShortcut': 'Diagram Shortcut Endpoints',
  'app.pages.managers.logManager.actions.preferenceModules': 'Preference Modules Endpoints',
  'app.pages.managers.logManager.actions.preferencesEndpoints': 'Preferences Endpoints',
  'app.pages.managers.logManager.actions.userCompanyPreferences':
    'User Company Preferences Endpoints',
  'app.pages.managers.logManager.actions.companyPreferences': 'Company Preferences Endpoints',
  'app.pages.managers.logManager.actions.apiEndpoints': 'API endpoints',
  'app.pages.managers.logManager.actions.reportExternalLink': 'Report External link endpoints',
  'app.pages.managers.logManager.actions.dashboardExternalLink':
    'Dashboard External link endpoints',
  'app.pages.managers.logManager.actions.scheduler': 'Scheduler Endpoints',
  'app.pages.managers.logManager.actions.getPythonTimezones': 'Scheduler - Get Timezones',
  'app.pages.managers.logManager.actions.taskLog': 'TaskLog Endpoints',
  'app.pages.managers.logManager.actions.byPeriodicTask': 'TaskLog - By Periodic Task',
  'app.pages.managers.logManager.actions.filterLogs': 'TaskLog - Filter Logs',
  'app.pages.managers.logManager.actions.logging': 'Logging Endpoints',
  'app.pages.managers.logManager.actions.restAuth': 'Rest Auth Endpoints',
  'app.pages.managers.logManager.actions.accounts': 'Accounts Endpoints',
  'app.pages.managers.logManager.actions.createNewApp': 'Create New App',
  'app.pages.managers.logManager.actions.setSelectorValue': 'Set Selector Value',
  'app.pages.managers.logManager.actions.getSelectorValue': 'Get Selector Value',
  'app.pages.managers.logManager.actions.getSelectorOptionsAndIndex':
    'Get Selector Options and Index',
  'app.pages.managers.logManager.actions.getSelectorParams': 'Get Selector Params',
  'app.pages.managers.logManager.actions.getChoice': 'Get Choice',
  'app.pages.managers.logManager.actions.setChoiceValue': 'Set Choice Value',
  'app.pages.managers.logManager.actions.getChoiceValue': 'Get Choice Value',
  'app.pages.managers.logManager.actions.getChoiceOptions': 'Get Choice Options',
  'app.pages.managers.logManager.actions.getChoiceOptionsAndIndex': 'Get Choice Options and Index',
  'app.pages.managers.logManager.actions.getChoiceParams': 'Get Choice Params',
  'app.pages.managers.logManager.actions.setInputScalarValue': 'Set Input Scalar Value',
  'app.pages.managers.logManager.actions.callFunction': 'Call Function',
  'app.pages.managers.logManager.actions.getWorkspaceAndPublic': 'Get Workspace and Public',
  'app.pages.managers.logManager.actions.searchFiles': 'Search Files',
  'app.pages.managers.logManager.actions.departmentsByCompanyId': 'Departments - By Company id',
  'app.pages.managers.logManager.actions.interfaces': 'Interfaces Endpoints',
  'app.pages.managers.logManager.actions.getAllInterfaces': 'Interfaces - Get All',
  'app.pages.managers.logManager.actions.listInterfaces': 'Interfaces - List',
  'app.pages.managers.logManager.actions.searchInterfaces': 'Interfaces - Search',
  'app.pages.managers.logManager.actions.createInterface': 'Interfaces - Create',
  'app.pages.managers.logManager.actions.updateInterface': 'Interfaces - Update',
  'app.pages.managers.logManager.actions.removeInterface': 'Interfaces - Remove',
  'app.pages.managers.logManager.actions.copyInterface': 'Interfaces - Copy',
  'app.pages.managers.logManager.actions.moveInterface': 'Interfaces - Move',
  'app.pages.managers.logManager.actions.duplicateInterface': 'Interfaces - Duplicate',
  'app.pages.managers.logManager.actions.exportInterfaces': 'Interfaces - Export',
  'app.pages.managers.logManager.actions.importInterface': 'Interfaces - Import',
  'app.pages.managers.logManager.actions.createInterfaceFolder': 'Interfaces - Create Folder',
  'app.pages.managers.logManager.actions.removeInterfaceFolder': 'Interfaces - Remove Folder',
  'app.pages.managers.logManager.actions.setInterfacePermission': 'Interfaces - Set Permission',
  'app.pages.managers.logManager.actions.getInterfaceIndexValues': 'Interfaces - Get Index Values',
  'app.pages.managers.logManager.actions.applyFormChanges': 'Apply Form Changes',
  'app.pages.managers.logManager.actions.applyTableChanges': 'Apply Table Changes',
  'app.pages.managers.logManager.actions.interfaceExternalLink':
    'Interface External Link Endpoints',

  //Applications
  'app.pages.applications.createApp': 'Create App',
  'app.pages.applications.applicationName': 'Application name',
  'app.pages.applications.fromScratch': 'From scratch',
  'app.pages.applications.fromScratchDescription': 'Starts with a simple "Hello world" example',
  'app.pages.applications.fromDataAnalytics': 'Data analytics',
  'app.pages.applications.fromDataAnalyticsDescription': 'Example of a data analytics application',
  'app.pages.applications.fromBusinessPlanning': 'Business planning',
  'app.pages.applications.fromBusinessPlanningDescription':
    'Example of a business planning application',
  'app.pages.applications.applicationManager': 'Application manager',
  'app.pages.applications.deleteAppTitle': 'Delete application',
  'app.pages.applications.deleteAppMessage': 'Are you sure you want to delete this application?',
  'app.pages.applications.results': 'Results',
  'app.pages.applications.applicationDeleted': 'Application deleted',
  'app.pages.applications.deletingApplication': 'Deleting application',
  'app.pages.applications.applicationNameChanged': 'Application name changed',
  'app.pages.applications.path': 'Path',
  'app.pages.applications.copyAppToWorkspaceTitle': 'Copy application to workspace',
  'app.pages.applications.copyAppToWorkspaceMessage':
    'Are you sure you want to copy this application to your workspace?',
  'app.pages.applications.appCopiedToWorkspace': 'Application successfully copied in:',
  'app.pages.applications.copyingAppToWorkspace': 'Copying application to workspace',
  'app.pages.applications.appImported': 'Application imported successfully',
  'app.pages.applications.createInPublic': 'Create in Public workspace',
  'app.pages.applications.appCopied': 'Application copied',
  'app.pages.applications.copyingAppToTeam': 'Copying application to team',
  'app.pages.applications.copyAppToPublicMessage':
    'Are you sure you want to copy this application to Public workspace?',
  'app.pages.applications.appCopiedToPublic': 'Application copied to Public workspace',
  'app.pages.applications.copyingAppToPublic': 'Copying application to Public',
  'app.pages.applications.setThumbnail': 'Set thumbnail',
  'app.pages.applications.replaceThumbnail': 'Replace thumbnail',
  'app.pages.applications.removeThumbnail': 'Remove thumbnail',
  'app.pages.applications.removeThumbnailMessage': 'Are you sure to remove thumbnail?',
  'app.pages.applications.thumbnailRemoved': 'Thumbnail removed',
  'app.pages.applications.thumbnailUploaded': 'Thumbnail uploaded',
  'app.pages.applications.loadingAppMessage': 'Loading application',
  'app.pages.applications.folderDuplicated': 'Folder duplicated',
  'app.pages.applications.deleteFolderMessage': 'Are you sure you want to delete this folder?',
  'app.pages.applications.deleteFolderTitle': 'Delete folder',
  'app.pages.applications.folderDeleted': 'Folder deleted',
  'app.pages.applications.folderCutted': 'Folder cutted',
  'app.pages.applications.folderCopied': 'Folder copied',
  'app.pages.applications.elementsPasted': 'Elements pasted',
  'app.pages.applications.showHiddenFolders': 'Show hidden folders',
  'app.pages.applications.copyAppSubMenu': 'Other copy options',
  'app.pages.applications.keepId': 'Keep application id',
  'app.pages.applications.directAccessLink': 'Direct access link',
  'app.pages.applications.directAccessLinkCopied': 'Direct access link copied successfully',
  'app.pages.applications.directAccessLinkError': 'Unable to generate the direct access link',
  'app.pages.applications.directAccessLinkDialogTitle': 'Generate direct access link',
  'app.pages.applications.directAccessLinkDefaultVersion': 'Use default version',
  'app.pages.applications.generatedLink': 'Generated link',
  'app.pages.applications.installOnPublic': 'Install on public',
  'app.pages.applications.generateDirectAccessLink': 'Generate link',

  //Application Summary

  'app.pages.applications.id': 'Application ID',
  'app.pages.applications.version': 'Application version',
  'app.pages.applications.uri': 'Location',
  'app.pages.applications.isPublic': 'Is in Public folder',
  'app.pages.applications.canwrite': 'Has write permission',
  'app.pages.applications.venvPath': 'Virtual environment path',
  'app.pages.applications.pythonVersion': 'Python version',
  'app.pages.applications.cpuArchitecture': 'CPU architecture',
  'app.pages.app.cpuArchitecture.x86': 'x86',
  'app.pages.app.cpuArchitecture.arm': 'ARM',

  //Icon selector
  'app.pages.iconSelector.iconType': 'Icon type',
  'app.pages.iconSelector.iconName': 'Icon name',
  'app.pages.iconSelector.solid': 'Solid',
  'app.pages.iconSelector.regular': 'Regular',

  //Versions
  'app.pages.versions.versionManager': 'Version manager',
  'app.pages.versions.deleteVersionTitle': 'Delete version',
  'app.pages.versions.deleteVersionMessage': 'Are you sure you want to delete version {version}?',
  'app.pages.versions.deleteVersionsMessage':
    'Are you sure you want to delete versions {versions}?',
  'app.pages.versions.versionDeleted': 'Version "{version}" was deleted',
  'app.pages.versions.versionsDeleted': 'Versions "{versions}" were deleted',
  'app.pages.versions.deletingVersion': 'Deleting version',
  'app.pages.versions.createVersion': 'Create version',
  'app.pages.versions.fromVersion': 'From version',
  'app.pages.versions.versionCreated': 'Version "{version}" was successfully created',
  'app.pages.versions.creationDate': 'Creation date',
  'app.pages.versions.closingDate': 'Closing date',
  'app.pages.versions.archiveDate': 'Archive date',
  'app.pages.versions.lastModifiedDate': 'Last modified date',
  'app.pages.versions.viewDetails': 'View details',
  'app.pages.versions.detailsVersionTitle': 'Version Details',
  'app.pages.versions.closedBy': 'Closed by',
  'app.pages.versions.archivedBy': 'Archived by',
  'app.pages.versions.lastModifiedBy': 'Last modified by',
  'app.pages.versions.status.active': 'Active',
  'app.pages.versions.status.closed': 'Closed',
  'app.pages.versions.status.archived': 'Archived',
  'app.pages.versions.status.unarchived': 'Unarchived',
  'app.pages.versions.setAsDefaultVersion': 'Set as default version',
  'app.pages.versions.setPermission': 'Set permission',
  'app.pages.versions.versionPermissionChanged': 'Version permission changed',
  'app.pages.versions.hasDepartmentRestrictions': 'This version has department access restrictions',
  'app.pages.versions.isDefaultAppVersion': 'Is the default version of the app',
  'app.pages.versions.setAsDefaultVersionMessage':
    'Are you sure you want to set version "{version}" as the default version of the app?',
  'app.pages.versions.defaultVersionChanged': 'Default version changed',
  'app.pages.versions.editProperties': 'Edit properties',
  'app.pages.versions.cannotDeleteReason':
    'It is not possible to delete the current open version of the app',
  'app.pages.versions.versionModified': 'Version {version} was successfully modified',
  'app.pages.versions.versionsModified': 'Versions {versions} were successfully modified',
  'app.pages.versions.cannotModifyNameReason':
    'It is not possible to modify the name of the current open version of the app',
  'app.pages.versions.updateVersionStatus': 'Update version status',
  'app.pages.versions.updateVersionStatusMessage':
    'Are you sure you want to update {version} version status to "{newStatus}"?',
  'app.pages.versions.updateVersionsStatusMessage':
    'Are you sure you want to update {versions} versions status to "{newStatus}"?',
  'app.pages.versions.importVersions': 'Import versions',
  'app.pages.versions.exportVersions': 'Export versions',
  'app.pages.versions.cannotChangeReason':
    'It is not possible to change the current open version of the app',
  'app.pages.versions.versionsImported': 'Uploaded versions were successfully imported',
  'app.pages.versions.uploadInstructions':
    'Upload a single .zip file that contains a folder for each version you want to import',
  'app.pages.versions.openAppVersion': 'Open app version',
  'app.pages.versions.openAppVersionOnNewInstance': 'Open app version on new instance',
  'app.pages.versions.excludeArchivedVersions': 'Exclude archived versions',
  'app.pages.versions.versionSelectedScenariosUpdated':
    'Version selected scenarios were successfully loaded',
  'app.pages.versions.openAfterCreating': 'Open after creating',
  'app.pages.versions.versionGroup': 'Version group',
  'app.pages.versions.versionGroupPathHelp':
    'Use / to create nested groups, for example Finance/Budget/2026.',
  'app.pages.versions.uncategorized': 'Not grouped',
  'app.pages.versions.moreActions': 'More actions',
  'app.pages.versions.unsavedChangesMessage':
    'Any unsaved changes from the open version will be lost',
  'app.pages.versions.versionExported': 'Version exported',
  'app.pages.versions.versionsExported': 'Versions exported',
  'app.pages.versions.nameExists': 'Version name already exists',
  'app.pages.versions.openExistingVersion': 'Open existing version',
  'app.pages.versions.createNewVersion': 'Create new version',
  'app.pages.versions.manageVersions': 'Manage versions',
  'app.pages.versions.createNewVersionFromThis': 'Create new version from this',
  'app.pages.versions.createNewVersionInMyWorkspace': 'Create new version in my workspace',
  'app.pages.versions.createNewVersionInMyWorkspaceConfirmation':
    "You don't have write permissions in the selected app's directory. The app will be copied to your workspace (if it doesn't exist) and the new version will be created there.",
  'app.pages.versions.newVersionName': 'New version name',
  'app.pages.versions.sourceVersion': 'Source version',
  'app.pages.versions.technicalVersion': 'Technical version',
  'app.pages.versions.technicalVersionFormatError':
    'It must have three groups of digits separated by dots (e.g. 3.21.005)',
  'app.pages.versions.technicalVersionHelp':
    'Semantic version identifier: three groups of digits separated by dots, for example 3.21.005.',
  'app.pages.versions.otherUserWithWritePermissions':
    'This version is currently being used by {user} with write permissions',
  'app.pages.versions.inThisApplication': 'In this application',
  'app.pages.versions.inAnotherApplication': 'In another application',
  'app.pages.versions.loadArchivedMetadata': 'Load archived versions metadata',
  'app.pages.versions.archivedMetadataLoaded': 'Archived versions metadata loaded',

  //Process manager
  'app.pages.app.processManager.addProcess': 'Add process',
  'app.pages.app.processManager.editProcess': 'Edit process',
  'app.pages.app.processManager.duplicateProcess': 'Duplicate process',
  'app.pages.app.processManager.showDescription': 'Show description',
  'app.pages.app.processManager.noDescriptionText': 'There is not description',
  'app.pages.app.processManager.processTodo': 'To do',
  'app.pages.app.processManager.process': 'Process',
  'app.pages.app.processManager.subscribers': 'Subscribers',
  'app.pages.app.processManager.status': 'Status',
  'app.pages.app.processManager.description': 'Description',
  'app.pages.app.processManager.group': 'group',
  'app.pages.app.processManager.task': 'Task',
  'app.pages.app.processManager.taskResponsible': 'Task responsible',
  'app.pages.app.processManager.taskResponsibles': 'Task responsibles',
  'app.pages.app.processManager.taskActionType': 'Action type',
  'app.pages.app.processManager.isBlockedBy': 'Is blocked by',
  'app.pages.app.processManager.expiration': 'Expiration',
  'app.pages.app.processManager.expirationType': 'Expiration type',
  'app.pages.app.processManager.createGroup': 'Create group',
  'app.pages.app.processManager.editGroup': 'Edit group',
  'app.pages.app.processManager.groupsAndTasks': 'Groups and tasks',
  'app.pages.app.processManager.processWithoutGroups': 'This process has no groups yet',
  'app.pages.app.processManager.processWithoutGroupsHint':
    'A group holds the tasks of one stage — create the first one to add tasks.',
  'app.pages.app.processManager.processWithoutGroupsNeedsName':
    'Name the process first, and then create its first group.',
  'app.pages.app.processManager.groupWithoutTasks': 'No tasks in this group yet',
  'app.pages.app.processManager.expirationDaysValue': '{days, plural, one {# day} other {# days}}',
  'app.pages.app.processManager.expirationHoursValue':
    '{hours, plural, one {# hour} other {# hours}}',
  'app.pages.app.processManager.expirationMinutesValue':
    '{minutes, plural, one {# minute} other {# minutes}}',
  'app.pages.app.processManager.expirationFromProcess': 'from the process start',
  'app.pages.app.processManager.expirationFromBlocker': 'from the blocking task',
  'app.pages.app.processManager.expirationImmediate': 'Immediately',
  'app.pages.app.processManager.sinceProcess': 'since the process was initiated',
  'app.pages.app.processManager.sinceBlockingTaskCompleted': 'since blocking task was completed',
  'app.pages.app.processManager.processCreated': 'Process created',
  'app.pages.app.processManager.processUpdated': 'Process updated',
  'app.pages.app.processManager.processDuplicated': 'Process duplicated',
  'app.pages.app.processManager.undefined': 'Undefined',
  'app.pages.app.processManager.processDeleted': 'Process deleted',
  'app.pages.app.processManager.processNotFound': 'Process not found',
  'app.pages.app.processManager.deleteProcess': 'Delete process',
  'app.pages.app.processManager.deleteProcessMessage':
    '¿Are you sure you want to delete this process?',
  'app.pages.app.processManager.reviewers': 'Reviewers',
  'app.pages.app.processManager.reviewerInterface': 'Reviewer interface',
  'app.pages.app.processManager.taskApp': 'Application',
  'app.pages.app.processManager.taskAppPlaceholder': "The process's application",
  'app.pages.app.processManager.taskAppDefault': "Uses the process's application",
  'app.pages.app.processManager.taskAppVersion': 'Version',
  'app.pages.app.processManager.taskAppVersionIsDefault': '(default today)',
  'app.pages.app.processManager.taskAppVersionDefault': 'Default version',
  'app.pages.app.processManager.runAs': 'Run as',
  'app.pages.app.processManager.noAgentUsers':
    'To assign an agent, create an agent user first from the User manager.',
  'app.pages.app.processManager.responsibleAgent': 'Responsible agent',
  'app.pages.app.processManager.reviewerAgent': 'Reviewer agent',
  'app.pages.app.processManager.selectAgent': 'Select an agent',
  'app.pages.app.processManager.peopleGroup': 'People',
  'app.pages.app.processManager.agentsGroup': 'Agents',
  'app.pages.app.processManager.oneAgentResponsibleOnly':
    'Only one agent can be responsible for a task.',
  'app.pages.app.processManager.agentRequired': 'Choose which agent runs this task.',
  'app.pages.app.processManager.agentSelfApproval':
    'The reviewer agent has to be different from the one doing the work.',
  'app.pages.app.processManager.personSelfReview':
    'A responsible of the task cannot also be its reviewer.',
  'app.pages.app.processManager.agentWorking': 'Agent working',
  'app.pages.app.processManager.agentTooltip': 'Agent',
  'app.pages.managers.agentAccessTokens': 'Access tokens',
  'app.pages.managers.isAgent': 'This user is an agent',
  'app.pages.managers.isAgentHelp':
    'An agent cannot sign in and has no password. It can be assigned to process tasks so an agent does the work.',
  'app.pages.app.processManager.expirationDays': 'Expiration days',
  'app.pages.app.processManager.collaborators': 'Collaborators',
  'app.pages.app.processManager.deleteGroupTitle': '¿Are you sure you want to delete this group?',
  'app.pages.app.processManager.deleteGroupMessage': 'Contains the following tasks',
  'app.pages.app.processManager.deleteTaskTitle': 'Delete this task?',
  'app.pages.app.processManager.deleteWaitingTasks':
    'These tasks wait for what you are deleting. The ones left without a blocking task keep their due date, counted from the process start from now on, and can start right away.',
  'app.pages.app.processManager.dueTypeNeedsBlocker': 'Choose a blocking task first',
  'app.pages.app.processManager.marginSummaryTitle': 'Some due dates do not fit',
  'app.pages.app.processManager.marginSummaryNone':
    '“{task}” is due on {date}, at the same time as “{blocker}”, which it waits for.',
  'app.pages.app.processManager.marginSummaryNegative':
    '“{task}” is due on {taskDate}, but “{blocker}”, which it waits for, is due on {blockerDate} ({gap} later).',
  'app.pages.app.processManager.dueAfterEndSummary':
    '“{task}” is due on {due}, after the process ends on {end}.',
  'app.pages.app.processManager.marginSummaryReview': 'Review',
  'app.pages.app.processManager.marginSummarySave': 'Save anyway',
  'app.pages.app.processManager.marginNone':
    '“{blocker}”, which this task waits for, is due {blockerDue} after the process starts, and so is this task: there is no time left to do it.',
  'app.pages.app.processManager.marginNegative':
    '“{blocker}”, which this task waits for, is due {blockerDue} after the process starts. This task is due {gap} earlier, before it can even start.',
  'app.pages.app.processManager.marginFix': 'Count the days from when it is completed',
  'app.pages.app.processManager.addTask': 'Add task',
  'app.pages.app.processManager.editTask': 'Edit task',
  'app.pages.app.processManager.taskStatus.not_ready_to_start': 'Not ready to start',
  'app.pages.app.processManager.taskStatus.not_started': 'Not started',
  'app.pages.app.processManager.taskStatus.in_progress': 'In progress',
  'app.pages.app.processManager.taskStatus.pending_review': 'Pending review',
  'app.pages.app.processManager.taskStatus.completed': 'Completed',
  'app.pages.app.processManager.restartProcess': 'Restart process',
  'app.pages.app.processManager.processRestarted': 'Process restarted',
  'app.pages.app.processManager.autoCompleteOnDue': 'Auto-complete on due date',
  'app.pages.app.processManager.autoCompleteOnDueTooltip':
    'Automatically mark task as completed when due date is reached.',
  'app.pages.app.processManager.scheduledTaskOnFinish': 'Task on finish',
  'app.pages.app.processManager.requireAllResponsibleCompletion':
    'Require all responsibles to complete the task',
  'app.pages.app.processManager.requireAllResponsibleCompletionTooltip':
    'All responsibles must complete the task before it can be marked as completed. If unchecked, only one responsible is required to complete the task.',
  'app.pages.app.processManager.processExported': 'Process exported',
  'app.pages.app.processManager.processesExported': 'Processes exported',
  'app.pages.app.processManager.importProcesses': 'Import processes',
  'app.pages.app.processManager.importProcessesInstructions':
    'Select a processes export file (.json) to import',
  'app.pages.app.processManager.invalidImportFile': 'Invalid import file',
  'app.pages.app.processManager.processesImported': 'Processes imported',
  'app.pages.app.processManager.importWarningsTitle': 'Import warnings',
  'app.pages.app.processManager.importWarningsProcess': 'Process {processName}',
  'app.pages.app.processManager.importWarningsUnresolvedUsers': 'Unresolved users',
  'app.pages.app.processManager.importWarningsUnresolvedUserItem':
    'Task {taskName} - {role}: {identifier}',
  'app.pages.app.processManager.importWarningsRoleResponsible': 'responsible',
  'app.pages.app.processManager.importWarningsRoleReviewer': 'reviewer',
  'app.pages.app.processManager.importWarningsRoleCollaborator': 'collaborator',
  'app.pages.app.processManager.importWarningsRoleSubscriber': 'subscriber',
  'app.pages.app.processManager.importWarningsUnresolvedAgents': 'Unresolved agents',
  'app.pages.app.processManager.importWarningsUnresolvedAgentItem':
    'Task "{taskName}": the agent "{agentCode}" was not assigned',
  'app.pages.app.processManager.importWarningsUnresolvedActions': 'Unresolved actions/interfaces',
  'app.pages.app.processManager.importWarningsUnresolvedActionItem': 'Task {taskName} - {field}',
  'app.pages.app.processManager.importWarningsLostAutomations': 'Lost automations',
  'app.pages.app.processManager.importWarningsLostAutomationItem': 'Task {taskName}',

  //Scenarios
  'app.pages.scenarios.scenarioManager': 'Scenario manager',
  'app.pages.scenarios.deleteScenarioTitle': 'Delete scenario',
  'app.pages.scenarios.deleteScenarioMessage':
    'Are you sure you want to delete scenario "{scenario}"?',
  'app.pages.scenarios.deleteScenariosMessage':
    'Are you sure you want to delete scenarios "{scenarios}"?',
  'app.pages.scenarios.scenarioDeleted': 'Scenario "{scenario}" was deleted',
  'app.pages.scenarios.scenariosDeleted': 'Scenarios "{scenarios}" were deleted',
  'app.pages.scenarios.deletingScenario': 'Deleting scenario',
  'app.pages.scenarios.createScenario': 'Create scenario',
  'app.pages.scenarios.fromScenario': 'From scenario',
  'app.pages.scenarios.scenarioCreated': 'Scenario "{scenario}" was successfully created',
  'app.pages.scenarios.lastModifiedDate': 'Last modified date',
  'app.pages.scenarios.editProperties': 'Edit properties',
  'app.pages.scenarios.scenarioModified': 'Scenario "{scenario}" was successfully modified',
  'app.pages.scenarios.importScenarios': 'Import scenarios',
  'app.pages.scenarios.exportScenario': 'Export scenario',
  'app.pages.scenarios.scenariosImported': 'Uploaded scenarios were successfully imported',
  'app.pages.scenarios.uploadInstructions':
    'Upload a single .zip file that contains a folder for each version (with a folder for each scenario inside) you want to import',
  'app.pages.scenarios.alias': 'Alias',
  'app.pages.scenarios.includedNodes': 'Included nodes',
  'app.pages.scenarios.includeNodesFrom': 'Include nodes from',
  'app.pages.scenarios.currentInterface': 'Current interface',
  'app.pages.scenarios.nodesToBeEvaluatedBeforehand': 'Nodes to be evaluated beforehand',
  'app.pages.scenarios.nodesToBeEvaluatedAfterwards': 'Nodes to be evaluated afterwards',
  'app.pages.scenarios.runScenarioAfterSave': 'Run scenario after save',
  'app.pages.scenarios.addNode': 'Add node',
  'app.pages.scenarios.showCurrentVersionOnly': 'Show current version only',
  'app.pages.scenarios.scenarioAlreadyExists':
    'There is already a scenario with this name in "{version}" version',
  'app.pages.scenarios.scenarioDuplicated': 'Scenario "{scenario}" was successfully duplicated',
  'app.pages.scenarios.duplicateScenario': 'Duplicate scenario',
  'app.pages.scenarios.saveScenario': 'Save scenario',
  'app.pages.scenarios.cannotSaveScenarioReason': 'Cannot save scenarios if version is not active',
  'app.pages.scenarios.cannotChangeScenarioReason':
    'Cannot change scenarios if version is not active',
  'app.pages.scenarios.existingScenario': 'Existing scenario',
  'app.pages.scenarios.createNewScenario': 'Create new scenario',
  'app.pages.scenarios.baseScenario': 'Base scenario',
  'app.pages.scenarios.scenarioSaved': 'Scenario "{scenario}" was successfully saved',
  'app.pages.scenarios.noNodesMessage':
    "The selected scenario doesn't include any nodes to save. Edit this scenario in Scenario Manager to add them.",
  'app.pages.scenarios.selectScenarios': 'Select scenarios',
  'app.pages.scenarios.byInterfaceMode': 'By interface',
  'app.pages.scenarios.scenariosForInterface': 'Scenarios for interface: {interfaceName}',
  'app.pages.scenarios.modeUpdated': 'Scenario selection mode updated successfully',
  'app.pages.scenarios.selectedScenarios': 'Selected scenarios',
  'app.pages.scenarios.scenarioExported': 'Scenario exported successfully',
  'app.pages.scenarios.scenariosExported': 'Scenarios exported successfully',
  'app.pages.scenarios.scenariosManager': 'Scenarios manager',
  'app.pages.scenarios.scenariosTemplates': 'Scenarios templates',
  'app.pages.scenarios.createTemplate': 'Create template',
  'app.pages.scenarios.editTemplate': 'Edit template',
  'app.pages.scenarios.duplicateTemplate': 'Duplicate template',
  'app.pages.scenarios.deleteTemplate': 'Delete template',
  'app.pages.scenarios.scenarioTemplateSuccessfullyCreated':
    'Scenario template successfully created',
  'app.pages.scenarios.scenarioTemplateSuccessfullyModified':
    'Scenario template {template} successfully modified',
  'app.pages.scenarios.deleteScenarioTemplateTitle': 'Delete scenario template',
  'app.pages.scenarios.deleteScenarioTemplateMessage':
    'Are you sure you want to delete template {scenarioTemplate}?',
  'app.pages.scenarios.scenarioTemplateSuccessfullyDuplicated':
    'Scenario template {scenarioTemplate} successfully duplicated',
  'app.pages.scenarios.scenarioTemplateNameAlreadyExists':
    'There is already a scenario template with this name in "{version}" version',
  'app.pages.scenarios.templateName': 'Template name',
  'app.pages.scenarios.scenarioNodesTemplate': 'Scenario nodes template',
  'app.pages.scenarios.noOptionsTemplate': 'No template options',
  'app.pages.scenarios.addNewScenarioNodesTemplate': 'Add new scenario nodes template',
  'app.pages.scenarios.destinationVersion': 'Destination version',
  'app.pages.scenarios.updateSelectedScenarios': 'Load selected scenarios',
  'app.pages.scenarios.visibility.whoCanSee': 'Who can see this scenario',
  'app.pages.scenarios.visibility.onlyMe': 'Only me',
  'app.pages.scenarios.visibility.everyone': 'Everyone',
  'app.pages.scenarios.visibility.byDepartments': 'Users from selected departments',
  'app.pages.scenarios.visibility.selectDepartments': 'Select departments',
  'app.pages.scenarios.visibility.selectDepartmentsPlaceholder': 'Choose departments...',
  'app.pages.scenarios.visibility.noDepartments': 'No departments available',
  'app.pages.scenarios.useCustomScenariosForInterface':
    'Custom scenario selection for interface {interfaceName}',

  //My tasks
  'app.pages.app.myTasks.title': 'My tasks',
  'app.pages.app.myTasks.statusChanged': 'Status changed',
  'app.pages.app.myTasks.showComments': 'Show comments',
  'app.pages.app.myTasks.openTaskDetail': 'Open task detail and comments',
  'app.pages.app.myTasks.responsible': 'Responsible',
  'app.pages.app.myTasks.responsibles': 'Responsibles',
  'app.pages.app.myTasks.deadline': 'Deadline',
  'app.pages.app.myTasks.finished': 'Finished',
  'app.pages.app.myTasks.commentDeleted': 'Comment deleted',
  'app.pages.app.myTasks.comments': 'Comments',
  'app.pages.app.myTasks.deleteComment': 'Delete comment',
  'app.pages.app.myTasks.addComment': 'Add comment',
  'app.pages.app.myTasks.noAssignedTasks': 'No assigned tasks',
  'app.pages.app.myTasks.requestChangesTitle': 'Send the task back',
  'app.pages.app.myTasks.requestChangesHelp':
    'The task goes back to whoever is responsible for it. What you write is posted as a comment and is the first thing they will read.',
  'app.pages.app.myTasks.requestChangesAgentHint':
    'The agent responsible will start working again with this note.',
  'app.pages.app.myTasks.requestChangesLabel': 'What has to be corrected',
  'app.pages.app.myTasks.requestChangesConfirm': 'Send back',
  'app.pages.app.myTasks.requestChangesDone': 'Task sent back to the responsible',
  'app.pages.app.myTasks.process': 'Process',
  'app.pages.app.myTasks.view': 'View',
  'app.pages.app.myTasks.tableView': 'Table',
  'app.pages.app.myTasks.timelineView': 'Timeline',
  'app.pages.app.myTasks.startedOn': 'started {date}',
  'app.pages.app.myTasks.closesOn': 'closes {date}',
  'app.pages.app.myTasks.cycleProgress': 'Process progress',
  'app.pages.app.myTasks.tasksCompleted': '{completed} of {total} tasks completed',
  'app.pages.app.myTasks.deadlineHealth': 'Deadline health',
  'app.pages.app.myTasks.overdueTasks': 'overdue',
  'app.pages.app.myTasks.atRiskTasks': 'at risk',
  'app.pages.app.myTasks.runway':
    'Closes {date} — {days, plural, one {# day} other {# days}} of runway left',
  'app.pages.app.myTasks.noCloseDate': 'No close date set',
  'app.pages.app.myTasks.waitingOnMe': 'Waiting on me',
  'app.pages.app.myTasks.openTasksWithYou': 'open tasks with you',
  'app.pages.app.myTasks.waitingDetail':
    '{agents, plural, =0 {no agent working} one {# agent working now} other {# agents working now}}, {blocked, plural, =0 {none waiting on a blocker} other {# waiting on a blocker}}',
  'app.pages.app.myTasks.allMustComplete': 'all must complete',
  'app.pages.app.myTasks.anyCanComplete': 'any can complete',
  'app.pages.app.myTasks.deadlineCompleted': 'completed',
  'app.pages.app.myTasks.deadlineOverdue':
    '{days, plural, one {# day overdue} other {# days overdue}}',
  'app.pages.app.myTasks.deadlineOverdueToday': 'overdue',
  'app.pages.app.myTasks.deadlineToday': 'today',
  'app.pages.app.myTasks.deadlineIn': '{days, plural, one {in # day} other {in # days}}',
  'app.pages.app.myTasks.timelineTaskColumn': 'Task · responsibles',
  'app.pages.app.myTasks.review': 'Review',
  'app.pages.app.myTasks.sharedTask': 'Shared task',
  'app.pages.app.myTasks.taskStatus': 'Task status',
  'app.pages.app.myTasks.reviewRound': 'Round {round}',
  'app.pages.app.myTasks.sentBackAt': 'Sent back {date} by {author}',
  'app.pages.app.myTasks.openNamed': 'Open {name}',
  'app.pages.app.myTasks.saveResults': 'Save results',
  'app.pages.app.myTasks.noComments': 'No comments yet',
  'app.pages.app.myTasks.send': 'Send',
  'app.pages.app.myTasks.commentRoleAgent': 'agent',
  'app.pages.app.myTasks.commentRoleReviewer': 'reviewer',
  'app.pages.app.myTasks.commentRoleResponsible': 'responsible',
  'app.pages.app.myTasks.commentSentBack': 'sent back for changes',
  'app.pages.app.myTasks.agentStarting': 'Starting up…',
  'app.pages.app.myTasks.agentReportsBack': 'Report the outcome and move the task',
  'app.pages.app.myTasks.agentReportsBackHint': 'reports back as a comment when it finishes',
  'app.pages.app.myTasks.agentRun': 'Run {run}',
  'app.pages.app.myTasks.agentStartedAt': 'started {date}',
  'app.pages.app.myTasks.elapsedSeconds': '{seconds} s',
  'app.pages.app.myTasks.elapsedMinutes': '{minutes} min {seconds} s',
  'app.pages.app.myTasks.elapsedHours': '{hours} h {minutes} min',

  //General settings
  'app.pages.generalSettings.logsSettings': 'Logs settings',
  'app.pages.generalSettings.initialPrompt': 'Initial prompt',
  'app.pages.generalSettings.customValue': 'Custom Value',
  'app.pages.generalSettings.customValueRemoved': 'Custom value removed',
  'app.pages.generalSettings.customValueSaved': 'Custom value saved successfully',
  'app.pages.generalSettings.paramsPlaceholder': 'Enter the parameters in json format',

  //App Configuration
  'app.pages.app.appConfiguration': 'App configuration',
  'app.pages.app.installLibrariesOnOpen': 'Install libraries on open',
  'app.pages.app.openDefaultVersionOnOpen': 'Open default version on open',
  'app.pages.app.openAsReadOnlyByDefault': 'Open as read-only by default',
  'app.pages.app.defaultTabOnOpen': 'Default tab on open',
  'app.pages.app.applicationLanguage': 'Application language',
  'app.pages.app.quickMenu': 'Quick menu',
  'app.pages.app.quickMenu.fromInterface': 'From interface',
  'app.pages.app.quickMenu.noMenu': 'No menu found',

  //External links
  'app.pages.externalLink.deleteMessage': 'Are you sure you want to delete the external link?',
  'app.pages.externalLink.linkDeleted': 'External link deleted',
  'app.pages.externalLink.deleteTitle': 'Delete external link',
  'app.pages.externalLink.nodeId': 'Node id',
  'app.pages.externalLink.commonInstance': 'Common instance',
  'app.pages.externalLink.apiEndpoint': 'API endpoint',
  'app.pages.externalLink.linkUpdated': 'External link updated',
  'app.pages.externalLink.customEndpoint': 'Custom endpoint',
  'app.pages.externalLink.customEndpointError': 'Custom endpoint already exists',
  'app.pages.externalLink.externalLinksNotFound': 'There are no external links',
  'app.pages.externalLink.selectApiKey': 'Select an API key',
  'app.pages.externalLink.executor': 'Executor',
  'app.pages.externalLink.noApiEndpoints': 'No API endpoints',

  //API keys manager
  'app.pages.apiKeysManager.alias': 'Alias',
  'app.pages.apiKeysManager.key': 'Key',
  'app.pages.apiKeysManager.active': 'Active',
  'app.pages.apiKeysManager.lastKeyChange': 'Last key change',
  'app.pages.apiKeysManager.showApiKeys': 'Show API keys',
  'app.pages.apiKeysManager.createApiKeys': 'Create API key',
  'app.pages.apiKeysManager.editApiKeys': 'Edit API key',
  'app.pages.apiKeysManager.deleteApiKeys': 'Delete API key',
  'app.pages.apiKeysManager.noApiKeys': 'There are no API keys',
  'app.pages.apiKeysManager.apiKey': 'API key',
  'app.pages.apiKeysManager.deleteApiKeyMessage': 'Are you sure you want to delete the API key?',
  'app.pages.apiKeysManager.apiKeyDeleted': 'API key deleted',
  'app.pages.apiKeysManager.apiKeyUpdated': 'API key updated',
  'app.pages.apiKeysManager.apiKeyCreated': 'API key created',
  'app.pages.apiKeysManager.keyCopied': 'Key copied',
  'app.pages.apiKeysManager.saveKeyAlert':
    'Attention! The API key will only be visible on this occasion. Make sure to copy it now',
  'app.pages.apiKeysManager.keyId': 'Key id',

  //App consolidation
  'app.pages.appConsolidation.sourceAppVersion': 'Source app version',
  'app.pages.appConsolidation.differences': 'Differences',
  'app.pages.appConsolidation.summary': 'Summary',
  'app.pages.appConsolidation.businessRules': 'Business rules',
  'app.pages.appConsolidation.includeAllModules': 'Include all',
  'app.pages.appConsolidation.includeAllInterfaces': 'Include all',
  'app.pages.appConsolidation.replaceMatchingNodes': 'Replace matching nodes outside these modules',
  'app.pages.appConsolidation.versionMetadata': 'Version metadata',
  'app.pages.appConsolidation.itemAdded': '{name} added',
  'app.pages.appConsolidation.itemDeleted': '{name} deleted',
  'app.pages.appConsolidation.itemEdited': '{name} edited',
  'app.pages.appConsolidation.itemsAdded': '{name} added',
  'app.pages.appConsolidation.itemsDeleted': '{name} deleted',
  'app.pages.appConsolidation.itemsEdited': '{name} edited',
  'app.pages.appConsolidation.noChanges': 'No changes',
  'app.pages.appConsolidation.confirmationDialogTitle': 'Confirm consolidation changes',
  'app.pages.appConsolidation.confirmationDialogText1':
    'Are you sure you want to commit these changes?',
  'app.pages.appConsolidation.confirmationDialogText2':
    'Changes applied to {sections} are irreversible.',
  'app.pages.appConsolidation.compareDefinitionOnly': 'Compare definition only',
  'app.pages.appConsolidation.versionFiles': 'Version files',
  'app.pages.appConsolidation.appFiles': 'App files',
  'app.pages.appConsolidation.appMetadata': 'App metadata',
  'app.pages.appConsolidation.scenarioFile': 'Scenario file',
  'app.pages.appConsolidation.scenarioFiles': 'Scenario files',
  'app.pages.appConsolidation.test': 'Test',
  'app.pages.appConsolidation.scenarios': 'Scenarios',
  'app.pages.appConsolidation.tests': 'Tests',
  'app.pages.appConsolidation.skill': 'Skill',
  'app.pages.appConsolidation.skills': 'Skills',
  'app.pages.appConsolidation.htmlCode': 'HTML',
  'app.pages.appConsolidation.pythonCode': 'Python code',

  //Office addin
  'app.pages.office.selectNode': 'Select a node',

  //Notifications
  'app.pages.notifications.scheduler.taskFinished':
    'The task {match1} has finished with state {match2}',
  'app.pages.notifications.workflow.taskReady':
    'The task {match1} of the process {match2} is ready to be started',
  'app.pages.notifications.workflow.taskOverdueExtended':
    'The task {match1} of the process {match2} is overdue. This may affect the completion of your task {match3}',
  'app.pages.notifications.workflow.taskOverdue':
    'The task {match1} of the process {match2} is overdue',
  'app.pages.notifications.workflow.taskChangedStatus':
    'The task {match1} of the process {match2} has changed status from {match3} to {match4}',
  'app.pages.notifications.workflow.processStarted': 'The process {match1} has started',
  'app.pages.notifications.workflow.processUpToDateAgain':
    'The process {match1} is up to date again',
  'app.pages.notifications.workflow.wroteComment':
    '{match1} wrote the following comment in task {match2} of the process {match3}: {match4}',
  'app.pages.notifications.title': 'Notifications',
  'app.pages.notifications.allNotifications': 'All',
  'app.pages.notifications.unReadNotifications': 'Unread',
  'app.pages.notifications.noNotifications': 'No notifications',
  'app.pages.notifications.markAsRead': 'Mark as read',
  'app.pages.notifications.maskAsUnread': 'Mark as unread',
  'app.pages.notifications.notificationDeleted': 'Notification deleted',
  'app.pages.notifications.markAllAsRead': 'Mark all as read',
  'app.pages.notifications.yesterday': 'Yesterday',
  'app.pages.notifications.unreadItem': 'Unread',
  'app.pages.notifications.bellWithUnread': 'Notifications: {count} unread',
  'app.pages.notifications.moreOptions': 'More options',
  'app.pages.notifications.filter': 'Filter',
  'app.pages.notifications.seeAll': 'See all',
  'app.pages.notifications.onlyThisApp': 'Only this app ({app})',
  'app.pages.notifications.onlyApp': 'Only {app}',
  'app.pages.notifications.removeOnlyThisApp': 'Remove filter: only {app}',
  'app.pages.notifications.empty.noneTitle': 'You have no notifications',
  'app.pages.notifications.empty.noneBody':
    "Here you'll see the messages people send you and notices from processes and scheduled tasks.",
  'app.pages.notifications.empty.noneInAppBody': 'Notices about this app will show up here.',
  'app.pages.notifications.empty.upToDateTitle': "You're all caught up",
  'app.pages.notifications.empty.upToDateBody': 'You have no unread notifications.',
  'app.pages.notifications.empty.filteredTitle': 'Nothing with this filter',
  'app.pages.notifications.empty.filteredBody': 'Try another filter or see all your notifications.',
  'app.pages.notifications.openApp.title': 'Open another application',
  'app.pages.notifications.openApp.body': 'To see this, <b>{app}</b> will open.',
  'app.pages.notifications.openApp.current': 'You currently have {app} open.',
  'app.pages.notifications.openApp.unsavedChanges':
    'You have unsaved changes in <b>{app}</b>. If you open without saving, they are lost.',
  'app.pages.notifications.openApp.open': 'Open {app}',
  'app.pages.notifications.openApp.saveAndOpen': 'Save and open',
  'app.pages.notifications.openApp.openWithoutSaving': 'Open without saving',
  'app.pages.notifications.today': 'Today',
  'app.pages.notifications.delete': 'Delete',
  'app.pages.notifications.messageDeleted': 'Message deleted',
  'app.pages.notifications.back': 'Back',
  'app.pages.notifications.newMessagesHint':
    '{count, plural, one {You have # new message} other {You have # new messages}}',
  'app.pages.notifications.removedUser': 'Deleted user',
  'app.pages.notifications.newMessage': 'New message',
  'app.pages.notifications.inbox': 'Inbox',
  'app.pages.notifications.thisApp': 'This app',
  'app.pages.notifications.allApps': 'All apps',
  'app.pages.notifications.widget.allowCompose': 'Allow writing messages',
  'app.pages.notifications.seeAllInBell': 'See all in the bell',
  'app.pages.notifications.tab.received': 'Received',
  'app.pages.notifications.tab.sent': 'Sent',
  'app.pages.notifications.filter.messages': 'Messages',
  'app.pages.notifications.filter.system': 'System',
  'app.pages.notifications.empty.noSentTitle': "You haven't sent any messages",
  'app.pages.notifications.empty.noSentBody':
    'With New message you can tell something to a person, a department or a team.',
  'app.pages.notifications.message.title': 'Message',
  'app.pages.notifications.message.to': 'To {to}',
  'app.pages.notifications.message.goTo': 'Go to {target}',
  'app.pages.notifications.message.open': 'Open',
  'app.pages.notifications.sent.title': 'Sent message',
  'app.pages.notifications.sent.seenBy': 'Seen by {seen} of {total}',
  'app.pages.notifications.sent.people': 'People',
  'app.pages.notifications.sent.groupSeen': '{seen} of {total} saw it',
  'app.pages.notifications.sent.seenAt': 'Seen · {when}',
  'app.pages.notifications.sent.pending': 'Pending',
  'app.pages.notifications.sent.alsoByEmail': 'Also by email',
  'app.pages.notifications.toast.received': '{sender} sent you a message',
  'app.pages.notifications.toast.see': 'See',
  'app.pages.notifications.toast.sent':
    'Message sent to {count, plural, one {# person} other {# people}}',
  'app.pages.notifications.toast.seeSent': 'See sent',
  'app.pages.notifications.section.workflow': 'My tasks',
  'app.pages.notifications.section.scheduler': 'Scheduled tasks',
  'app.pages.notifications.section.version_manager': 'Versions',
  'app.pages.notifications.section.scenario_manager': 'Scenarios',
  'app.pages.notifications.section.file_manager': 'Files',
  'app.pages.notifications.section.code': 'Code',
  'app.pages.notifications.section.automation_tests': 'Automation tests',
  'app.pages.notifications.composer.people': 'People',
  'app.pages.notifications.composer.departments': 'Departments',
  'app.pages.notifications.composer.teams': 'Teams',
  'app.pages.notifications.composer.members': '{count, plural, one {# member} other {# members}}',
  'app.pages.notifications.composer.overLimit':
    'It reaches more than {limit} people. Remove a group.',
  'app.pages.notifications.composer.noReach': 'Nobody in this selection can receive it.',
  'app.pages.notifications.composer.noResults': 'No results for «{query}».',
  'app.pages.notifications.composer.to': 'To',
  'app.pages.notifications.composer.addMore': 'Add more…',
  'app.pages.notifications.composer.toPlaceholder': 'People, departments or teams',
  'app.pages.notifications.composer.toHint': 'Add at least one person, department or team.',
  'app.pages.notifications.composer.message': 'Message',
  'app.pages.notifications.composer.messagePlaceholder':
    'Write the notice. For example: I released the plan, check the Chocolates family.',
  'app.pages.notifications.composer.atLimit': 'You reached the 1000 character limit.',
  'app.pages.notifications.composer.linkTo': 'Link to',
  'app.pages.notifications.composer.linkNone': 'None',
  'app.pages.notifications.composer.linkInterface': 'Interface',
  'app.pages.notifications.composer.linkSection': 'Section',
  'app.pages.notifications.composer.noApp':
    'To link the message to an interface or section, open an application. Without an app, only the text is sent.',
  'app.pages.notifications.composer.alsoByEmail': 'Also send by email',
  'app.pages.notifications.composer.advanced': 'Advanced options',
  'app.pages.notifications.composer.linkApp': 'Link to this application ({app})',
  'app.pages.notifications.composer.linkVersion': 'Open in this version ({version})',
  'app.pages.notifications.composer.send': 'Send',
  'app.pages.notifications.reply.label': 'Reply',
  'app.pages.notifications.toast.replied': '{sender} replied to your message',
  'app.pages.notifications.message.replies': 'Replies',
  'app.pages.notifications.message.you': 'You',
  'app.pages.notifications.message.replyTo': 'Reply to {name}',
  'app.pages.notifications.message.reply': 'Reply',
  'app.pages.notifications.message.unavailable': 'This message is no longer available.',
  'app.pages.notifications.sent.tabReads': 'Reads',
  'app.pages.notifications.sent.tabReplies': 'Replies',
  'app.pages.notifications.sent.repliesCount': '{count, plural, one {# reply} other {# replies}}',
  'app.pages.notifications.sent.noReplies': 'No replies yet.',

  // AI Agents
  'app.pages.aiAgents.aiAgents': 'AI Agents',
  'app.pages.aiAgents.agentsUpdated': 'Available agents updated',
  'app.pages.aiAgents.send': 'Send',
  'app.pages.aiAgents.newChat': 'New chat',
  'app.pages.aiAgents.memorySaved': 'Noted in this app’s memory:',
  'app.pages.aiAgents.memoryManage': 'Manage',
  'app.pages.aiAgents.downloadGeneratedFile': 'Download this file',
  'app.pages.aiAgents.question.answer': 'Regarding "{question}":',
  'app.pages.aiAgents.question.multiSelectHint': 'Select one or more options',
  'app.pages.aiAgents.question.confirm': 'Confirm',
  'app.pages.aiAgents.question.other': 'Other',
  'app.pages.aiAgents.question.otherPlaceholder': 'Type another answer',
  'app.pages.aiAgents.question.sendOther': 'Send answer',
  'app.pages.aiAgents.showPrivacyStatement': 'Privacy statement',
  'app.pages.aiAgents.chatSuccessfullyExported': 'Chat successfully exported',
  'app.pages.aiAgents.dockToTheRight': 'Dock to the right',
  'app.pages.aiAgents.dockToTheLeft': 'Dock to the left',
  'app.pages.aiAgents.updateAvailableAgents': 'Update available agents',
  'app.pages.aiAgents.viewTraces': 'View traces',
  'app.pages.aiAgents.pinContextComponent': 'Pin context component',
  'app.pages.aiAgents.ask': 'Ask',
  'app.pages.aiAgents.askAboutCoding': 'Enter your code generation request',
  'app.pages.aiAgents.dictate': 'Dictate',
  'app.pages.aiAgents.inlineNoChanges': 'The agent did not propose changes for this code.',
  'app.pages.aiAgents.cancelRecording': 'Cancel',
  'app.pages.aiAgents.uploadFiles': 'Upload files',
  'app.pages.aiAgents.addInterfaceComponent': 'Add interface component',
  'app.pages.aiAgents.pickComponentHint': 'Click a component to add it to the context',
  'app.pages.aiAgents.captureScreenArea': 'Capture screen area',
  'app.pages.aiAgents.screenCaptureHint': 'Drag to select an area to capture. Press Esc to cancel.',
  'app.pages.aiAgents.screenCapturePreparing': 'Preparing capture...',
  'app.pages.aiAgents.screenCaptureError': 'The selected area could not be captured',
  'app.pages.aiAgents.uploadFilesDescription': 'Upload files to add context to the conversation',
  'app.pages.aiAgents.filesUploaded': '{count} file(s) uploaded successfully',
  'app.pages.aiAgents.contextUsageTooltip':
    'Context usage: {percent}% ({used} of {budget} tokens). At 100% the conversation is automatically compacted, summarizing older messages.',
  'app.pages.aiAgents.compactNow': 'Compact conversation',
  'app.pages.aiAgents.compactingSession': 'Compacting conversation...',
  'app.pages.aiAgents.invalidFileType':
    'Allowed files must have one of these extensions: {extensions}',
  'app.pages.aiAgents.fileTooLarge': 'File "{fileName}" exceeds the maximum size of {maxSize}MB',
  'app.pages.aiAgents.codeAssistant': 'Show/hide code assistant',
  'app.pages.aiAgents.unknownCodeClassification': 'I can only answer code questions about Python.',
  'app.pages.aiAgents.sessionHistory': 'Session history',
  'app.pages.aiAgents.restoreInterfaceChanges': 'Also revert interface changes to this point',
  'app.pages.aiAgents.noSessionHistory': 'No previous sessions',
  'app.pages.aiAgents.disabledInSection': 'This agent is disabled in this section',
  'app.pages.aiAgents.disabledRequiresAppOpen': 'This agent needs an open application',
  'app.pages.aiAgents.aiDisabledTitle': 'AI features are not enabled',
  'app.pages.aiAgents.aiDisabledDescription':
    'AI features are not enabled for this company. Contact your administrator to enable them in AI Settings.',
  'app.pages.aiAgents.aiDisabledPlaceholder': 'AI features are not enabled',
  'app.pages.aiAgents.customAgentsDisabledTitle': 'This agent is not enabled',
  'app.pages.aiAgents.customAgentsDisabledDescription':
    'Custom agents are not enabled for this company, so the agents defined inside this application cannot be used. Pick the Pyplan agent to keep working, or ask your administrator to enable them in AI Settings.',
  'app.pages.aiAgents.customAgentsDisabledPlaceholder':
    'This agent is not enabled for your company',
  'app.pages.aiAgents.tokenUsageMenuItem': 'AI tokens this month: {used} of {limit} ({percent}%)',
  'app.pages.aiAgents.tokenLimitReachedPlaceholder': 'Monthly AI token limit reached',
  'app.pages.aiAgents.tokenLimitReachedTitle': 'Monthly AI token limit reached',
  'app.pages.aiAgents.tokenLimitReachedDescription':
    "This company has used all of this month's AI tokens. Contact your administrator to raise or remove the limit.",
  'app.pages.aiAgents.tokenUsageTooltip':
    "You're approaching your AI token limit: {used} used of {limit} ({percent}%)",
  'app.pages.aiAgents.tokenUsageAtLimitTooltip':
    "You've reached your AI token limit: {used} used of {limit}. AI is unavailable until next month or until an administrator raises the limit.",
  'app.pages.aiAgents.renameSession': 'Rename session',
  'app.pages.aiAgents.deleteSession': 'Delete session',
  'app.pages.aiAgents.editConversation': 'Edit conversation',
  'app.pages.aiAgents.restoreConversation': 'Restore conversation',
  'app.pages.aiAgents.restoreCheckpointConfirmation':
    'This will move the selected message back to the input and remove it and all following messages from the conversation. Do you want to continue?',
  'app.pages.aiAgents.untitledSession': 'Session {date}',
  'app.pages.aiAgents.messages': 'messages',
  'app.pages.aiAgents.assistantComponentDeprecated': 'The Assistant component is deprecated',

  // Secrets manager
  'app.pages.secretsManager.secretManager': 'Secrets',
  'app.pages.secretsManager.createSecret': 'Create secret',
  'app.pages.secretsManager.editSecret': 'Edit secret',
  'app.pages.secretsManager.deleteSecret': 'Delete secret',
  'app.pages.secretsManager.deleteSecretConfirmation':
    'Are you sure you want to delete the secret?',
  'app.pages.secretsManager.secretDeleted': 'Secret deleted',
  'app.pages.secretsManager.secretUpdated': 'Secret updated',
  'app.pages.secretsManager.secretCreated': 'Secret created',
  'app.pages.secretsManager.secretKey': 'Secret key',
  'app.pages.secretsManager.secretValue': 'Secret value',
  'app.pages.secretsManager.noSecrets': 'There are no secrets',
  'app.pages.secretsManager.secret': 'Secret',
  'app.pages.secretsManager.allUsers': 'All users',
  'app.pages.secretsManager.showSecretValue': 'Show secret value',
  'app.pages.secretsManager.hideSecretValue': 'Hide secret value',
  'app.pages.secretsManager.secretKeyExists': 'Secret key already exists',
  'app.pages.secretsManager.system': 'System',

  // Application Analysis
  'app.pages.appAnalysis.analysisConfiguration': 'Analysis configuration',
  'app.pages.appAnalysis.detectNodesWithLargeDefinition': 'Detect nodes with large definition',
  'app.pages.appAnalysis.detectingNodesWithLargeDefinition':
    'Detecting nodes with large definition',
  'app.pages.appAnalysis.detectingNodesWithDeprecatedType': 'Detecting nodes with deprecated type',
  'app.pages.appAnalysis.detectingNotUsedNodes': 'Detecting unused nodes',
  'app.pages.appAnalysis.detectingAliasNodesWithoutOriginal':
    'Detecting alias nodes without original node',
  'app.pages.appAnalysis.detectingEmptyModules': 'Detecting empty modules',
  'app.pages.appAnalysis.detectingMultiDimensionalDataArray':
    'Detecting multidimensional dataarrays',
  'app.pages.appAnalysis.detectingLargeNodesEvaluationTime':
    'Detecting large nodes evaluation time',
  'app.pages.appAnalysis.detectingLargeInterfaces': 'Detecting large interfaces',
  'app.pages.appAnalysis.nodesWithLargeDefinitionDetected': 'Nodes with large definition detected',
  'app.pages.appAnalysis.largeDefinitionNotFound':
    'No nodes with more than 50 lines of code were detected',
  'app.pages.appAnalysis.largeDefinitionFound':
    '{count} nodes with more than 50 lines of code were detected',
  'app.pages.appAnalysis.detectNodesWithDeprecatedType': 'Detect nodes with deprecated type',
  'app.pages.appAnalysis.nodesWithDeprecatedTypeDetected': 'Nodes with deprecated type detected',
  'app.pages.appAnalysis.deprecatedTypeNotFound': 'No nodes with deprecated type were detected',
  'app.pages.appAnalysis.deprecatedTypeFound': '{count} nodes with deprecated type were detected',
  'app.pages.appAnalysis.detectNotUsedNodes': 'Detect unused nodes',
  'app.pages.appAnalysis.notUsedNodesDetected': 'unused nodes detected',
  'app.pages.appAnalysis.notUsedNodesNotFound': 'No unused nodes were detected',
  'app.pages.appAnalysis.notUsedNodesFound': '{count} unused nodes were detected',
  'app.pages.appAnalysis.detectAliasNodesWithoutOriginal':
    'Detect alias nodes without original node',
  'app.pages.appAnalysis.aliasNodesWithoutOriginalDetected':
    'Alias nodes without original node detected',
  'app.pages.appAnalysis.aliasNodesWithoutOriginalNotFound':
    'No alias nodes without original node were detected',
  'app.pages.appAnalysis.aliasNodesWithoutOriginalFound':
    '{count} alias nodes without original node were detected',
  'app.pages.appAnalysis.detectEmptyModules': 'Detect empty modules',
  'app.pages.appAnalysis.emptyModulesDetected': 'Empty modules detected',
  'app.pages.appAnalysis.emptyModulesNotFound': 'No empty modules were detected',
  'app.pages.appAnalysis.emptyModulesFound': '{count} empty modules were detected',
  'app.pages.appAnalysis.detectNodesWithNonExistingModule': 'Detect nodes with non-existing module',
  'app.pages.appAnalysis.nodesWithNonExistingModuleDetected':
    'Nodes with non-existing module detected',
  'app.pages.appAnalysis.nonExistingModuleNotFound':
    'No nodes with non-existing module were detected',
  'app.pages.appAnalysis.nonExistingModuleFound':
    '{count} nodes with non-existing module were detected',
  'app.pages.appAnalysis.detectMultiDimensionalDataArray':
    'Detect multidimensional dataarrays with more than: ',
  'app.pages.appAnalysis.multiDimensionalDataArrayDetected':
    'Multi-dimensional data array detected',
  'app.pages.appAnalysis.multiDimensionalDataArrayNotFound':
    'No data arrays with more than {dimensions} dimensions were detected',
  'app.pages.appAnalysis.multiDimensionalDataArrayFound':
    '{count} data arrays with more than {dimensions} dimensions were detected',
  'app.pages.appAnalysis.detectLargeNodesEvaluationTime': 'Detect large nodes evaluation time',
  'app.pages.appAnalysis.largeNodesEvaluationTimeDetected': 'Large nodes evaluation time detected',
  'app.pages.appAnalysis.largeNodesEvaluationTimeNotFound':
    'No nodes with evaluation time greater than 5 seconds were detected',
  'app.pages.appAnalysis.largeNodesEvaluationTimeGreaterThan5':
    'Nodes with evaluation times greater than 5 seconds were found',
  'app.pages.appAnalysis.largeNodesEvaluationTimeGreaterThan10':
    'Nodes with evaluation times greater than 10 seconds were found',
  'app.pages.appAnalysis.largeNodesEvaluationTimeGreaterThan20':
    'Nodes with evaluation times greater than 20 seconds were found',
  'app.pages.appAnalysis.detectLargeInterfaces': 'Detect large interfaces',
  'app.pages.appAnalysis.largeInterfacesDetected': 'Large interfaces detected',
  'app.pages.appAnalysis.largeInterfacesNotFound':
    'No interfaces with more than 10 components were detected',
  'app.pages.appAnalysis.largeInterfacesMoreThan10':
    'Interfaces with more than 10 components were detected',
  'app.pages.appAnalysis.largeInterfacesLonger':
    'Interfaces with more than 15 components were detected',
  'app.pages.appAnalysis.detectLargeApplicationSize': 'Detect large application size',
  'app.pages.appAnalysis.largeApplicationSizeDetected': 'Large application size detected',
  'app.pages.appAnalysis.largeApplicationSizeNotFound': 'The application size is less than 1GB',
  'app.pages.appAnalysis.largeApplicationSizeGreaterThan1GB':
    'The application size is greater than 1GB',
  'app.pages.appAnalysis.detectLargeAppVersions': 'Detect large app versions',
  'app.pages.appAnalysis.largeAppVersionsDetected': 'Large app versions detected',
  'app.pages.appAnalysis.largeAppVersionsNotFound':
    'No app versions with more than 200MB of data were detected',
  'app.pages.appAnalysis.largeAppVersionsGreaterThan200MB':
    'App versions with more than 200MB of data were detected',
  'app.pages.appAnalysis.detectDashComponents': 'Detect Dash components',
  'app.pages.appAnalysis.dashComponentsDetected': 'Dash components detected',
  'app.pages.appAnalysis.dashComponentsNotFound': 'No Dash components were detected',
  'app.pages.appAnalysis.interfaceWithDashComponentsFound':
    '{count} Interface with dash components were detected',
  'app.pages.appAnalysis.runningAnalysis': 'Running analysis',
  'app.pages.appAnalysis.analysisReport': 'Analysis report',
  'app.pages.appAnalysis.runAnalysis': 'Run analysis',
  'app.pages.appAnalysis.newAnalysis': 'New analysis',
  'app.pages.appAnalysis.analysisDate': 'Analysis date',
  'app.pages.appAnalysis.countOfLines': 'Count of lines',
  'app.pages.appAnalysis.nodeClass': 'Node class',
  'app.pages.appAnalysis.evaluationTime': 'Evaluation time',
  'app.pages.appAnalysis.countOfComponents': 'Count of components',
  'app.pages.appAnalysis.nodesMustBeCalculated':
    'The nodes must be calculated to perform this analysis',
  'app.pages.appAnalysis.copyAllAnalysisData': 'Copy all analysis data',
  'app.pages.appAnalysis.exportAnalysisCsv': 'Export analysis as CSV',
  'app.pages.appAnalysis.exportAnalysisExcel': 'Export analysis as Excel',
  'app.pages.appAnalysis.analysisReportDownloaded': 'Analysis report downloaded',
  'app.pages.appAnalysis.applicationSize': 'Application size',
  'app.pages.appAnalysis.versionSize': 'Version size',
  'app.pages.appAnalysis.componentName': 'Component name',
  'app.pages.appAnalysis.versionPath': 'Version path',
  'app.pages.appAnalysis.applicationPath': 'Application path',
  'app.pages.appAnalysis.detectBadPractices': 'Detect possible bad practices in node definitions',
  'app.pages.appAnalysis.detectBadPracticesInfo':
    'Reports the use of self.model and manual invalidations (invalidate, silentInvalidate, invalidateOutputs, invalidate_nodes) in node definitions. They are warnings to review: some uses, such as in button nodes or data load flows, are legitimate',
  'app.pages.appAnalysis.badPracticesDetected': 'Possible bad practices in node definitions',
  'app.pages.appAnalysis.badPracticesNotFound':
    'No bad practices were detected in node definitions',
  'app.pages.appAnalysis.badPracticesFound':
    '{count} possible bad practices were detected in node definitions. Review them: some uses may be legitimate',
  'app.pages.appAnalysis.practice': 'Practice',
  'app.pages.appAnalysis.lines': 'Lines',
  'app.pages.appAnalysis.practiceSelfModel': 'Use of self.model',
  'app.pages.appAnalysis.practiceManualInvalidation': 'Manual invalidation',

  //Upload manager
  'app.pages.app.uploadmanager.showBaseFile': 'Show base file',
  'app.pages.app.uploadmanager.showCurrentFile': 'Show current file',
  'app.pages.app.uploadmanager.showLastModifiedDate': 'Show last modified date',
  'app.pages.app.uploadmanager.showLastModifiedUser': 'Show last modified user',
  'app.pages.app.uploadmanager.addNewFileUploadItem': 'Add new file upload item',
  'app.pages.app.uploadmanager.baseFilePath': 'Base file path',
  'app.pages.app.uploadmanager.currentFilePath': 'Current file path',
  'app.pages.app.uploadmanager.validationNode': 'Validation node (optional)',
  'app.pages.app.uploadmanager.callbackNode': 'Callback node (optional)',
  'app.pages.app.uploadmanager.invalidateNode': 'Invalidate node (optional)',
  'app.pages.app.uploadmanager.runNodesOnRestore':
    'Run callback and invalidate nodes when restoring a file from history',
  'app.pages.app.uploadmanager.historyCount': 'History count',
  'app.pages.app.uploadmanager.autoValidationTitle': 'Automatic validation based on base file',
  'app.pages.app.uploadmanager.toggleValidationOptions': 'Show/hide automatic validation',
  'app.pages.app.uploadmanager.validateSheets': 'Validate sheets',
  'app.pages.app.uploadmanager.validateColumnNames': 'Validate column names',
  'app.pages.app.uploadmanager.validateColumnTypes': 'Validate column types',
  'app.pages.app.uploadmanager.preserveExistingFilename': 'Preserve existing filename',
  'app.pages.app.uploadmanager.historyPath': 'History path (optional)',
  'app.pages.app.uploadmanager.navigateToInterface': 'Navigate to interface (optional)',
  'app.pages.app.uploadmanager.displayOptionsTitle': 'Display options',
  'app.pages.app.uploadmanager.toggleDisplayOptions': 'Show/hide display options',
  'app.pages.app.uploadmanager.showBaseDownload': 'Show base file download button',
  'app.pages.app.uploadmanager.showUpload': 'Show upload button',
  'app.pages.app.uploadmanager.showDownload': 'Show download button',
  'app.pages.app.uploadmanager.showHistory': 'Show file history',
  'app.pages.app.uploadmanager.accessTitle': 'Access',
  'app.pages.app.uploadmanager.toggleAccessOptions': 'Show/hide access options',
  'app.pages.app.uploadmanager.accessDescription':
    'Who can see and upload this file. Users who can edit interfaces also see it in edit mode.',
  'app.pages.app.uploadmanager.accessEveryone': 'Everyone',
  'app.pages.app.uploadmanager.accessByDepartments': 'By departments',
  'app.pages.app.uploadmanager.accessByUsers': 'By users',
  'app.pages.app.uploadmanager.accessDepartments': 'Departments',
  'app.pages.app.uploadmanager.accessUsers': 'Users',
  'app.pages.app.uploadmanager.accessDepartmentsRequired': 'Select at least one department',
  'app.pages.app.uploadmanager.accessUsersRequired': 'Select at least one user',
  'app.pages.app.uploadmanager.accessDepartmentsUnavailable':
    'Departments could not be loaded. Configured: {departments}',
  'app.pages.app.uploadmanager.accessUnknownUser': 'User not found ({id})',
  'app.pages.app.uploadmanager.restrictedAccess': 'Restricted access',
  'app.pages.app.uploadmanager.restrictedAccessDepartments': 'Departments ({count})',
  'app.pages.app.uploadmanager.restrictedAccessUsers': 'Users ({count})',
  'app.pages.app.uploadmanager.restrictedAccessMore': '+{count} more',
  'app.pages.app.uploadmanager.restrictedAccessNone': 'Nobody assigned',
  'app.pages.app.uploadmanager.restrictedAccessLoading': 'Loading...',
  'app.pages.app.uploadmanager.selectHistoryPath': 'Select history path',
  'app.pages.app.uploadmanager.downloadBaseFile': 'Download base file',
  'app.pages.app.uploadmanager.uploadFile': 'Upload file',
  'app.pages.app.uploadmanager.downloadFile': 'Download file',
  'app.pages.app.uploadmanager.selectInterfaceForNavigation': 'Select interface for navigation',
  'app.pages.app.uploadmanager.validatigFile': 'Validating file',
  'app.pages.app.uploadmanager.basePathModeForFiles': 'Base path mode for files',
  'app.pages.app.uploadmanager.relativeToApplication': 'Relative to application',
  'app.pages.app.uploadmanager.relativeToVersion': 'Relative to version',
  'app.pages.app.uploadmanager.viewHistory': 'View history',
  'app.pages.app.uploadmanager.fileRestored': 'File restored',
  'app.pages.app.uploadmanager.fileRestoreError': 'Error restoring file',
  'app.pages.app.uploadmanager.fileRestoredWithErrors': 'File restored with errors',
  'app.pages.app.uploadmanager.historyFiles': 'History files',
  'app.pages.app.uploadmanager.restoringFile': 'Restoring file',
  'app.pages.app.uploadmanager.noHistoryFiles': 'No history files found',
  'app.pages.app.uploadmanager.restoreFile': 'Restore file',
  'app.pages.app.uploadmanager.confirmRestoreTitle': 'Confirm restore file',
  'app.pages.app.uploadmanager.confirmRestoreContent':
    'Are you sure you want to restore the file? This will overwrite the current file with the selected history file.',
  'app.pages.app.uploadmanager.downloadAllFiles': 'Download all files',
  'app.pages.app.uploadmanager.fileDownloaded': 'File downloaded',
  'app.pages.app.uploadmanager.fileDownloadError': 'Error downloading file',
  'app.pages.app.uploadmanager.confirmDeleteMessage':
    'Are you sure you want to delete this file upload item? This will remove the file and its history.',
  'app.pages.app.uploadmanager.noUploadItems': 'No upload items found',
  'app.pages.app.uploadmanager.baseFile': 'Base file',
  'app.pages.app.uploadmanager.additionalInformationOfFile': 'Additional information of file',
  'app.pages.app.uploadmanager.fileSize': 'File size',
  'app.pages.app.uploadmanager.showFileSize': 'Show file size',
  'app.pages.app.uploadmanager.removeFile': 'Remove file',
  'app.pages.app.uploadmanager.fileRemoved': 'File removed',
  'app.pages.app.uploadmanager.fileRemoveError': 'Error removing file',
  'app.pages.app.uploadmanager.confirmRemoveTitle': 'Confirm remove file',
  'app.pages.app.uploadmanager.confirmRemoveContent':
    'Are you sure you want to remove the file? This action cannot be undone.',
  'app.pages.app.uploadmanager.useFolderPath': 'Use folder path',
  'app.pages.app.uploadmanager.currentFolderPath': 'Current folder path',
  'app.pages.app.uploadmanager.viewFolderFiles': 'View folder files',
  'app.pages.app.uploadmanager.folderFiles': 'Folder files',
  'app.pages.app.uploadmanager.loadingFiles': 'Loading folder files...',
  'app.pages.app.uploadmanager.filePathMustBeFile':
    'The file path must point to a file, not a folder',
  'app.pages.app.uploadmanager.selectFileModeFile': 'Select file mode',
  'app.pages.app.uploadmanager.selectFileModeFolder': 'Select folder mode',
  'app.pages.app.uploadmanager.noFilesInFolder': 'No files found in folder',
  'app.pages.app.uploadmanager.validationStartRow': 'Validation start row',
  'app.pages.app.uploadmanager.unknownError': 'Unknown error',
  'app.pages.app.uploadmanager.Temporary_file_does_not_exist': 'Temporary file does not exist',
  'app.pages.app.uploadmanager.Base_file_extension_mismatch': 'Base file extension mismatch',
  'app.pages.app.uploadmanager.Validation_node_failed': 'Validation node failed',
  'app.pages.app.uploadmanager.Validation_node_not_callable': 'Validation node not callable',
  'app.pages.app.uploadmanager.Base_file_does_not_exist': 'Base file does not exist',
  'app.pages.app.uploadmanager.Sheet_names_do_not_match': 'Sheet names do not match',
  'app.pages.app.uploadmanager.Both_files_must_be_excel': 'Both files must be Excel files',
  'app.pages.app.uploadmanager.Column_names_do_not_match': 'Column names do not match',
  'app.pages.app.uploadmanager.Column_type_mismatch': 'Column type mismatch',
  'app.pages.app.uploadmanager.Uploaded_file_missing_columns': 'Uploaded file is missing columns',
  'app.pages.app.uploadmanager.Uploaded_file_extra_columns': 'Uploaded file has extra columns',
  'app.pages.app.uploadmanager.History_directory_does_not_exist':
    'History directory does not exist',
  'app.pages.app.uploadmanager.Failed_to_move_file': 'Failed to move file',
  'app.pages.app.uploadmanager.Callback_node_not_callable': 'Callback node not callable',
  'app.pages.app.uploadmanager.Callback_node_failed': 'Error running callback node',
  'app.pages.app.uploadmanager.Invalidate_node_failed': 'Error invalidating node',
  'app.pages.app.uploadmanager.File_uploaded_successfully': 'File uploaded successfully',
  'app.pages.app.uploadmanager.Upload_item_not_found':
    'The file item no longer exists in this component',
  'app.pages.app.uploadmanager.Upload_item_access_denied':
    'You do not have access to upload this file',

  // AI Agents
  'app.aiAgents.agentStatus.WAITING': 'Waiting',
  'app.aiAgents.agentStatus.REASONING': 'Reasoning',
  'app.aiAgents.agentStatus.SEARCHING': 'Searching',
  'app.aiAgents.agentStatus.GENERATING': 'Generating',
  'app.aiAgents.agentStatus.RESPONDING': 'Responding',
  'app.aiAgents.agentStatus.USING_TOOL': 'Using tool',
  'app.aiAgents.agentStatus.EXECUTING_TOOL': 'Executing tool',
  'app.aiAgents.agentStatus.COMPLETED': 'Completed',
  'app.aiAgents.agentStatus.INDEXING_DOCUMENTS': 'Indexing documents',
  'app.aiAgents.agentStatus.EXECUTING_CONTEXT_NODES': 'Executing context nodes',
  'app.aiAgents.agentStatus.COMPACTING': 'Compacting',
  'app.aiAgents.reasoning.title': 'Reasoning',
  'app.aiAgents.toolCall.used': 'Used tool:',
  'app.aiAgents.activity.working': 'Working…',
  'app.aiAgents.activity.reasoning': 'reasoning',
  'app.aiAgents.activity.steps': '{count, plural, one {# step} other {# steps}}',
  'app.aiAgents.activity.reasoned': 'Reasoned',
  // App tests
  'app.pages.app.sidebarMenu.createApplicationTest': 'Create application test',
  'app.pages.app.sidebarMenu.editApplicationTest': 'Edit application test',
  'app.pages.app.sidebarMenu.deleteApplicationTest': 'Delete automation test',
  'app.pages.app.sidebarMenu.duplicateApplicationTest': 'Duplicate automation test',
  'app.pages.applicationTests.checkType': 'Check type',
  'app.pages.applicationTests.equalTo': 'Equal to',
  'app.pages.applicationTests.between': 'Between',
  'app.pages.applicationTests.noEvaluationError': 'No evaluation error',
  'app.pages.applicationTests.expectedValue': 'Expected value',
  'app.pages.applicationTests.precondition': 'Precondition',
  'app.pages.applicationTests.selectorValues': 'Selector values',
  'app.pages.applicationTests.addSelector': 'Add selector',
  'app.pages.applicationTests.addPrecondition': 'Add precondition',
  'app.pages.applicationTests.areYouSureToDeleteApplicationTest':
    'Are you sure you want to delete the following tests: {names}',
  'app.pages.applicationTests.areYouSureToRunApplicationTests':
    'Are you sure you want to run the following tests: {names}',
  'app.pages.applicationTests.lastExecutionStatus': 'Last execution status',
  'app.pages.applicationTests.lastExecutionDate': 'Last execution date',
  'app.pages.applicationTests.testDeletedSuccessfully': 'Test deleted successfully',
  'app.pages.applicationTests.testCreatedSuccessfully': 'Test created successfully',
  'app.pages.applicationTests.testUpdatedSuccessfully': 'Test updated successfully',
  'app.pages.applicationTests.testDuplicatedSuccessfully': 'Test duplicated successfully',
  'app.pages.applicationTests.runApplicationTests': 'Run application tests',
  'app.pages.applicationTests.mainMenuInterfaces': 'Main menu interfaces',
  'app.pages.applicationTests.newName': 'New name',
  'app.pages.applicationTests.executeTests': 'Execute tests',
  'app.pages.applicationTests.executeTestsWithNames': 'Execute tests: {names}',
  'app.pages.applicationTests.sendEmails': 'Always send emails',
  'app.pages.applicationTests.emailRecipients': 'Email recipients',
  'app.pages.applicationTests.sendOnFailureOnly': 'Send emails only on failure',
  'app.pages.applicationTests.testExecutedSuccessfully': 'Test scheduled for execution',
  'app.pages.applicationTests.selectNodes': 'Select nodes',
  'app.pages.applicationTests.viewPreconditions': 'View preconditions',
  'app.pages.applicationTests.settings': 'Settings',
  'app.pages.applicationTests.areYouSureToExecuteTests':
    'Are you sure you want to execute the selected tests?',
  'app.pages.applicationTests.settingsSavedSuccessfully': 'Settings saved successfully',
  'app.pages.applicationTests.testTypes': 'Test types',
  'app.pages.applicationTests.configureNodes': 'Configure nodes',
  'app.pages.applicationTests.permissions': 'Permissions',
  'app.pages.applicationTests.configurePermissions': 'Configure permissions',
  'app.pages.applicationTests.permissionAssertionsCount':
    '{count, plural, one {# assertion} other {# assertions}}',
  'app.pages.applicationTests.permissionsInfo':
    'Each assertion is evaluated for every department of the test, as if the user belonged only to that department. The roles of whoever runs the test are ignored.',
  'app.pages.applicationTests.addPermissionAssertion': 'Add assertion',
  'app.pages.applicationTests.noPermissionAssertions': 'No assertions configured',
  'app.pages.applicationTests.permissionItemType': 'Type',
  'app.pages.applicationTests.permissionItem': 'Item',
  'app.pages.applicationTests.expectedAccess': 'Expected access',
  'app.pages.applicationTests.accessAllowed': 'With access',
  'app.pages.applicationTests.accessDenied': 'Without access',
  'app.pages.applicationTests.removePermissionAssertion': 'Remove assertion',
  'app.pages.applicationTests.permissionVersion': 'Version',
  'app.pages.applicationTests.permissionType.folder': 'Folder',
  'app.pages.applicationTests.permissionType.application': 'Application',
  'app.pages.applicationTests.permissionType.application_version': 'Application version',
  'app.pages.applicationTests.permissionType.interface': 'Interface',
  'app.pages.applicationTests.permissionType.interface_folder': 'Interface folder',
  'app.pages.applicationTests.permissionType.module': 'Module',
  'app.pages.applicationTests.noPreconditionsAdded': 'No preconditions added',
  'app.pages.applicationTests.noNodesSelected': 'No nodes selected',
  'app.pages.applicationTests.removeFilters': 'Remove filters',
  'app.pages.applicationTests.viewLogs': 'View logs',
  'app.pages.applicationTests.executionTime': 'Execution time',
  'app.pages.applicationTests.executionLogs': 'Execution logs',
  'app.pages.applicationTests.viewTest': 'View test',
  'app.pages.applicationTests.testExecutedOn': 'Test executed on {date}',
  'app.pages.applicationTests.testExecutedInSeconds': 'in {duration} seconds',
  'app.pages.applicationTests.preconditionInfo':
    '(Optional) Preconditions to be met before running the test.You can add selector nodes and expected values for those nodes.',
  'app.pages.applicationTests.automationTests': 'Automation tests',
  'app.pages.applicationTests.testNoExecutedYet': 'The test has not been executed yet',
  'app.pages.applicationTests.step': 'Step',
  'app.pages.applicationTests.areYouSureToExecuteSingleTest':
    'Are you sure you want to execute the test?',
  'app.pages.applicationTests.executeSingleTest': 'Execute test',
  'app.pages.applicationTests.hideDetails': 'Hide details',
  'app.pages.applicationTests.noLogsAvailable': 'No logs available',
  'app.pages.applicationTests.testPassed': 'Passed',
  'app.pages.applicationTests.testFailed': 'Failed',
  'app.pages.applicationTests.testSuccess': 'Success',
  'app.pages.applicationTests.usersToNotify': 'Users to notify',
  'app.pages.applicationTests.notificationMode': 'Notification mode',
  'app.pages.applicationTests.noNotification': 'No notification',
  // HTML EDITOR
  'app.pages.htmlEditor.insertTemplate': 'Insert template',
  'app.pages.htmlEditor.templates': 'Templates',
  'app.pages.htmlEditor.saveTemplate': 'Save template',
  'app.pages.htmlEditor.replaceExisting': 'Replace existing',
  'app.pages.htmlEditor.manageTemplates': 'Manage templates',
  'app.pages.htmlEditor.createNewTemplate': 'Create new template',
  'app.pages.htmlEditor.renameOrDeleteTemplates': 'Rename or delete templates',
  'app.pages.htmlEditor.copyFormatting': 'Copy formatting',
  'app.pages.htmlEditor.template': 'Template',
  'app.pages.htmlEditor.templateSavedSuccessfully': 'Template saved successfully.',
  'app.pages.htmlEditor.templateReplacedSuccessfully': 'Template replaced successfully.',
  'app.pages.htmlEditor.templateRenamedSuccessfully': 'Template renamed successfully.',
  'app.pages.htmlEditor.templateDeletedSuccessfully': 'Template deleted successfully.',
  'app.pages.htmlEditor.noTemplatesToManage': 'No templates to manage.',
  'app.pages.htmlEditor.noTemplatesDefined': 'No templates defined.',
  'app.pages.htmlEditor.htmlTemplates': 'HTML Templates',
  'app.pages.htmlEditor.showCodeAssistant': 'Show code assistant',

  // AI Traces
  'app.pages.aiTraces.traces': 'Traces',
  'app.pages.aiTraces.title': 'AI Traces',
  'app.pages.aiTraces.userSessionsTitle': 'AI User Sessions',
  'app.pages.app.sidebarMenu.aiSessions': 'AI Sessions',
  'app.pages.aiTraces.workflow': 'Workflow',
  'app.pages.aiTraces.agent': 'Agent',
  'app.pages.aiTraces.provider': 'Provider',
  'app.pages.aiTraces.tokens': 'Tokens',
  'app.pages.aiTraces.inputTokens': 'Input tokens',
  'app.pages.aiTraces.outputTokens': 'Output tokens',
  'app.pages.aiTraces.totalTokens': 'Total tokens',
  'app.pages.aiTraces.cachedTokens': 'Cached tokens',
  'app.pages.aiTraces.reasoningTokens': 'Reasoning tokens',
  'app.pages.aiTraces.duration': 'Duration',
  'app.pages.aiTraces.environment': 'Environment',
  'app.pages.aiTraces.groupId': 'Session',
  'app.pages.aiTraces.downloadReport': 'Download traces report',
  'app.pages.aiTraces.reportDownloaded': 'Traces report downloaded',
  'app.pages.aiTraces.noTraces': 'No traces found',
  'app.pages.aiTraces.filterProvider': 'Filter by provider',
  'app.pages.aiTraces.filterAgent': 'Filter by agent',
  'app.pages.aiTraces.filterStatus': 'Filter by status',
  'app.pages.aiTraces.dateFrom': 'Date from',
  'app.pages.aiTraces.dateTo': 'Date to',
  'app.pages.aiTraces.allProviders': 'All providers',
  'app.pages.aiTraces.allAgents': 'All agents',
  'app.pages.aiTraces.allStatuses': 'All statuses',
  'app.pages.aiTraces.spanDetail': 'Span detail',
  'app.pages.aiTraces.spanId': 'Span ID',
  'app.pages.aiTraces.startedAt': 'Started at',
  'app.pages.aiTraces.endedAt': 'Ended at',
  'app.pages.aiTraces.noData': 'No data available for this span.',
  'app.pages.aiTraces.spans': 'Spans',
  'app.pages.aiTraces.stopped': 'Stopped',
  'app.pages.aiTraces.stopExecution': 'Stop execution',
  'app.pages.aiTraces.stopExecutionConfirmTitle': 'Stop execution?',
  'app.pages.aiTraces.stopExecutionConfirmContent':
    'The agent will be asked to stop as soon as possible. Pending tool calls may still complete before the run halts. Continue?',
  'app.pages.aiTraces.stopExecutionSuccess': 'Stop request sent. The agent will halt shortly.',
  'app.pages.aiTraces.stopExecutionError': 'Could not stop the agent execution.',
  'app.pages.aiTraces.stopExecutionNotInProgress': 'The execution is no longer in progress.',
  'app.pages.aiTraces.selectSpan': 'Select a span to view its details',
  'app.pages.aiTraces.noSpans': 'No spans available',
  'app.pages.aiTraces.instructions': 'Instructions',
  'app.pages.aiTraces.systemInstructions': 'System instructions',
  'app.pages.aiTraces.configuration': 'Configuration',
  'app.pages.aiTraces.topP': 'Top P',
  'app.pages.aiTraces.reasoningEffort': 'Reasoning effort',
  'app.pages.aiTraces.reasoningSummary': 'Reasoning summary',
  'app.pages.aiTraces.functionCall': 'Function call',
  'app.pages.aiSettings.title': 'AI Settings',
  'app.pages.aiSkills.title': 'Skills and memory',
  'app.pages.mcpUsage.title': 'MCP Usage',
  'app.pages.mcpUsage.client': 'Client',
  'app.pages.mcpUsage.action': 'Action',
  'app.pages.mcpUsage.application': 'Application',
  'app.pages.mcpUsage.result': 'Result',
  'app.pages.mcpUsage.detail': 'Detail',
  'app.pages.mcpUsage.noEvents': 'No MCP activity recorded for these filters',
  'app.pages.mcpUsage.includeInternal': 'Include in-app assistant',
  'app.pages.mcpUsage.includeInternalHint':
    "Pyplan's own assistant uses the same MCP endpoints. It is hidden by default so this page shows external clients only.",
  'app.pages.mcpUsage.outcome.ok': 'OK',
  'app.pages.mcpUsage.outcome.denied': 'Denied',
  'app.pages.mcpUsage.outcome.invalid': 'Invalid',
  'app.pages.mcpUsage.outcome.gone': 'App closed',
  'app.pages.mcpUsage.outcome.unavailable': 'AI off',
  'app.pages.mcpUsage.outcome.error': 'Error',
  'app.pages.mcpUsage.clientType.mcpToken': 'MCP client',
  'app.pages.mcpUsage.clientType.pat': 'Access token',
  'app.pages.mcpUsage.clientType.session': 'Pyplan session',
  'app.pages.mcpUsage.clientType.internal': 'In-app assistant',
  'app.pages.mcpUsage.clientType.unknown': 'Unknown',
  'app.pages.mcpUsage.summary': 'Summary',
  'app.pages.mcpUsage.totalCalls': 'Calls',
  'app.pages.mcpUsage.activeUsers': 'Users',
  'app.pages.mcpUsage.appsTouched': 'Applications',
  'app.pages.mcpUsage.errorRate': 'Error rate',
  'app.pages.mcpUsage.deniedRate': 'Denied',
  'app.pages.mcpUsage.writeRate': 'Writes',
  'app.pages.mcpUsage.errorRateHint': 'Calls that failed inside Pyplan ({count} of {total})',
  'app.pages.mcpUsage.deniedRateHint': 'Calls refused for lack of permission ({count} of {total})',
  'app.pages.mcpUsage.writeRateHint': 'Tool calls that change the application ({count} of {total})',
  'app.pages.mcpUsage.topTools': 'Most used tools',
  'app.pages.mcpUsage.failingTools': 'Tools that fail most',
  'app.pages.mcpUsage.topClients': 'Clients',
  'app.pages.mcpUsage.topUsers': 'Users',
  'app.pages.mcpUsage.topApps': 'Applications',
  'app.pages.mcpUsage.topEndpoints': 'Operations',
  'app.pages.mcpUsage.topSkills': 'Most loaded skills',
  'app.pages.mcpUsage.activity': 'Activity',
  'app.pages.mcpUsage.failedLabel': '{count} failed',
  'app.pages.mcpUsage.noData': 'No data',
  'app.pages.mcpUsage.showSummary': 'Show summary',
  'app.pages.mcpUsage.hideSummary': 'Hide summary',
  'app.pages.mcpUsage.showMoreIndicators': 'More indicators',
  'app.pages.mcpUsage.hideMoreIndicators': 'Fewer indicators',
  'app.pages.aiCosts.title': 'AI Costs',
  'app.pages.aiCosts.periodFrom': 'From',
  'app.pages.aiCosts.periodTo': 'To',
  'app.pages.aiCosts.clearFilters': 'Clear filters',
  'app.pages.aiCosts.exportCsv': 'Export CSV',
  'app.pages.aiCosts.exportCsvTooltip': 'One line per company, month, attribution and model',
  'app.pages.aiCosts.unpricedSuffix': '{tokens} unpriced',
  'app.pages.aiCosts.company': 'Company',
  'app.pages.aiCosts.period': 'Period',
  'app.pages.aiCosts.clientCost': 'Billable to client',
  'app.pages.aiCosts.internalCost': 'Internal',
  'app.pages.aiCosts.totalCost': 'Total',
  'app.pages.aiCosts.totalsAllRows': 'Total — all {count} rows',
  'app.pages.aiCosts.tokens': 'Tokens',
  'app.pages.aiCosts.runs': 'Runs',
  'app.pages.aiCosts.noData': 'No AI consumption recorded for this period.',
  'app.pages.aiCosts.unpricedWarningTitle': 'These amounts are understated',
  'app.pages.aiCosts.unpricedWarningBody':
    'Some models consumed tokens with no rate configured, so they were costed at zero. Load their rates in AI Pricing and the figures will be correct from then on — past consumption stays at zero.',
  'app.pages.aiCosts.unpricedModelLine': '{model} ({provider}): {tokens} tokens — {companies}',
  'app.pages.aiCosts.internalNote':
    'Internal usage comes from the email domains allowlisted in AI Settings. It is not billable and does not count against the company quota.',
  'app.pages.aiCosts.modelBreakdown': 'Breakdown by model',
  'app.pages.aiCosts.model': 'Model',
  'app.pages.aiCosts.attribution': 'Attribution',
  'app.pages.aiCosts.invalidPeriod': 'Use the YYYY-MM format',
  'app.pages.aiSkills.newSkill': 'New skill',
  'app.pages.aiSkills.editSkill': 'Edit skill',
  'app.pages.aiSkills.deleteConfirmMessage': 'Are you sure you want to delete this skill?',
  'app.pages.aiSkills.noSkillsFound': 'No skills found',
  'app.pages.aiSkills.noAppOpenMessage':
    'Open an application to view and manage its skills. Only company-level skills are shown right now.',
  'app.pages.aiSkills.name': 'Name',
  'app.pages.aiSkills.level': 'Level',
  'app.pages.aiSkills.category': 'Category',
  'app.pages.aiSkills.content': 'Content (SKILL.md)',
  'app.pages.aiSkills.levelCompany': 'Company',
  'app.pages.aiSkills.levelApp': 'App',
  'app.pages.aiSkills.nameHelp': 'Letters, numbers, spaces, hyphens, underscores and dots.',
  'app.pages.aiSkills.back': 'Back to skills',
  'app.pages.aiSkills.import': 'Import',
  'app.pages.aiSkills.export': 'Export',
  'app.pages.aiSkills.deleteConfirmTitle': 'Confirm deletion',
  'app.pages.aiSkills.successDeleted': 'Successfully deleted',
  'app.pages.aiSkills.successCreated': 'Successfully created',
  'app.pages.aiSkills.successUpdated': 'Successfully updated',
  'app.pages.aiSkills.fieldRequired': 'Required field',
  'app.pages.aiSkills.tabSkills': 'Skills',
  'app.pages.aiSkills.tabMemory': 'Memory',
  'app.pages.aiSkills.newMemory': 'New memory',
  'app.pages.aiSkills.editMemory': 'Edit memory',
  'app.pages.aiSkills.deleteMemoryConfirmMessage': 'Are you sure you want to delete this memory?',
  'app.pages.aiSkills.noMemoriesFound': 'This application has not learned anything yet',
  'app.pages.aiSkills.memoryText': 'Memory',
  'app.pages.aiSkills.memoryAgent': 'Agent',
  'app.pages.aiSkills.memoryAgentHelp':
    'Only this agent reads it. Each agent keeps its own memory.',
  'app.pages.aiSkills.memoryUpdated': 'Updated',
  'app.pages.aiSkills.memoryStaleHint': 'Untouched for a long time. Check whether it still holds.',
  'app.pages.aiSkills.memoryTextHelp':
    'One piece of guidance about how to work in this app. {count}/{max}',
  'app.pages.aiSkills.memoryTooLong': 'A memory can be at most {max} characters',
  'app.pages.aiSkills.memoryCountForAgent': '{count} of {max} memories of {agent}',
  'app.pages.aiSkills.memoryCountAllAgents':
    '{count, plural, one {# memory} other {# memories}} across {agents, plural, one {# agent} other {# agents}}',
  'app.pages.aiSkills.allAgents': 'All',
  'app.pages.aiSkills.categoryWorkflow': 'Workflow',
  'app.pages.aiSkills.memoryAppliesTo': 'Applies to',
  'app.pages.aiSkills.memoryAppliesToHelp': 'It is only carried into the chat while working there.',
  'app.pages.aiSkills.sectionAll': 'Everywhere',
  'app.pages.aiSkills.sectionCode': 'Diagram and code',
  'app.pages.aiSkills.sectionInterfaces': 'Interfaces',
  'app.pages.aiSkills.memoryOrigin': 'Learned from {source}, in conversation',
  'app.pages.aiSkills.sourceRework': 'having to redo the work',
  'app.pages.aiSkills.sourceCorrection': 'a correction',
  'app.pages.aiSkills.sourceFailure': 'repeated failures',
  'app.pages.aiSkills.sourceUserRequest': 'an explicit request',
  'app.pages.aiSkills.categoryStyle': 'Style',
  'app.pages.aiSkills.categoryPitfall': 'Pitfall',
  'app.pages.aiSkills.noAppOpenMemoryMessage': 'Open an application to view and manage its memory.',
  'app.pages.aiSkills.memoryDisabledMessage':
    'Memory is switched off for this company, so agents neither read nor write it. The memories below are kept and will be used again if it is switched back on.',
  'app.pages.aiSettings.currentCompany': 'Current company',
  'app.pages.aiSettings.agentPreferencesTab': 'Agent preferences',
  'app.pages.aiSettings.appTranslationsTab': 'App translations',
  'app.pages.aiSettings.appTranslationsDefault': 'App translations params',
  'app.pages.aiSettings.appTranslationsSaveSuccess': 'App translations settings saved successfully',
  'app.pages.aiSettings.invalidJson': 'Invalid JSON format',
  'app.pages.aiSettings.saveSuccess': 'AI settings saved successfully',
  'app.pages.aiSettings.availabilityTab': 'Availability',
  'app.pages.aiSettings.availabilityCompanyTitle': 'Current company',
  'app.pages.aiSettings.availabilityGlobalTitle': 'Global default',
  'app.pages.aiSettings.aiEnabled': 'AI features enabled',
  'app.pages.aiSettings.aiEnabledHelp':
    'When disabled, every AI feature is turned off for this company, including the use of MCP.',
  'app.pages.aiSettings.useGlobalLimit': 'Use the global limit ({value})',
  'app.pages.aiSettings.customAgentsEnabled': 'Custom agents enabled',
  'app.pages.aiSettings.customAgentsEnabledHelp':
    'When disabled, the agents defined inside applications cannot be used, by chat or by MCP. The built-in Pyplan agent keeps working.',
  'app.pages.aiSettings.agentsInProcessesEnabled': 'Agents in processes enabled',
  'app.pages.aiSettings.agentsInProcessesEnabledHelp':
    'When disabled, agents cannot be assigned to process tasks and the ones already assigned do not run. The chat is not affected.',
  'app.pages.aiSettings.globalAlwaysEnabledHelp':
    'AI features and custom agents are always enabled globally. Turn them off per company in the panel on the left.',
  'app.pages.aiSettings.monthlyTokenLimit': 'Monthly token limit',
  'app.pages.aiSettings.monthlyTokenLimitHelp':
    '0 means unlimited. A warning is shown from 80% onwards.',
  'app.pages.aiSettings.monthlyTokenLimitInvalid': 'Enter a whole number of 0 or more',
  'app.pages.aiSettings.tokensUsedThisMonth': 'Used this month',
  'app.pages.aiSettings.tokensUnlimited': 'unlimited',
  'app.pages.aiSettings.fullAccessEmailDomains': 'Email domains with full access',
  'app.pages.aiSettings.fullAccessEmailDomainsHelp':
    'Comma-separated domains that bypass the AI switch and the token limit for every company. Role permissions still apply. Global only.',
  'app.pages.aiSettings.availabilitySaveSuccess': 'AI availability saved successfully',
  'app.pages.aiTraces.functionName': 'Function name',
  'app.pages.aiTraces.arguments': 'Arguments',
  'app.pages.aiTraces.functions': 'Functions',
  'app.pages.aiTraces.handoff': 'Handoff',
  'app.pages.aiTraces.fromAgent': 'From agent',
  'app.pages.aiTraces.toAgent': 'To agent',
  'app.pages.aiTraces.guardrail': 'Guardrail',
  'app.pages.aiTraces.triggered': 'Triggered',
  'app.pages.aiTraces.handoffs': 'Handoffs',
  'app.pages.aiTraces.responseId': 'Response ID',
  'app.pages.aiTraces.rawData': 'Raw data',
  'app.pages.aiTraces.tokenSummary': 'Token summary',
  'app.pages.aiTraces.sessionDetails': 'Session details',
  'app.pages.aiTraces.viewSessionDetails': 'View session details',
  'app.pages.aiTraces.sessions': 'Sessions',
  'app.pages.aiTraces.sessionTitle': 'Title',
  'app.pages.aiTraces.sessionId': 'Session ID',
  'app.pages.aiTraces.unknownUser': 'Unknown',
  'app.pages.aiTraces.session': 'Session',
  'app.pages.aiTraces.lastActivity': 'Last activity',
  'app.pages.aiTraces.traceCount': 'Traces',
  'app.pages.aiTraces.sessionCount': 'Sessions',
  'app.pages.aiTraces.cacheRatio': 'Cache',
  'app.pages.aiTraces.agents': 'Agents',
  'app.pages.aiTraces.models': 'Models',
  'app.pages.aiTraces.elapsed': 'Elapsed',
  'app.pages.aiTraces.viewConversation': 'View conversation',
  'app.pages.aiTraces.unpricedWarning':
    '{count, plural, one {# trace} other {# traces}} used a model without a configured price: the cost shown is lower than the real one.',
  'app.pages.aiTraces.retentionNotice':
    'Covers the traces of the last {days} days. For billing, use the AI costs report.',
  'app.pages.aiTraces.noSessions': 'No sessions found',
  'app.pages.aiTraces.noUsers': 'No users found',
  'app.pages.aiTraces.sessionNotFound': 'The session has no traces in the selected period',
  'app.pages.aiTraces.sessionDialogTitle': 'Session conversation',
  'app.pages.aiTraces.noSessionMessages': 'No messages were found for this session.',
  'app.pages.aiTraces.sessionLoadError': 'The session conversation could not be loaded.',
  'app.pages.aiTraces.temperature': 'Temperature',
  'app.pages.aiTraces.appVersion': 'App version',
  'app.pages.aiTraces.costSummary': 'Cost summary',
  'app.pages.aiTraces.inputCost': 'Input cost',
  'app.pages.aiTraces.outputCost': 'Output cost',
  'app.pages.aiTraces.cachedCost': 'Cached cost',
  'app.pages.aiTraces.totalCost': 'Total cost',

  // AI Pricing
  'app.pages.aiProvider.title': 'AI Providers',
  'app.pages.aiModel.title': 'AI Models',
  'app.pages.aiPricing.title': 'AI Pricing',
  'app.pages.aiPricing.providersTab': 'Providers',
  'app.pages.aiPricing.pricingTab': 'Pricing',
  'app.pages.aiPricing.newProvider': 'New provider',
  'app.pages.aiPricing.editProvider': 'Edit provider',
  'app.pages.aiPricing.newModel': 'New model',
  'app.pages.aiPricing.editModel': 'Edit model',
  'app.pages.aiPricing.newTier': 'New pricing tier',
  'app.pages.aiPricing.editTier': 'Edit pricing tier',
  'app.pages.aiPricing.deleteConfirmTitle': 'Confirm deletion',
  'app.pages.aiPricing.deleteConfirmMessage': 'Are you sure you want to delete this item?',
  'app.pages.aiPricing.successCreated': 'Successfully created',
  'app.pages.aiPricing.successUpdated': 'Successfully updated',
  'app.pages.aiPricing.successDeleted': 'Successfully deleted',
  'app.pages.aiPricing.filterByModel': 'Filter by model',
  'app.pages.aiPricing.allModels': 'All models',
  'app.pages.aiPricing.noProvidersFound': 'No providers found',
  'app.pages.aiPricing.noModelsFound': 'No models found',
  'app.pages.aiPricing.noTiersFound': 'No pricing tiers found',
  'app.pages.aiPricing.modelCode': 'Model code',
  'app.pages.aiPricing.tokensMin': 'Tokens min',
  'app.pages.aiPricing.tokensMax': 'Tokens max',
  'app.pages.aiPricing.inputPrice': 'Input price',
  'app.pages.aiPricing.cachePrice': 'Cache price',
  'app.pages.aiPricing.outputPrice': 'Output price',
  'app.pages.aiPricing.pricePerMillionTokens': 'Price per million tokens',
  'app.pages.aiPricing.tokensMaxMustBeGreater': 'Max must be greater than min',
  'app.pages.aiPricing.unlimited': 'Unlimited',
  'app.pages.aiPricing.successChangedStatus': 'Successfully changed model status',

  // nextMcp
  'app.pages.nextMcp.authorizeMcpAccess': 'Authorize MCP access',
  'app.pages.nextMcp.mcpRequestAccess':
    'An MCP client is requesting access to your Pyplan account ({username}).',
  'app.pages.nextMcp.mcpRequestAccessNoUser':
    'An MCP client is requesting access to your Pyplan account.',
  'app.pages.nextMcp.company': 'Company',
  'app.pages.nextMcp.authorize': 'Authorize',
  'app.pages.nextMcp.missingOAuthParams':
    'Missing OAuth parameters. Please restart the flow from your MCP client.',
  'app.pages.nextMcp.noActiveCompanies': 'Your user has no active companies.',
  'app.pages.nextMcp.aiDisabledForCompany':
    'AI features are not enabled for this company, so it cannot be linked to an MCP client. Contact your administrator to enable them.',
  'app.pages.nextMcp.unableToLoadSession': 'Unable to load your Pyplan session. Please try again.',
  'app.pages.nextMcp.noTokenReturned': 'Pyplan API did not return a DRF token',
  'app.pages.nextMcp.unexpectedCallback': 'Unexpected callback response',
  'app.pages.nextMcp.authorizationFailed': 'Authorization failed',

  // Test applications
  'app.pages.testApplications.testApplications': 'Test applications',
  'app.pages.testApplications.applicationPath': 'Application',
  'app.pages.testApplications.version': 'Version',
  'app.pages.testApplications.lastExecutionDate': 'Last execution date',
  'app.pages.testApplications.lastExecutionStatus': 'Last execution status',
  'app.pages.testApplications.enabled': 'Enabled',
  'app.pages.testApplications.actions': 'Actions',
  'app.pages.testApplications.run': 'Run',
  'app.pages.testApplications.addApplication': 'Add application',
  'app.pages.testApplications.editConfiguration': 'Edit configuration',
  'app.pages.testApplications.emailSectionTitle': 'Email notification on completion',
  'app.pages.testApplications.removeApplication': 'Remove application',
  'app.pages.testApplications.viewLogs': 'View logs',
  'app.pages.testApplications.defaultVersion': 'Default version',
  'app.pages.testApplications.selectApplication': 'Select an application',
  'app.pages.testApplications.selectApplicationHelper':
    'Pick an application from the file manager to register it for testing.',
  'app.pages.testApplications.responsibles': 'Responsibles',
  'app.pages.testApplications.sendOnFailureOnly': 'Send emails only on failure',
  'app.pages.testApplications.applicationAdded': 'Application added successfully',
  'app.pages.testApplications.applicationRemoved': 'Application removed successfully',
  'app.pages.testApplications.configurationSaved': 'Configuration saved successfully',
  'app.pages.testApplications.runScheduled': 'Tests scheduled for execution',
  'app.pages.testApplications.areYouSureToRemove':
    'Are you sure you want to remove the following applications: {names}',
  'app.pages.testApplications.noApplicationsRegistered': 'No applications registered for testing',
  'app.pages.testApplications.executionLogs': 'Execution logs',
  'app.experience.newExperience': 'New experience',
  'app.experience.switchedToNext':
    'You are using the new experience. Updated sections show the new design; the rest will follow gradually.',
  'app.experience.switchedToNextWithoutViews':
    'You are using the new experience. The new design will be rolled out to each section gradually.',
  'app.experience.switchError': 'The experience could not be changed. Please try again.',
  'app.pages.home.subtitle': 'Open your applications and pick up where you left off.',
  'app.pages.home.openInstances': 'Open instances',
  'app.pages.home.moreWorkspaces': '{count} more',
  'app.pages.home.searchWorkspaces': 'Search workspaces',
  'app.pages.home.view': 'View',
  'app.pages.home.listView': 'List view',
  'app.pages.home.gridView': 'Grid view',
  'app.pages.home.emptyWorkspace': 'There are no applications in this workspace.',
  'app.pages.home.appOptions': 'Application options',
  'app.pages.home.workspace': 'Workspace'
}

export default messages
